import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeRangeScalar: { input: any; output: any };
  Decimal: { input: any; output: any };
  GenericScalar: { input: any; output: any };
  JSONString: { input: any; output: any };
  NotEmptyID: { input: any; output: any };
  Time: { input: any; output: any };
  Upload: { input: any; output: any };
};

/** An enumeration. */
export enum AcademyCourseResultStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Not Started */
  NOT_STARTED = "NOT_STARTED",
}

export type AcademyMutation = {
  __typename?: "AcademyMutation";
  startCourse?: Maybe<CourseResultCreateMutation>;
};

export type AcademyMutationStartCourseArgs = {
  input: UpdateCourseResultInput;
};

export type AcademyQuery = {
  __typename?: "AcademyQuery";
  courses?: Maybe<CourseNodeConnection>;
};

export type AcademyQueryCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type AcceptJobSuggestionMutation = {
  __typename?: "AcceptJobSuggestionMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type AccessType = {
  __typename?: "AccessType";
  id: Scalars["ID"]["output"];
  slug: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type AccountMutation = {
  __typename?: "AccountMutation";
  admin?: Maybe<AdminMutation>;
  canadaVisa?: Maybe<CanadaVisaMutation>;
  certificateAndLicense?: Maybe<CertificateAndLicenseMutation>;
  education?: Maybe<EducationMutation>;
  employment?: Maybe<EmploymentMutation>;
  googleAuth?: Maybe<GoogleAuth>;
  languageCertificate?: Maybe<LanguageCertificateMutation>;
  linkedinAuth?: Maybe<LinkedInAuth>;
  organization?: Maybe<OrganizationMutation>;
  passwordReset?: Maybe<PasswordReset>;
  performOnboardingJobSuggestion?: Maybe<PerformOnboardingJobSuggestionMutation>;
  profile?: Maybe<ProfileMutation>;
  refreshToken?: Maybe<RefreshToken>;
  register?: Maybe<UserRegister>;
  resendActivationEmail?: Maybe<ResendActivationEmail>;
  revokeToken?: Maybe<RevokeTokenMutation>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmail>;
  supportTicket?: Maybe<SupportTicketMutation>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verify?: Maybe<VerifyAccount>;
  workExperience?: Maybe<WorkExperienceMutation>;
};

export type AccountMutationGoogleAuthArgs = {
  accessToken: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationLinkedinAuthArgs = {
  code: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  redirectUri: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationPasswordResetArgs = {
  gRecaptchaToken: Scalars["String"]["input"];
  newPassword1: Scalars["String"]["input"];
  newPassword2: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type AccountMutationPerformOnboardingJobSuggestionArgs = {
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type AccountMutationRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  jobReferralCode?: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  referralCode?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationResendActivationEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccountMutationSendPasswordResetEmailArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
};

export type AccountMutationTokenAuthArgs = {
  deviceId: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  gRecaptchaToken: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type AccountMutationVerifyArgs = {
  token: Scalars["String"]["input"];
};

export type AdminAssessmentType = {
  __typename?: "AdminAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AdminCanadaVisaType = {
  __typename?: "AdminCanadaVisaType";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type AdminCooperationType = {
  __typename?: "AdminCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<AdminJobPositionNode>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type AdminCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminJobPositionAssignmentNode = {
  __typename?: "AdminJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<AdminJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type AdminJobPositionAssignmentNodeConnection = {
  __typename?: "AdminJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionAssignmentNode` and its cursor. */
export type AdminJobPositionAssignmentNodeEdge = {
  __typename?: "AdminJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionAssignmentNode>;
};

export type AdminJobPositionNode = {
  __typename?: "AdminJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  assignmentsStatusCounts?: Maybe<JobPositionAssignmentStatusCountsType>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type AdminJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AdminJobPositionNodeConnection = {
  __typename?: "AdminJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobPositionNode` and its cursor. */
export type AdminJobPositionNodeEdge = {
  __typename?: "AdminJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobPositionNode>;
};

export type AdminJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type AdminJobPositionStatusUpdateMutation = {
  __typename?: "AdminJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<AdminJobPositionNode>;
};

export type AdminJobSeekerType = {
  __typename?: "AdminJobSeekerType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  canadaVisa?: Maybe<AdminCanadaVisaType>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<ProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type AdminJobSeekerTypeConnection = {
  __typename?: "AdminJobSeekerTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminJobSeekerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminJobSeekerType` and its cursor. */
export type AdminJobSeekerTypeEdge = {
  __typename?: "AdminJobSeekerTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminJobSeekerType>;
};

export type AdminMutation = {
  __typename?: "AdminMutation";
  acceptJobSuggestion?: Maybe<AcceptJobSuggestionMutation>;
  assignJob?: Maybe<AssignJobMutation>;
  hijack?: Maybe<HijackUserMutation>;
  setOrganizationContacts?: Maybe<AdminSetOrganizationContactsMutation>;
  triggerJobSuggestion?: Maybe<TriggerJobSuggestionMutation>;
  unassignJob?: Maybe<UnassignJobMutation>;
  updateJobPositionStatus?: Maybe<AdminJobPositionStatusUpdateMutation>;
  updateOrganization?: Maybe<AdminOrganizationUpdateMutation>;
  updateOrganizationStatus?: Maybe<AdminOrganizationStatusUpdateMutation>;
};

export type AdminMutationAcceptJobSuggestionArgs = {
  suggestionItemId: Scalars["ID"]["input"];
};

export type AdminMutationAssignJobArgs = {
  jobPositionId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type AdminMutationHijackArgs = {
  userId: Scalars["ID"]["input"];
};

export type AdminMutationSetOrganizationContactsArgs = {
  input: Array<InputMaybe<AdminSetOrganizationContactableInput>>;
};

export type AdminMutationTriggerJobSuggestionArgs = {
  jobPositionId: Scalars["ID"]["input"];
};

export type AdminMutationUnassignJobArgs = {
  id: Scalars["ID"]["input"];
};

export type AdminMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminJobPositionStatusUpdateInput;
};

export type AdminMutationUpdateOrganizationArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type AdminMutationUpdateOrganizationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: AdminOrganizationStatusUpdateInput;
};

export type AdminOrganizationEmployeeNode = {
  __typename?: "AdminOrganizationEmployeeNode";
  cooperation?: Maybe<AdminCooperationType>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type AdminOrganizationEmployeeNodeConnection = {
  __typename?: "AdminOrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationEmployeeNode` and its cursor. */
export type AdminOrganizationEmployeeNodeEdge = {
  __typename?: "AdminOrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationEmployeeNode>;
};

export type AdminOrganizationNode = {
  __typename?: "AdminOrganizationNode";
  about?: Maybe<Scalars["String"]["output"]>;
  assessments?: Maybe<Array<Maybe<AdminAssessmentType>>>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  communicateorganizationmethod?: Maybe<CommunicateOrganizationMethodType>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  dnstxtrecordmethod?: Maybe<DnstxtRecordMethodType>;
  email?: Maybe<Scalars["String"]["output"]>;
  employeeCooperationStatusCounts?: Maybe<OrganizationEmployeeCooperationStatusCountsType>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  jobPositionLocationTypeCounts?: Maybe<JobPositionLocationTypeCountsType>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobPositionsStatusCounts?: Maybe<JobPositionStatusCountsType>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  organizationEmployees?: Maybe<AdminOrganizationEmployeeNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
  uploadcompanycertificatemethod?: Maybe<UploadCompanyCertificateMethodType>;
  uploadfiletowebsitemethod?: Maybe<UploadFileToWebsiteMethodType>;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type AdminOrganizationNodeJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminOrganizationNodeOrganizationEmployeesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_Fields_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cooperations_JobPositionAssignment_JobPosition_LocationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AdminOrganizationNodeConnection = {
  __typename?: "AdminOrganizationNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AdminOrganizationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `AdminOrganizationNode` and its cursor. */
export type AdminOrganizationNodeEdge = {
  __typename?: "AdminOrganizationNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<AdminOrganizationNode>;
};

export type AdminOrganizationStatisticsType = {
  __typename?: "AdminOrganizationStatisticsType";
  blockedCount?: Maybe<Scalars["Int"]["output"]>;
  completedCount?: Maybe<Scalars["Int"]["output"]>;
  draftedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
  submittedCount?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
  verifiedCount?: Maybe<Scalars["Int"]["output"]>;
  withJobPositionsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AdminOrganizationStatusUpdateInput = {
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
};

export type AdminOrganizationStatusUpdateMutation = {
  __typename?: "AdminOrganizationStatusUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type AdminOrganizationUpdateMutation = {
  __typename?: "AdminOrganizationUpdateMutation";
  organization?: Maybe<AdminOrganizationNode>;
};

export type AdminQuery = {
  __typename?: "AdminQuery";
  jobPositionAssignments?: Maybe<AdminJobPositionAssignmentNodeConnection>;
  jobPositions?: Maybe<AdminJobPositionNodeConnection>;
  jobSeekers?: Maybe<AdminJobSeekerTypeConnection>;
  jobSuggestionResult?: Maybe<JobSuggestionResultNodeConnection>;
  organizationStatistics?: Maybe<AdminOrganizationStatisticsType>;
  organizations?: Maybe<AdminOrganizationNodeConnection>;
};

export type AdminQueryJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type AdminQueryJobPositionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationJobPositionOrderByChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  organization_Name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminQueryJobSeekersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  canadaVisa_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountCanadaVisaStatusChoices>>>;
  educations_Degree_In?: InputMaybe<Array<InputMaybe<AuthAccountEducationDegreeChoices>>>;
  email_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountUserFluentLanguagesChoices>>>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Decimal"]["input"]>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountUserJobTypeChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountUserOrderByChoices>;
  profile_BirthDate_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_BirthDate_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  profile_City_Country_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_City_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_Contactable_Contacts_Value_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  profile_EmploymentStatus_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileEmploymentStatusChoices>>>;
  profile_Gender_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileGenderChoices>>>;
  profile_Industry_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_InterestedJobs_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  profile_NativeLanguage_In?: InputMaybe<Array<InputMaybe<AuthAccountProfileNativeLanguageChoices>>>;
  profile_Skills_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  referredJobPositions_Id_In?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  workexperiences_Grade_In?: InputMaybe<Array<InputMaybe<AuthAccountWorkExperienceGradeChoices>>>;
};

export type AdminQueryJobSuggestionResultArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  jobPosition_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Organization_Id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobSuggestionResultOrderByChoices>;
};

export type AdminQueryOrganizationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  establishedAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  hasJobPositionFrom?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountOrganizationOrderByChoices>;
  organizationEmployeeId?: InputMaybe<Scalars["String"]["input"]>;
  organizationJobPositionId?: InputMaybe<Scalars["String"]["input"]>;
  organizationPhone?: InputMaybe<Scalars["String"]["input"]>;
  shortName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  size_Gte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  size_Lte?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  status?: InputMaybe<AuthAccountOrganizationStatusChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
  user_Email?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdminSetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type AdminSetOrganizationContactsMutation = {
  __typename?: "AdminSetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type AssessmentMutation = {
  __typename?: "AssessmentMutation";
  generateAssessmentToken?: Maybe<GenerateAssessmentTokenMutation>;
};

export type AssessmentMutationGenerateAssessmentTokenArgs = {
  assessmentId: Scalars["String"]["input"];
};

export type AssessmentResultQuestionType = {
  __typename?: "AssessmentResultQuestionType";
  text: Scalars["String"]["output"];
};

export type AssessmentSkillType = {
  __typename?: "AssessmentSkillType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type AssessmentType = {
  __typename?: "AssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<JobSeekerAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type AssignJobMutation = {
  __typename?: "AssignJobMutation";
  created?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

/** An enumeration. */
export enum AttachmentType {
  /** Platform Message Attachment Course */
  COURSE = "COURSE",
  /** Platform Message Attachment Course Result */
  COURSE_RESULT = "COURSE_RESULT",
  /** Platform Message Attachment File */
  FILE = "FILE",
}

/** An enumeration. */
export enum AuthAccountCanadaVisaStatusChoices {
  /** Citizenship */
  CITIZENSHIP = "CITIZENSHIP",
  /** Electronic Travel Authorization (eTA) */
  ELECTRONIC_TRAVEL_AUTHORIZATION = "ELECTRONIC_TRAVEL_AUTHORIZATION",
  /** International Experience Canada (IEC) */
  INTERNATIONAL_EXPERIENCE_CANADA = "INTERNATIONAL_EXPERIENCE_CANADA",
  /** No Visa */
  NO_VISA = "NO_VISA",
  /** Permanent Resident (PR) */
  PERMANENT_RESIDENT = "PERMANENT_RESIDENT",
  /** Refugee (Work Permit) */
  REFUGEE_WORK_PERMIT = "REFUGEE_WORK_PERMIT",
  /** Seasonal Agricultural Worker Program (SAWP) */
  SEASONAL_AGRICULTURAL_WORKER_PROGRAM = "SEASONAL_AGRICULTURAL_WORKER_PROGRAM",
  /** Temporary Resident (Close Work Permit) */
  TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT = "TEMPORARY_RESIDENT_CLOSE_WORK_PERMIT",
  /** Temporary Resident (Open Work Permit) */
  TEMPORARY_RESIDENT_OPEN_WORK_PERMIT = "TEMPORARY_RESIDENT_OPEN_WORK_PERMIT",
  /** Temporary Resident (Study Permit) */
  TEMPORARY_RESIDENT_STUDY_PERMIT = "TEMPORARY_RESIDENT_STUDY_PERMIT",
  /** Visitor Visa */
  VISITOR_VISA = "VISITOR_VISA",
}

/** An enumeration. */
export enum AuthAccountCertificateAndLicenseStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountContactTypeChoices {
  /** Address */
  ADDRESS = "ADDRESS",
  /** LinkedIn */
  LINKEDIN = "LINKEDIN",
  /** Phone */
  PHONE = "PHONE",
  /** Website */
  WEBSITE = "WEBSITE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountEducationDegreeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountEducationStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobPositionAssignmentStatusHistoryStatusChoices {
  /** Accepted */
  ACCEPTED = "ACCEPTED",
  /** Awaiting Interview Date */
  AWAITING_INTERVIEW_DATE = "AWAITING_INTERVIEW_DATE",
  /** Awaiting Jobseeker Approval */
  AWAITING_JOBSEEKER_APPROVAL = "AWAITING_JOBSEEKER_APPROVAL",
  /** Interview Canceled */
  INTERVIEW_CANCELED = "INTERVIEW_CANCELED",
  /** Interview Done */
  INTERVIEW_DONE = "INTERVIEW_DONE",
  /** Interview Scheduled */
  INTERVIEW_SCHEDULED = "INTERVIEW_SCHEDULED",
  /** Not Reviewed */
  NOT_REVIEWED = "NOT_REVIEWED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Rejected By Jobseeker */
  REJECTED_BY_JOBSEEKER = "REJECTED_BY_JOBSEEKER",
}

/** An enumeration. */
export enum AuthAccountJobSuggestionResultOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountLanguageCertificateStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationBusinessTypeChoices {
  /** Product */
  PRODUCT = "PRODUCT",
  /** Service */
  SERVICE = "SERVICE",
  /** Software */
  SOFTWARE = "SOFTWARE",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeeCooperationStatusChoices {
  /** Active */
  ACTIVE = "ACTIVE",
  /** Awaiting */
  AWAITING = "AWAITING",
  /** Finished */
  FINISHED = "FINISHED",
  /** Fired */
  FIRED = "FIRED",
  /** Resigned */
  RESIGNED = "RESIGNED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Completed By Job Seeker */
  COMPLETED_BY_JOB_SEEKER = "COMPLETED_BY_JOB_SEEKER",
  /** Completed By Organization */
  COMPLETED_BY_ORGANIZATION = "COMPLETED_BY_ORGANIZATION",
  /** Created */
  CREATED = "CREATED",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionContractTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDaysOffChoices {
  /** Friday */
  FRIDAY = "FRIDAY",
  /** Monday */
  MONDAY = "MONDAY",
  /** Saturday */
  SATURDAY = "SATURDAY",
  /** Sunday */
  SUNDAY = "SUNDAY",
  /** Thursday */
  THURSDAY = "THURSDAY",
  /** Tuesday */
  TUESDAY = "TUESDAY",
  /** Wednesday */
  WEDNESDAY = "WEDNESDAY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionDegreesChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** Bachelors */
  BACHELORS = "BACHELORS",
  /** Certificate */
  CERTIFICATE = "CERTIFICATE",
  /** Diploma */
  DIPLOMA = "DIPLOMA",
  /** Masters */
  MASTERS = "MASTERS",
  /** PhD */
  PHD = "PHD",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionLocationTypeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionNativeLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionPaymentTermChoices {
  /** Bi-Weekly */
  BI_WEEKLY = "BI_WEEKLY",
  /** Daily */
  DAILY = "DAILY",
  /** Hourly */
  HOURLY = "HOURLY",
  /** Monthly */
  MONTHLY = "MONTHLY",
  /** Weekly */
  WEEKLY = "WEEKLY",
  /** Yearly */
  YEARLY = "YEARLY",
}

/** An enumeration. */
export enum AuthAccountOrganizationJobPositionStatusChoices {
  /** Capacity Filled */
  CAPACITY_FILLED = "CAPACITY_FILLED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Expired */
  EXPIRED = "EXPIRED",
  /** Published */
  PUBLISHED = "PUBLISHED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Suspended */
  SUSPENDED = "SUSPENDED",
}

/** An enumeration. */
export enum AuthAccountOrganizationOrderByChoices {
  /** Created at */
  CREATED_AT = "CREATED_AT",
  /** Created at (descending) */
  _CREATED_AT = "_CREATED_AT",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageAssigneeTypeChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountOrganizationPlatformMessageSourceChoices {
  /** AI */
  AI = "AI",
  /** Human */
  HUMAN = "HUMAN",
}

/** An enumeration. */
export enum AuthAccountOrganizationSizeChoices {
  /** Over 1000 */
  OVER_1000 = "OVER_1000",
  /** 1-10 */
  _1_10 = "_1_10",
  /** 10-50 */
  _10_50 = "_10_50",
  /** 50-100 */
  _50_100 = "_50_100",
  /** 100-500 */
  _100_500 = "_100_500",
  /** 500-1000 */
  _500_1000 = "_500_1000",
}

/** An enumeration. */
export enum AuthAccountOrganizationStatusChoices {
  /** Blocked */
  BLOCKED = "BLOCKED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

/** An enumeration. */
export enum AuthAccountOrganizationTypeChoices {
  /** Branch Office */
  BRANCH_OFFICE = "BRANCH_OFFICE",
  /** Cooperative */
  COOPERATIVE = "COOPERATIVE",
  /** General Partnership */
  GENERAL_PARTNERSHIP = "GENERAL_PARTNERSHIP",
  /** Limited Partnership */
  LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP",
  /** Non-Profit Organization */
  NON_PROFIT_ORGANIZATION = "NON_PROFIT_ORGANIZATION",
  /** Private Corporation */
  PRIVATE_CORPORATION = "PRIVATE_CORPORATION",
  /** Public Corporation */
  PUBLIC_CORPORATION = "PUBLIC_CORPORATION",
  /** Sole Proprietorship */
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  /** Subsidiary */
  SUBSIDIARY = "SUBSIDIARY",
}

/** An enumeration. */
export enum AuthAccountProfileEmploymentStatusChoices {
  /** Employed */
  EMPLOYED = "EMPLOYED",
  /** Unemployed */
  UNEMPLOYED = "UNEMPLOYED",
}

/** An enumeration. */
export enum AuthAccountProfileEyeColorChoices {
  /** Green */
  _1CAC78 = "_1CAC78",
  /** Blue */
  _5DADEC = "_5DADEC",
  /** Brown */
  _6B4226 = "_6B4226",
  /** Hazel */
  _8E7618 = "_8E7618",
  /** Gray */
  _BEBEBE = "_BEBEBE",
  /** Amber */
  _FFBF00 = "_FFBF00",
}

/** An enumeration. */
export enum AuthAccountProfileFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileGenderChoices {
  /** Female */
  FEMALE = "FEMALE",
  /** Male */
  MALE = "MALE",
  /** Not Applicable */
  NOT_APPLICABLE = "NOT_APPLICABLE",
  /** Not Known */
  NOT_KNOWN = "NOT_KNOWN",
}

/** An enumeration. */
export enum AuthAccountProfileJobLocationTypeExcludeChoices {
  /** Global */
  GLOBAL = "GLOBAL",
  /** Hybrid */
  HYBRID = "HYBRID",
  /** On-site (Within a Limited Area) */
  LIMITED_AREA = "LIMITED_AREA",
  /** On the road */
  ON_THE_ROAD = "ON_THE_ROAD",
  /** On-site (Precise Location) */
  PRECISE_LOCATION = "PRECISE_LOCATION",
  /** Remote */
  REMOTE = "REMOTE",
}

/** An enumeration. */
export enum AuthAccountProfileJobTypeExcludeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountProfileNativeLanguageChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountProfileSkinColorChoices {
  /** Very Dark */
  _3B260B = "_3B260B",
  /** Brown */
  _8D5524 = "_8D5524",
  /** Deep */
  _100C08 = "_100C08",
  /** Dark Brown */
  _60391C = "_60391C",
  /** Olive */
  _A86B33 = "_A86B33",
  /** Medium */
  _C68642 = "_C68642",
  /** Light Medium */
  _D9A377 = "_D9A377",
  /** Light */
  _E5B897 = "_E5B897",
  /** Fair */
  _F0D5B1 = "_F0D5B1",
  /** Very Fair */
  _FFDFC4 = "_FFDFC4",
}

/** An enumeration. */
export enum AuthAccountSupportTicketCategoryTypesChoices {
  /** Job Seeker */
  JOB_SEEKER = "JOB_SEEKER",
  /** Organization */
  ORGANIZATION = "ORGANIZATION",
}

/** An enumeration. */
export enum AuthAccountSupportTicketContactMethodChoices {
  /** Email */
  EMAIL = "EMAIL",
  /** Phone */
  PHONE = "PHONE",
  /** WhatsApp */
  WHATSAPP = "WHATSAPP",
}

/** An enumeration. */
export enum AuthAccountSupportTicketPriorityChoices {
  /** High */
  HIGH = "HIGH",
  /** Low */
  LOW = "LOW",
  /** Medium */
  MEDIUM = "MEDIUM",
  /** Urgent */
  URGENT = "URGENT",
}

/** An enumeration. */
export enum AuthAccountSupportTicketStatusChoices {
  /** Closed */
  CLOSED = "CLOSED",
  /** Open */
  OPEN = "OPEN",
}

/** An enumeration. */
export enum AuthAccountUserFluentLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

/** An enumeration. */
export enum AuthAccountUserJobTypeChoices {
  /** Apprenticeship */
  APPRENTICESHIP = "APPRENTICESHIP",
  /** Fix Term Contract */
  FIX_TERM_CONTRACT = "FIX_TERM_CONTRACT",
  /** Freelance */
  FREELANCE = "FREELANCE",
  /** Full Time */
  FULL_TIME = "FULL_TIME",
  /** Internship/Co-op */
  INTERNSHIP_CO_OP = "INTERNSHIP_CO_OP",
  /** Part Time */
  PART_TIME = "PART_TIME",
  /** Permanent */
  PERMANENT = "PERMANENT",
  /** Prince Edward Island */
  PRINCE_EDWARD_ISLAND = "PRINCE_EDWARD_ISLAND",
  /** Seasonal */
  SEASONAL = "SEASONAL",
}

/** An enumeration. */
export enum AuthAccountUserOrderByChoices {
  /** Id */
  ID = "ID",
  /** Id (descending) */
  _ID = "_ID",
}

/** An enumeration. */
export enum AuthAccountUserTaskStatusChoices {
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Failed */
  FAILED = "FAILED",
  /** In Progress */
  IN_PROGRESS = "IN_PROGRESS",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Timed-Out */
  TIMEDOUT = "TIMEDOUT",
}

/** An enumeration. */
export enum AuthAccountUserTaskTaskNameChoices {
  /** admin_perform_job_suggestion */
  ADMIN_PERFORM_JOB_SUGGESTION = "ADMIN_PERFORM_JOB_SUGGESTION",
  /** clean_revoked_tokens */
  CLEAN_REVOKED_TOKENS = "CLEAN_REVOKED_TOKENS",
  /** clean_unverified_expired_users */
  CLEAN_UNVERIFIED_EXPIRED_USERS = "CLEAN_UNVERIFIED_EXPIRED_USERS",
  /** extract_job_position_from_file_task */
  EXTRACT_JOB_POSITION_FROM_FILE_TASK = "EXTRACT_JOB_POSITION_FROM_FILE_TASK",
  /** get_certificate_text */
  GET_CERTIFICATE_TEXT = "GET_CERTIFICATE_TEXT",
  /** perform_job_suggestion */
  PERFORM_JOB_SUGGESTION = "PERFORM_JOB_SUGGESTION",
  /** render_cv_template */
  RENDER_CV_TEMPLATE = "RENDER_CV_TEMPLATE",
  /** self_verify_documents */
  SELF_VERIFY_DOCUMENTS = "SELF_VERIFY_DOCUMENTS",
  /** send_campaign_notifications */
  SEND_CAMPAIGN_NOTIFICATIONS = "SEND_CAMPAIGN_NOTIFICATIONS",
  /** send_email_async */
  SEND_EMAIL_ASYNC = "SEND_EMAIL_ASYNC",
  /** send_email_async_non_existing_user */
  SEND_EMAIL_ASYNC_NON_EXISTING_USER = "SEND_EMAIL_ASYNC_NON_EXISTING_USER",
  /** set_expiry */
  SET_EXPIRY = "SET_EXPIRY",
  /** set_job_position_cooperation_status */
  SET_JOB_POSITION_COOPERATION_STATUS = "SET_JOB_POSITION_COOPERATION_STATUS",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceGradeChoices {
  /** Associate */
  ASSOCIATE = "ASSOCIATE",
  /** CEO */
  CEO = "CEO",
  /** CFO */
  CFO = "CFO",
  /** CTO */
  CTO = "CTO",
  /** Director */
  DIRECTOR = "DIRECTOR",
  /** Intern */
  INTERN = "INTERN",
  /** Junior */
  JUNIOR = "JUNIOR",
  /** Manager */
  MANAGER = "MANAGER",
  /** Mid-Level */
  MID_LEVEL = "MID_LEVEL",
  /** Senior */
  SENIOR = "SENIOR",
}

/** An enumeration. */
export enum AuthAccountWorkExperienceStatusChoices {
  /** Drafted */
  DRAFTED = "DRAFTED",
  /** Rejected */
  REJECTED = "REJECTED",
  /** Self Verified */
  SELF_VERIFIED = "SELF_VERIFIED",
  /** Submitted */
  SUBMITTED = "SUBMITTED",
  /** Verified */
  VERIFIED = "VERIFIED",
}

export type AvatarFileType = {
  __typename?: "AvatarFileType";
  file: Scalars["String"]["output"];
};

export type BaseFileModelType = {
  __typename?: "BaseFileModelType";
  file: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type BatchCreateContactInput = {
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type CvMutation = {
  __typename?: "CVMutation";
  generateResume?: Maybe<GenerateResumeMutation>;
};

export type CvMutationGenerateResumeArgs = {
  templateId?: InputMaybe<Scalars["NotEmptyID"]["input"]>;
};

export type CvQuery = {
  __typename?: "CVQuery";
  templates?: Maybe<CvTemplateNodeConnection>;
};

export type CvQueryTemplatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CvTemplateNode = {
  __typename?: "CVTemplateNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type CvTemplateNodeConnection = {
  __typename?: "CVTemplateNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CvTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CVTemplateNode` and its cursor. */
export type CvTemplateNodeEdge = {
  __typename?: "CVTemplateNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CvTemplateNode>;
};

export type CalendarEventAttendeeType = {
  __typename?: "CalendarEventAttendeeType";
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum CalendarEventObjectType {
  job_position_interview = "job_position_interview",
}

export type CalendarEventRelatedObjectType = {
  __typename?: "CalendarEventRelatedObjectType";
  key?: Maybe<CalendarEventObjectType>;
  pk?: Maybe<Scalars["ID"]["output"]>;
};

export type CalendarEventStatusUpdateMutation = {
  __typename?: "CalendarEventStatusUpdateMutation";
  calendarEvent?: Maybe<CalendarEventType>;
};

export type CalendarEventType = {
  __typename?: "CalendarEventType";
  attendees?: Maybe<Array<Maybe<CalendarEventAttendeeType>>>;
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  meetUrl?: Maybe<Scalars["String"]["output"]>;
  relatedObject?: Maybe<CalendarEventRelatedObjectType>;
  status: FlexCalendarCalendarEventStatusChoices;
};

export type CalendarQuery = {
  __typename?: "CalendarQuery";
  calendars?: Maybe<Array<Maybe<CalendarType>>>;
};

export type CalendarType = {
  __typename?: "CalendarType";
  events: Array<CalendarEventType>;
  id: Scalars["ID"]["output"];
};

export type CanadaVisaCreateOrUpdateMutation = {
  __typename?: "CanadaVisaCreateOrUpdateMutation";
  canadaVisa?: Maybe<CanadaVisaNode>;
};

export type CanadaVisaMutation = {
  __typename?: "CanadaVisaMutation";
  createOrUpdate?: Maybe<CanadaVisaCreateOrUpdateMutation>;
};

export type CanadaVisaMutationCreateOrUpdateArgs = {
  input: UpdateCanadaVisaInput;
};

export type CanadaVisaNode = {
  __typename?: "CanadaVisaNode";
  citizenshipDocument?: Maybe<CitizenshipDocumentFileType>;
  id: Scalars["ID"]["output"];
  nationality?: Maybe<CountryNode>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type CertificateAndLicenseAiType = {
  __typename?: "CertificateAndLicenseAIType";
  certifier?: Maybe<Scalars["String"]["output"]>;
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseAnalyseAndExtractDataMutation = {
  __typename?: "CertificateAndLicenseAnalyseAndExtractDataMutation";
  data?: Maybe<CertificateAndLicenseAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type CertificateAndLicenseCreateMutation = {
  __typename?: "CertificateAndLicenseCreateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseMutation = {
  __typename?: "CertificateAndLicenseMutation";
  analyseAndExtractData?: Maybe<CertificateAndLicenseAnalyseAndExtractDataMutation>;
  create?: Maybe<CertificateAndLicenseCreateMutation>;
  update?: Maybe<CertificateAndLicenseUpdateMutation>;
};

export type CertificateAndLicenseMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseMutationCreateArgs = {
  input: CreateCertificateAndLicenseAndSetVerificationMethodInput;
};

export type CertificateAndLicenseMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchCertificateAndLicenseInput;
};

export type CertificateAndLicenseNode = {
  __typename?: "CertificateAndLicenseNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type CertificateAndLicenseOfflineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
  certificateFile: CertificateFileType;
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseOnlineVerificationMethodType = {
  __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type CertificateAndLicenseQuery = {
  __typename?: "CertificateAndLicenseQuery";
  get?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateAndLicenseQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type CertificateAndLicenseUpdateMutation = {
  __typename?: "CertificateAndLicenseUpdateMutation";
  certificateAndLicense?: Maybe<CertificateAndLicenseNode>;
};

export type CertificateFileType = {
  __typename?: "CertificateFileType";
  file: Scalars["String"]["output"];
};

/** An enumeration. */
export enum CitiesLightCountryContinentChoices {
  /** Africa */
  AF = "AF",
  /** Antarctica */
  AN = "AN",
  /** Asia */
  AS = "AS",
  /** Europe */
  EU = "EU",
  /** North America */
  NA = "NA",
  /** Oceania */
  OC = "OC",
  /** South America */
  SA = "SA",
}

export type CitizenshipDocumentFileType = {
  __typename?: "CitizenshipDocumentFileType";
  file: Scalars["String"]["output"];
};

export type CityNode = {
  __typename?: "CityNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  featureCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  latitude?: Maybe<Scalars["Decimal"]["output"]>;
  longitude?: Maybe<Scalars["Decimal"]["output"]>;
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  population?: Maybe<Scalars["BigInt"]["output"]>;
  region?: Maybe<RegionNode>;
  searchNames: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  subregion?: Maybe<SubRegionNode>;
  timezone?: Maybe<Scalars["String"]["output"]>;
};

export type CityNodeConnection = {
  __typename?: "CityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename?: "CityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CityNode>;
};

/** An enumeration. */
export enum CommonIndustryOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

/** An enumeration. */
export enum CommonLanguageProficiencyTestLanguagesChoices {
  /** Afrikaans */
  AF = "AF",
  /** Arabic */
  AR = "AR",
  /** Algerian Arabic */
  AR_DZ = "AR_DZ",
  /** Asturian */
  AST = "AST",
  /** Azerbaijani */
  AZ = "AZ",
  /** Belarusian */
  BE = "BE",
  /** Bulgarian */
  BG = "BG",
  /** Bengali */
  BN = "BN",
  /** Breton */
  BR = "BR",
  /** Bosnian */
  BS = "BS",
  /** Catalan */
  CA = "CA",
  /** Central Kurdish (Sorani) */
  CKB = "CKB",
  /** Czech */
  CS = "CS",
  /** Welsh */
  CY = "CY",
  /** Danish */
  DA = "DA",
  /** German */
  DE = "DE",
  /** Lower Sorbian */
  DSB = "DSB",
  /** Greek */
  EL = "EL",
  /** English */
  EN = "EN",
  /** Australian English */
  EN_AU = "EN_AU",
  /** British English */
  EN_GB = "EN_GB",
  /** Esperanto */
  EO = "EO",
  /** Spanish */
  ES = "ES",
  /** Argentinian Spanish */
  ES_AR = "ES_AR",
  /** Colombian Spanish */
  ES_CO = "ES_CO",
  /** Mexican Spanish */
  ES_MX = "ES_MX",
  /** Nicaraguan Spanish */
  ES_NI = "ES_NI",
  /** Venezuelan Spanish */
  ES_VE = "ES_VE",
  /** Estonian */
  ET = "ET",
  /** Basque */
  EU = "EU",
  /** Persian */
  FA = "FA",
  /** Finnish */
  FI = "FI",
  /** French */
  FR = "FR",
  /** Frisian */
  FY = "FY",
  /** Irish */
  GA = "GA",
  /** Scottish Gaelic */
  GD = "GD",
  /** Galician */
  GL = "GL",
  /** Hebrew */
  HE = "HE",
  /** Hindi */
  HI = "HI",
  /** Croatian */
  HR = "HR",
  /** Upper Sorbian */
  HSB = "HSB",
  /** Hungarian */
  HU = "HU",
  /** Armenian */
  HY = "HY",
  /** Interlingua */
  IA = "IA",
  /** Indonesian */
  ID = "ID",
  /** Igbo */
  IG = "IG",
  /** Ido */
  IO = "IO",
  /** Icelandic */
  IS = "IS",
  /** Italian */
  IT = "IT",
  /** Japanese */
  JA = "JA",
  /** Georgian */
  KA = "KA",
  /** Kabyle */
  KAB = "KAB",
  /** Kazakh */
  KK = "KK",
  /** Khmer */
  KM = "KM",
  /** Kannada */
  KN = "KN",
  /** Korean */
  KO = "KO",
  /** Kyrgyz */
  KY = "KY",
  /** Luxembourgish */
  LB = "LB",
  /** Lithuanian */
  LT = "LT",
  /** Latvian */
  LV = "LV",
  /** Macedonian */
  MK = "MK",
  /** Malayalam */
  ML = "ML",
  /** Mongolian */
  MN = "MN",
  /** Marathi */
  MR = "MR",
  /** Malay */
  MS = "MS",
  /** Burmese */
  MY = "MY",
  /** Norwegian Bokmål */
  NB = "NB",
  /** Nepali */
  NE = "NE",
  /** Dutch */
  NL = "NL",
  /** Norwegian Nynorsk */
  NN = "NN",
  /** Ossetic */
  OS = "OS",
  /** Punjabi */
  PA = "PA",
  /** Polish */
  PL = "PL",
  /** Portuguese */
  PT = "PT",
  /** Brazilian Portuguese */
  PT_BR = "PT_BR",
  /** Romanian */
  RO = "RO",
  /** Russian */
  RU = "RU",
  /** Slovak */
  SK = "SK",
  /** Slovenian */
  SL = "SL",
  /** Albanian */
  SQ = "SQ",
  /** Serbian */
  SR = "SR",
  /** Serbian Latin */
  SR_LATN = "SR_LATN",
  /** Swedish */
  SV = "SV",
  /** Swahili */
  SW = "SW",
  /** Tamil */
  TA = "TA",
  /** Telugu */
  TE = "TE",
  /** Tajik */
  TG = "TG",
  /** Thai */
  TH = "TH",
  /** Turkmen */
  TK = "TK",
  /** Turkish */
  TR = "TR",
  /** Tatar */
  TT = "TT",
  /** Udmurt */
  UDM = "UDM",
  /** Uyghur */
  UG = "UG",
  /** Ukrainian */
  UK = "UK",
  /** Urdu */
  UR = "UR",
  /** Uzbek */
  UZ = "UZ",
  /** Vietnamese */
  VI = "VI",
  /** Simplified Chinese */
  ZH_HANS = "ZH_HANS",
  /** Traditional Chinese */
  ZH_HANT = "ZH_HANT",
}

export type CommonMutation = {
  __typename?: "CommonMutation";
  uploadFile?: Maybe<UploadFileMutation>;
};

export type CommonMutationUploadFileArgs = {
  file: Scalars["Upload"]["input"];
  type: UploadType;
};

export type CommonQuery = {
  __typename?: "CommonQuery";
  cities?: Maybe<CityNodeConnection>;
  countries?: Maybe<CountryNodeConnection>;
  fields?: Maybe<FieldNodeConnection>;
  industries?: Maybe<IndustryNodeConnection>;
  jobBenefits?: Maybe<JobBenefitNodeConnection>;
  jobs?: Maybe<JobNodeConnection>;
  languagesProficiencyTests?: Maybe<LanguageProficiencyTestNodeConnection>;
  regions?: Maybe<RegionNodeConnection>;
  skills?: Maybe<SkillNodeConnection>;
  universities?: Maybe<UniversityNodeConnection>;
};

export type CommonQueryCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CommonQueryCountriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryFieldsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryJobBenefitsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQueryJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryLanguagesProficiencyTestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  languages_Contains?: InputMaybe<Array<InputMaybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryRegionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommonQuerySkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonSkillOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommonQueryUniversitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An enumeration. */
export enum CommonSkillOrderByChoices {
  /** Order */
  ORDER = "ORDER",
  /** Order (descending) */
  _ORDER = "_ORDER",
}

export type CommunicateOrganizationMethodInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  phonenumber: Scalars["String"]["input"];
};

export type CommunicateOrganizationMethodType = {
  __typename?: "CommunicateOrganizationMethodType";
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  phonenumber: Scalars["String"]["output"];
};

export type CommunicationMethodAiType = {
  __typename?: "CommunicationMethodAIType";
  department?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  person?: Maybe<Scalars["String"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationMethodType = {
  __typename?: "CommunicationMethodType";
  degreeFile: DegreeFileType;
  department: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  person: Scalars["String"]["output"];
  website: Scalars["String"]["output"];
};

export type ContactType = {
  __typename?: "ContactType";
  id: Scalars["ID"]["output"];
  type: AuthAccountContactTypeChoices;
  value: Scalars["String"]["output"];
};

export type CountryNode = {
  __typename?: "CountryNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  code2?: Maybe<Scalars["String"]["output"]>;
  code3?: Maybe<Scalars["String"]["output"]>;
  continent: CitiesLightCountryContinentChoices;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  phone?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  tld: Scalars["String"]["output"];
};

export type CountryNodeConnection = {
  __typename?: "CountryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CountryNode` and its cursor. */
export type CountryNodeEdge = {
  __typename?: "CountryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CountryNode>;
};

export type CourseNode = {
  __typename?: "CourseNode";
  description: Scalars["String"]["output"];
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  isGeneral?: Maybe<Scalars["Boolean"]["output"]>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  results: CourseResultTypeConnection;
};

export type CourseNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type CourseNodeResultsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type CourseNodeConnection = {
  __typename?: "CourseNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseNode` and its cursor. */
export type CourseNodeEdge = {
  __typename?: "CourseNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseNode>;
};

export type CourseResultCreateMutation = {
  __typename?: "CourseResultCreateMutation";
  courseResult?: Maybe<CourseResultType>;
  startUrl: Scalars["String"]["output"];
};

export type CourseResultType = {
  __typename?: "CourseResultType";
  course: CourseNode;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  status: AcademyCourseResultStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
  user: UserNode;
};

export type CourseResultTypeConnection = {
  __typename?: "CourseResultTypeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseResultTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `CourseResultType` and its cursor. */
export type CourseResultTypeEdge = {
  __typename?: "CourseResultTypeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<CourseResultType>;
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certificateandlicenseofflineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod>;
  certificateandlicenseonlineverificationmethod?: InputMaybe<CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod>;
  certifier: Scalars["String"]["input"];
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  title: Scalars["String"]["input"];
};

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseofflineverificationmethod =
  {
    certificateFile: Scalars["ID"]["input"];
  };

export type CreateCertificateAndLicenseAndSetVerificationMethodInputCreateCertificateandlicenseonlineverificationmethod =
  {
    certificateLink: Scalars["String"]["input"];
  };

export type CreateEducationAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  communicationmethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod>;
  degree: AuthAccountEducationDegreeChoices;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field: Scalars["ID"]["input"];
  ieemethod?: InputMaybe<CreateEducationAndSetVerificationMethodInputCreateIeemethod>;
  start: Scalars["Date"]["input"];
  university: Scalars["ID"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateCommunicationmethod = {
  degreeFile: Scalars["ID"]["input"];
  department: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  person: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type CreateEducationAndSetVerificationMethodInputCreateIeemethod = {
  educationEvaluationDocument: Scalars["ID"]["input"];
  evaluator?: InputMaybe<IeeMethodEvaluator>;
};

export type CreateLanguageCertificateAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt: Scalars["Date"]["input"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod>;
  onlinemethod?: InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod>;
  test: Scalars["ID"]["input"];
  values?: InputMaybe<
    Array<InputMaybe<CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues>>
  >;
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOfflinemethod = {
  certificateFile: Scalars["ID"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputCreateOnlinemethod = {
  certificateLink: Scalars["String"]["input"];
};

export type CreateLanguageCertificateAndSetVerificationMethodInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type CreateOrganizationInvitationInput = {
  email: Scalars["String"]["input"];
  organization: Scalars["ID"]["input"];
  role: Scalars["ID"]["input"];
};

export type CreateOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization: Scalars["ID"]["input"];
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CreateSupportTicketInput = {
  category: Scalars["ID"]["input"];
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  priority: AuthAccountSupportTicketPriorityChoices;
  title: Scalars["String"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city: Scalars["ID"]["input"];
  employerlettermethod?: InputMaybe<WorkExperienceEmployerLetterMethodInput>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  jobTitle: Scalars["String"]["input"];
  organization: Scalars["String"]["input"];
  paystubsmethod?: InputMaybe<CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start: Scalars["Date"]["input"];
};

export type CreateWorkExperienceAndSetVerificationMethodInputCreatePaystubsmethod = {
  paystubs: Scalars["ID"]["input"];
};

export type DnstxtRecordMethodType = {
  __typename?: "DNSTXTRecordMethodType";
  code: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type DegreeFileType = {
  __typename?: "DegreeFileType";
  file: Scalars["String"]["output"];
};

export type EducationAiType = {
  __typename?: "EducationAIType";
  city?: Maybe<CityNode>;
  degree?: Maybe<AuthAccountEducationDegreeChoices>;
  end?: Maybe<Scalars["Date"]["output"]>;
  field?: Maybe<FieldType>;
  start?: Maybe<Scalars["Date"]["output"]>;
  university?: Maybe<UniversityNode>;
};

export type EducationAnalyseAndExtractDataMutation = {
  __typename?: "EducationAnalyseAndExtractDataMutation";
  data?: Maybe<EducationAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<EducationVerificationMethodType>;
};

export type EducationCreateMutation = {
  __typename?: "EducationCreateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationEvaluationDocumentFileType = {
  __typename?: "EducationEvaluationDocumentFileType";
  file: Scalars["String"]["output"];
};

export type EducationMutation = {
  __typename?: "EducationMutation";
  analyseAndExtractData?: Maybe<EducationAnalyseAndExtractDataMutation>;
  create?: Maybe<EducationCreateMutation>;
  update?: Maybe<EducationUpdateMutation>;
};

export type EducationMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: EducationVerificationMethodUploadType;
};

export type EducationMutationCreateArgs = {
  input: CreateEducationAndSetVerificationMethodInput;
};

export type EducationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchEducationInput;
};

export type EducationNode = {
  __typename?: "EducationNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  createdAt: Scalars["DateTime"]["output"];
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
  updatedAt: Scalars["DateTime"]["output"];
};

export type EducationQuery = {
  __typename?: "EducationQuery";
  get?: Maybe<EducationNode>;
};

export type EducationQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type EducationUpdateMutation = {
  __typename?: "EducationUpdateMutation";
  education?: Maybe<EducationNode>;
};

export type EducationVerificationMethodType = CommunicationMethodAiType | IeeMethodAiType;

/** An enumeration. */
export enum EducationVerificationMethodUploadType {
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
}

export type EmployeeType = {
  __typename?: "EmployeeType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  courses?: Maybe<CourseNodeConnection>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type EmployeeTypeCoursesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  results_Status?: InputMaybe<AcademyCourseResultStatusChoices>;
};

export type EmployerLetterFileType = {
  __typename?: "EmployerLetterFileType";
  file: Scalars["String"]["output"];
};

export type EmployerLetterMethodType = {
  __typename?: "EmployerLetterMethodType";
  employerLetter: EmployerLetterFileType;
  employers?: Maybe<Array<Maybe<ReferenceCheckEmployerType>>>;
  id: Scalars["ID"]["output"];
};

export type EmploymentMutation = {
  __typename?: "EmploymentMutation";
  selectInterviewSlot?: Maybe<SelectInterviewSlotMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobSeekerJobPositionAssignmentStatusUpdateMutation>;
};

export type EmploymentMutationSelectInterviewSlotArgs = {
  jobPositionAssignmentId: Scalars["ID"]["input"];
  slotId: Scalars["ID"]["input"];
};

export type EmploymentMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobSeekerJobPositionAssignmentStatusUpdateInput;
};

export type FieldNode = {
  __typename?: "FieldNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type FieldNodeConnection = {
  __typename?: "FieldNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FieldNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FieldNode` and its cursor. */
export type FieldNodeEdge = {
  __typename?: "FieldNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<FieldNode>;
};

export type FieldType = {
  __typename?: "FieldType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

/** An enumeration. */
export enum FlexCalendarCalendarEventStatusChoices {
  /** Canceled */
  CANCELED = "CANCELED",
  /** Completed */
  COMPLETED = "COMPLETED",
  /** Scheduled */
  SCHEDULED = "SCHEDULED",
  /** Started */
  STARTED = "STARTED",
}

export type FullBodyImageFileType = {
  __typename?: "FullBodyImageFileType";
  file: Scalars["String"]["output"];
};

export type GenerateAssessmentTokenMutation = {
  __typename?: "GenerateAssessmentTokenMutation";
  token?: Maybe<Scalars["String"]["output"]>;
};

export type GenerateResumeMutation = {
  __typename?: "GenerateResumeMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GeneratedCvNode = {
  __typename?: "GeneratedCVNode";
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type GoogleAuth = {
  __typename?: "GoogleAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type HijackUserMutation = {
  __typename?: "HijackUserMutation";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<UserNode>;
};

export type IeeMethodAiType = {
  __typename?: "IEEMethodAIType";
  evaluator?: Maybe<IeeMethodEvaluator>;
};

/** An enumeration. */
export enum IeeMethodEvaluator {
  /** Comparative Education Service */
  CES = "CES",
  /** International Credential Assessment Service of Canada */
  ICAS = "ICAS",
  /** International Qualifications Assessment Service */
  IQAS = "IQAS",
  /** Other */
  OTHER = "OTHER",
  /** World Education Services */
  WES = "WES",
}

export type IeeMethodType = {
  __typename?: "IEEMethodType";
  educationEvaluationDocument: EducationEvaluationDocumentFileType;
  id: Scalars["ID"]["output"];
};

export type InAppNotificationMutation = {
  __typename?: "InAppNotificationMutation";
  updateReadAt?: Maybe<InAppNotificationReadAtUpdateMutation>;
};

export type InAppNotificationMutationUpdateReadAtArgs = {
  input: Array<InputMaybe<InAppNotificationReadAtUpdateInput>>;
};

export type InAppNotificationNode = {
  __typename?: "InAppNotificationNode";
  action?: Maybe<NotificationActionType>;
  body: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

export type InAppNotificationReadAtUpdateInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InAppNotificationReadAtUpdateMutation = {
  __typename?: "InAppNotificationReadAtUpdateMutation";
  inAppNotifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
};

export type IndustryNode = {
  __typename?: "IndustryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type IndustryNodeConnection = {
  __typename?: "IndustryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndustryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IndustryNode` and its cursor. */
export type IndustryNodeEdge = {
  __typename?: "IndustryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<IndustryNode>;
};

export type JobBenefitNode = {
  __typename?: "JobBenefitNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobBenefitNodeConnection = {
  __typename?: "JobBenefitNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobBenefitNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobBenefitNode` and its cursor. */
export type JobBenefitNodeEdge = {
  __typename?: "JobBenefitNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobBenefitNode>;
};

export type JobBenefitType = {
  __typename?: "JobBenefitType";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type JobNode = {
  __typename?: "JobNode";
  id: Scalars["ID"]["output"];
  industries: IndustryNodeConnection;
  requireAppearanceData: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type JobNodeIndustriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<CommonIndustryOrderByChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type JobNodeConnection = {
  __typename?: "JobNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobNode` and its cursor. */
export type JobNodeEdge = {
  __typename?: "JobNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobNode>;
};

export type JobPositionAssignmentNode = {
  __typename?: "JobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  hasActiveCooperationInOtherOrganizations?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobSeeker?: Maybe<JobSeekerUnionType>;
  jobSuggestionItem?: Maybe<JobSuggestionResultItemNode>;
  overQualificationReasons?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobPositionAssignmentNodeConnection = {
  __typename?: "JobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobPositionAssignmentNode` and its cursor. */
export type JobPositionAssignmentNodeEdge = {
  __typename?: "JobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionAssignmentStatisticsType = {
  __typename?: "JobPositionAssignmentStatisticsType";
  acceptedCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDateCount?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApprovalCount?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceledCount?: Maybe<Scalars["Int"]["output"]>;
  interviewDoneCount?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduledCount?: Maybe<Scalars["Int"]["output"]>;
  notReviewedCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseekerCount?: Maybe<Scalars["Int"]["output"]>;
  rejectedCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusCountType = {
  __typename?: "JobPositionAssignmentStatusCountType";
  count?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

export type JobPositionAssignmentStatusCountsType = {
  __typename?: "JobPositionAssignmentStatusCountsType";
  accepted?: Maybe<Scalars["Int"]["output"]>;
  awaitingInterviewDate?: Maybe<Scalars["Int"]["output"]>;
  awaitingJobseekerApproval?: Maybe<Scalars["Int"]["output"]>;
  interviewCanceled?: Maybe<Scalars["Int"]["output"]>;
  interviewDone?: Maybe<Scalars["Int"]["output"]>;
  interviewScheduled?: Maybe<Scalars["Int"]["output"]>;
  notReviewed?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  rejectedByJobseeker?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionAssignmentStatusHistoryType = {
  __typename?: "JobPositionAssignmentStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  interview?: Maybe<JobPositionInterviewDetailType>;
  status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
};

export type JobPositionAssignmentStatusUpdateInput = {
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
};

export type JobPositionInterviewDetailType = {
  __typename?: "JobPositionInterviewDetailType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionInterviewSlotType = {
  __typename?: "JobPositionInterviewSlotType";
  datetime?: Maybe<Scalars["DateTimeRangeScalar"]["output"]>;
  id: Scalars["ID"]["output"];
  isAvailable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JobPositionInterviewType = {
  __typename?: "JobPositionInterviewType";
  event: CalendarEventType;
  id: Scalars["ID"]["output"];
  slot?: Maybe<JobPositionInterviewSlotType>;
};

export type JobPositionLocationTypeCountsType = {
  __typename?: "JobPositionLocationTypeCountsType";
  globalCount?: Maybe<Scalars["Int"]["output"]>;
  hybridCount?: Maybe<Scalars["Int"]["output"]>;
  limitedAreaCount?: Maybe<Scalars["Int"]["output"]>;
  onTheRoadCount?: Maybe<Scalars["Int"]["output"]>;
  preciseLocationCount?: Maybe<Scalars["Int"]["output"]>;
  remoteCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JobPositionStatusCountsType = {
  __typename?: "JobPositionStatusCountsType";
  capacityFilled?: Maybe<Scalars["Int"]["output"]>;
  drafted?: Maybe<Scalars["Int"]["output"]>;
  expired?: Maybe<Scalars["Int"]["output"]>;
  published?: Maybe<Scalars["Int"]["output"]>;
  rejected?: Maybe<Scalars["Int"]["output"]>;
  submitted?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type JobSeekerAssessmentResultType = {
  __typename?: "JobSeekerAssessmentResultType";
  evaluation?: Maybe<JobSeekerEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type JobSeekerCertificateAndLicenseType = {
  __typename?: "JobSeekerCertificateAndLicenseType";
  certificateandlicenseofflineverificationmethod?: Maybe<CertificateAndLicenseOfflineVerificationMethodType>;
  certificateandlicenseonlineverificationmethod?: Maybe<CertificateAndLicenseOnlineVerificationMethodType>;
  certifier: Scalars["String"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  status: AuthAccountCertificateAndLicenseStatusChoices;
  title: Scalars["String"]["output"];
};

export type JobSeekerCooperationType = {
  __typename?: "JobSeekerCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type JobSeekerCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSeekerEducationType = {
  __typename?: "JobSeekerEducationType";
  city: CityNode;
  communicationmethod?: Maybe<CommunicationMethodType>;
  degree: AuthAccountEducationDegreeChoices;
  end?: Maybe<Scalars["Date"]["output"]>;
  field: FieldType;
  id: Scalars["ID"]["output"];
  ieemethod?: Maybe<IeeMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountEducationStatusChoices;
  university: UniversityNode;
};

export type JobSeekerEmployeeType = {
  __typename?: "JobSeekerEmployeeType";
  cooperations?: Maybe<JobSeekerCooperationType>;
  id: Scalars["ID"]["output"];
  organization?: Maybe<JobSeekerOrganizationType>;
};

export type JobSeekerEvaluationType = {
  __typename?: "JobSeekerEvaluationType";
  score: Score;
  userFeedback: Scalars["String"]["output"];
};

export type JobSeekerGeneratedCvType = {
  __typename?: "JobSeekerGeneratedCVType";
  aboutMe?: Maybe<Scalars["String"]["output"]>;
  file: Scalars["String"]["output"];
  modified: Scalars["DateTime"]["output"];
};

export type JobSeekerJobPositionAssignmentNode = {
  __typename?: "JobSeekerJobPositionAssignmentNode";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  interviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
  jobPosition?: Maybe<JobSeekerJobPositionType>;
  status: AuthAccountJobPositionAssignmentStatusChoices;
  statusHistories?: Maybe<Array<Maybe<JobPositionAssignmentStatusHistoryType>>>;
};

export type JobSeekerJobPositionAssignmentNodeConnection = {
  __typename?: "JobSeekerJobPositionAssignmentNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSeekerJobPositionAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSeekerJobPositionAssignmentNode` and its cursor. */
export type JobSeekerJobPositionAssignmentNodeEdge = {
  __typename?: "JobSeekerJobPositionAssignmentNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionAssignmentStatusUpdateInput = {
  status: AuthAccountJobPositionAssignmentStatusChoices;
};

export type JobSeekerJobPositionAssignmentStatusUpdateMutation = {
  __typename?: "JobSeekerJobPositionAssignmentStatusUpdateMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type JobSeekerJobPositionType = {
  __typename?: "JobSeekerJobPositionType";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type JobSeekerJobPositionTypeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JobSeekerLanguageCertificateType = {
  __typename?: "JobSeekerLanguageCertificateType";
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
};

export type JobSeekerOrganizationType = {
  __typename?: "JobSeekerOrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  logo?: Maybe<OrganizationLogoFileType>;
  name: Scalars["String"]["output"];
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
};

export type JobSeekerPrimitiveType = {
  __typename?: "JobSeekerPrimitiveType";
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfilePrimitiveType>;
  workexperiences?: Maybe<Array<Maybe<JobSeekerWorkExperienceType>>>;
};

export type JobSeekerProfilePrimitiveType = {
  __typename?: "JobSeekerProfilePrimitiveType";
  avatar?: Maybe<AvatarFileType>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerProfileType = {
  __typename?: "JobSeekerProfileType";
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  score: Scalars["Int"]["output"];
};

export type JobSeekerType = {
  __typename?: "JobSeekerType";
  assessments?: Maybe<Array<Maybe<OrganizationAssessmentType>>>;
  certificateandlicenses?: Maybe<Array<JobSeekerCertificateAndLicenseType>>;
  cv?: Maybe<JobSeekerGeneratedCvType>;
  educations?: Maybe<Array<JobSeekerEducationType>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  languagecertificates?: Maybe<Array<JobSeekerLanguageCertificateType>>;
  lastName: Scalars["String"]["output"];
  profile?: Maybe<JobSeekerProfileType>;
  resume?: Maybe<ResumeType>;
  workexperiences?: Maybe<Array<JobSeekerWorkExperienceType>>;
};

export type JobSeekerUnionType = JobSeekerPrimitiveType | JobSeekerType;

export type JobSeekerWorkExperienceType = {
  __typename?: "JobSeekerWorkExperienceType";
  city: CityNode;
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
};

export type JobSuggestionResultItemNode = {
  __typename?: "JobSuggestionResultItemNode";
  confidenceLevel: Scalars["Int"]["output"];
  considerations?: Maybe<Array<Scalars["String"]["output"]>>;
  experienceMatch: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isAssigned?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  matchExplanation?: Maybe<Scalars["String"]["output"]>;
  matchScore?: Maybe<Scalars["Int"]["output"]>;
  overQualificationReasons: Array<Scalars["String"]["output"]>;
  recommendation: Scalars["Int"]["output"];
  seniorityMatch: Scalars["Int"]["output"];
  skillMatch: Scalars["Int"]["output"];
  strengths?: Maybe<Array<Scalars["String"]["output"]>>;
  user?: Maybe<UserNode>;
};

export type JobSuggestionResultItemNodeConnection = {
  __typename?: "JobSuggestionResultItemNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobSuggestionResultItemNode` and its cursor. */
export type JobSuggestionResultItemNodeEdge = {
  __typename?: "JobSuggestionResultItemNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultItemNode>;
};

export type JobSuggestionResultNode = {
  __typename?: "JobSuggestionResultNode";
  id: Scalars["ID"]["output"];
  items?: Maybe<JobSuggestionResultItemNodeConnection>;
  jobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type JobSuggestionResultNodeItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JobSuggestionResultNodeConnection = {
  __typename?: "JobSuggestionResultNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobSuggestionResultNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `JobSuggestionResultNode` and its cursor. */
export type JobSuggestionResultNodeEdge = {
  __typename?: "JobSuggestionResultNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<JobSuggestionResultNode>;
};

export type LanguageCertificateAiType = {
  __typename?: "LanguageCertificateAIType";
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  issuedAt?: Maybe<Scalars["Date"]["output"]>;
  language?: Maybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: Maybe<LanguageCertificateTestAiType>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueAiType>>>;
};

export type LanguageCertificateAnalyseAndExtractDataMutation = {
  __typename?: "LanguageCertificateAnalyseAndExtractDataMutation";
  data?: Maybe<LanguageCertificateAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateCreateMutation = {
  __typename?: "LanguageCertificateCreateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateFileType = {
  __typename?: "LanguageCertificateFileType";
  file: Scalars["String"]["output"];
};

export type LanguageCertificateMutation = {
  __typename?: "LanguageCertificateMutation";
  analyseAndExtractData?: Maybe<LanguageCertificateAnalyseAndExtractDataMutation>;
  create?: Maybe<LanguageCertificateCreateMutation>;
  update?: Maybe<LanguageCertificateUpdateMutation>;
};

export type LanguageCertificateMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateMutationCreateArgs = {
  input: CreateLanguageCertificateAndSetVerificationMethodInput;
};

export type LanguageCertificateMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchLanguageCertificateInput;
};

export type LanguageCertificateNode = {
  __typename?: "LanguageCertificateNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  issuedAt: Scalars["Date"]["output"];
  language: AuthAccountLanguageCertificateLanguageChoices;
  offlinemethod?: Maybe<LanguageCertificateOfflineVerificationMethodType>;
  onlinemethod?: Maybe<LanguageCertificateOnlineVerificationMethodType>;
  status: AuthAccountLanguageCertificateStatusChoices;
  test?: Maybe<LanguageProficiencyTestNode>;
  values?: Maybe<Array<Maybe<LanguageCertificateValueNode>>>;
};

export type LanguageCertificateOfflineVerificationMethodType = {
  __typename?: "LanguageCertificateOfflineVerificationMethodType";
  certificateFile: LanguageCertificateFileType;
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateOnlineVerificationMethodType = {
  __typename?: "LanguageCertificateOnlineVerificationMethodType";
  certificateLink: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type LanguageCertificateQuery = {
  __typename?: "LanguageCertificateQuery";
  get?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type LanguageCertificateTestAiType = {
  __typename?: "LanguageCertificateTestAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateUpdateMutation = {
  __typename?: "LanguageCertificateUpdateMutation";
  languageCertificate?: Maybe<LanguageCertificateNode>;
};

export type LanguageCertificateValueAiType = {
  __typename?: "LanguageCertificateValueAIType";
  skill?: Maybe<LanguageCertificateValueSkillAiType>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageCertificateValueNode = {
  __typename?: "LanguageCertificateValueNode";
  id: Scalars["ID"]["output"];
  skill?: Maybe<LanguageProficiencySkillNode>;
  value: Scalars["String"]["output"];
};

export type LanguageCertificateValueSkillAiType = {
  __typename?: "LanguageCertificateValueSkillAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
  skillName?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
};

export type LanguageProficiencySkillNode = {
  __typename?: "LanguageProficiencySkillNode";
  id: Scalars["ID"]["output"];
  skillName: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  /** A list of kwargs dictionaries */
  validatorKwargs: Scalars["JSONString"]["output"];
};

export type LanguageProficiencySkillNodeConnection = {
  __typename?: "LanguageProficiencySkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencySkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencySkillNode` and its cursor. */
export type LanguageProficiencySkillNodeEdge = {
  __typename?: "LanguageProficiencySkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencySkillNode>;
};

export type LanguageProficiencyTestNode = {
  __typename?: "LanguageProficiencyTestNode";
  id: Scalars["ID"]["output"];
  languages?: Maybe<Array<Maybe<CommonLanguageProficiencyTestLanguagesChoices>>>;
  skills?: Maybe<LanguageProficiencySkillNodeConnection>;
  title: Scalars["String"]["output"];
};

export type LanguageProficiencyTestNodeSkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LanguageProficiencyTestNodeConnection = {
  __typename?: "LanguageProficiencyTestNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LanguageProficiencyTestNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LanguageProficiencyTestNode` and its cursor. */
export type LanguageProficiencyTestNodeEdge = {
  __typename?: "LanguageProficiencyTestNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<LanguageProficiencyTestNode>;
};

export type LinkedInAuth = {
  __typename?: "LinkedInAuth";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  academy: AcademyMutation;
  account: AccountMutation;
  assessment: AssessmentMutation;
  common: CommonMutation;
  cv: CvMutation;
  notification: NotificationMutation;
};

export type NotificationActionDetailType = NotificationRelatedObjectType | NotificationSimpleLinkType;

export type NotificationActionType = {
  __typename?: "NotificationActionType";
  detail?: Maybe<NotificationActionDetailType>;
  text: Scalars["String"]["output"];
};

export type NotificationMutation = {
  __typename?: "NotificationMutation";
  inAppNotification?: Maybe<InAppNotificationMutation>;
  pushNotification?: Maybe<PushNotificationMutation>;
};

/** An enumeration. */
export enum NotificationRelatedObjectSlugEnum {
  JOB_POSITION = "JOB_POSITION",
  JOB_POSITION_ASSIGNMENT = "JOB_POSITION_ASSIGNMENT",
  ORGANIZATION_EMPLOYEE_COOPERATION = "ORGANIZATION_EMPLOYEE_COOPERATION",
}

export type NotificationRelatedObjectType = {
  __typename?: "NotificationRelatedObjectType";
  relatedObjectId: Scalars["Int"]["output"];
  relatedObjectSlug?: Maybe<NotificationRelatedObjectSlugEnum>;
};

export type NotificationSimpleLinkType = {
  __typename?: "NotificationSimpleLinkType";
  id: Scalars["ID"]["output"];
  link: Scalars["String"]["output"];
};

export type ObtainJsonWebToken = {
  __typename?: "ObtainJSONWebToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  refreshExpiresIn?: Maybe<Scalars["Int"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
  unarchiving?: Maybe<Scalars["Boolean"]["output"]>;
  user?: Maybe<UserNode>;
};

export type OnboardingJobSuggestionOutputType = {
  __typename?: "OnboardingJobSuggestionOutputType";
  jobSuggestions?: Maybe<Array<Maybe<OnboardingJobSuggestionType>>>;
  text?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingJobSuggestionType = {
  __typename?: "OnboardingJobSuggestionType";
  companyName?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  salaryRange?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  shortDescription?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAssessmentResultType = {
  __typename?: "OrganizationAssessmentResultType";
  evaluation?: Maybe<OrganizationEvaluationType>;
  question: AssessmentResultQuestionType;
};

export type OrganizationAssessmentType = {
  __typename?: "OrganizationAssessmentType";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  remainingQuestions: Scalars["Int"]["output"];
  results?: Maybe<Array<Maybe<OrganizationAssessmentResultType>>>;
  skill?: Maybe<AssessmentSkillType>;
  status: Status;
  title: Scalars["String"]["output"];
  totalEstimatedTime: Scalars["Int"]["output"];
  totalQuestions: Scalars["Int"]["output"];
};

export type OrganizationCertificateFileType = {
  __typename?: "OrganizationCertificateFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationEmployeeCooperationStatusCountsType = {
  __typename?: "OrganizationEmployeeCooperationStatusCountsType";
  active?: Maybe<Scalars["Int"]["output"]>;
  awaiting?: Maybe<Scalars["Int"]["output"]>;
  finished?: Maybe<Scalars["Int"]["output"]>;
  fired?: Maybe<Scalars["Int"]["output"]>;
  resigned?: Maybe<Scalars["Int"]["output"]>;
  suspended?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationEmployeeCooperationStatusUpdateInput = {
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationStatusUpdateMutation = {
  __typename?: "OrganizationEmployeeCooperationStatusUpdateMutation";
  organizationEmployeeCooperation?: Maybe<OrganizationEmployeeCooperationType>;
};

export type OrganizationEmployeeCooperationType = {
  __typename?: "OrganizationEmployeeCooperationType";
  createdAt: Scalars["DateTime"]["output"];
  employerSatisfactionRate?: Maybe<Scalars["Float"]["output"]>;
  endAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  performanceReport?: Maybe<OrganizationEmployeePerformanceReportNodeConnection>;
  platformMessages?: Maybe<OrganizationPlatformMessageNodeConnection>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
};

export type OrganizationEmployeeCooperationTypePerformanceReportArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  date_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  date_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeCooperationTypePlatformMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrganizationEmployeeNode = {
  __typename?: "OrganizationEmployeeNode";
  cooperations?: Maybe<Array<Maybe<OrganizationEmployeeCooperationType>>>;
  employee?: Maybe<EmployeeType>;
  id: Scalars["ID"]["output"];
};

export type OrganizationEmployeeNodeConnection = {
  __typename?: "OrganizationEmployeeNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeeNode` and its cursor. */
export type OrganizationEmployeeNodeEdge = {
  __typename?: "OrganizationEmployeeNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeeNode>;
};

export type OrganizationEmployeePerformanceReportNode = {
  __typename?: "OrganizationEmployeePerformanceReportNode";
  date?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  reportSummary?: Maybe<Scalars["String"]["output"]>;
  reportText: Scalars["String"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusChoices;
  statusHistories: Array<OrganizationEmployeePerformanceReportStatusHistoryType>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationEmployeePerformanceReportNodeConnection = {
  __typename?: "OrganizationEmployeePerformanceReportNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationEmployeePerformanceReportNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationEmployeePerformanceReportNode` and its cursor. */
export type OrganizationEmployeePerformanceReportNodeEdge = {
  __typename?: "OrganizationEmployeePerformanceReportNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationEmployeePerformanceReportNode>;
};

export type OrganizationEmployeePerformanceReportStatusHistoryType = {
  __typename?: "OrganizationEmployeePerformanceReportStatusHistoryType";
  createdAt: Scalars["DateTime"]["output"];
  status: AuthAccountOrganizationEmployeePerformanceReportStatusHistoryStatusChoices;
};

export type OrganizationEmployeeQuery = {
  __typename?: "OrganizationEmployeeQuery";
  get?: Maybe<OrganizationEmployeeNode>;
  list?: Maybe<OrganizationEmployeeNodeConnection>;
};

export type OrganizationEmployeeQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationEmployeeQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cooperationStartAt?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtGte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperationStartAtLte?: InputMaybe<Scalars["Date"]["input"]>;
  cooperations_Status?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  user_JobPositionAssignments_JobPosition?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationEvaluationType = {
  __typename?: "OrganizationEvaluationType";
  negativePoints: Array<Maybe<Scalars["String"]["output"]>>;
  positivePoints: Array<Maybe<Scalars["String"]["output"]>>;
  score: Score;
  scoreReasoning: Scalars["String"]["output"];
  scoreValue?: Maybe<Scalars["Decimal"]["output"]>;
  userFeedback: Scalars["String"]["output"];
};

export type OrganizationExtractJobPosition = {
  __typename?: "OrganizationExtractJobPosition";
  jobPosition?: Maybe<OrganizationJobPositionNode>;
  taskScheduled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationInvitationType = {
  __typename?: "OrganizationInvitationType";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: UserNode;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  organization?: Maybe<OrganizationType>;
  role: RoleType;
};

export type OrganizationInviteMutation = {
  __typename?: "OrganizationInviteMutation";
  organizationInvitation?: Maybe<OrganizationInvitationType>;
};

export type OrganizationJobPositionCreateMutation = {
  __typename?: "OrganizationJobPositionCreateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionInterviewSlotSetMutation = {
  __typename?: "OrganizationJobPositionInterviewSlotSetMutation";
  overlappingInterviews?: Maybe<Array<Maybe<JobPositionInterviewType>>>;
};

export type OrganizationJobPositionNode = {
  __typename?: "OrganizationJobPositionNode";
  ageRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  assignments?: Maybe<JobPositionAssignmentNodeConnection>;
  benefits?: Maybe<Array<JobBenefitType>>;
  cities: CityNodeConnection;
  contractType?: Maybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  employerQuestions?: Maybe<Array<Scalars["String"]["output"]>>;
  fields?: Maybe<Array<FieldType>>;
  hiringInCanada?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  interviewSlots: Array<JobPositionInterviewSlotType>;
  isEditable?: Maybe<Scalars["Boolean"]["output"]>;
  jobRestrictions?: Maybe<Scalars["String"]["output"]>;
  languages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: Maybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: Maybe<Array<Maybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  organization?: Maybe<OrganizationType>;
  otherBenefits?: Maybe<Array<Scalars["String"]["output"]>>;
  paymentTerm?: Maybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: Maybe<Scalars["String"]["output"]>;
  report?: Maybe<OrganizationJobPositionReportType>;
  requiredDocuments?: Maybe<Array<Scalars["String"]["output"]>>;
  salaryRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  skills?: Maybe<Array<SkillType>>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
  status: AuthAccountOrganizationJobPositionStatusChoices;
  title?: Maybe<Scalars["String"]["output"]>;
  vaccancy?: Maybe<Scalars["Int"]["output"]>;
  validityDate?: Maybe<Scalars["Date"]["output"]>;
  validityDays?: Maybe<Scalars["Int"]["output"]>;
  workExperienceYearsRange?: Maybe<Array<Scalars["Int"]["output"]>>;
  workingEndAt?: Maybe<Scalars["Time"]["output"]>;
  workingStartAt?: Maybe<Scalars["Time"]["output"]>;
};

export type OrganizationJobPositionNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type OrganizationJobPositionNodeCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrganizationJobPositionNodeConnection = {
  __typename?: "OrganizationJobPositionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationJobPositionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A Relay edge containing a `OrganizationJobPositionNode` and its cursor. */
export type OrganizationJobPositionNodeEdge = {
  __typename?: "OrganizationJobPositionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionQuery = {
  __typename?: "OrganizationJobPositionQuery";
  get?: Maybe<OrganizationJobPositionNode>;
  list?: Maybe<OrganizationJobPositionNodeConnection>;
};

export type OrganizationJobPositionQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationJobPositionQueryListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  assignments_Status?: InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName?: InputMaybe<Scalars["String"]["input"]>;
  cities_DisplayName_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  cities_Id?: InputMaybe<Scalars["ID"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  startAt_Gte?: InputMaybe<Scalars["Date"]["input"]>;
  startAt_Lte?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationJobPositionReportType = {
  __typename?: "OrganizationJobPositionReportType";
  assignmentStatusCounts?: Maybe<Array<Maybe<JobPositionAssignmentStatusCountType>>>;
};

export type OrganizationJobPositionStatusUpdateInput = {
  status: AuthAccountOrganizationJobPositionStatusChoices;
};

export type OrganizationJobPositionStatusUpdateMutation = {
  __typename?: "OrganizationJobPositionStatusUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationJobPositionUpdateMutation = {
  __typename?: "OrganizationJobPositionUpdateMutation";
  organizationJobPosition?: Maybe<OrganizationJobPositionNode>;
};

export type OrganizationLogoFileType = {
  __typename?: "OrganizationLogoFileType";
  file: Scalars["String"]["output"];
};

export type OrganizationMembershipType = {
  __typename?: "OrganizationMembershipType";
  accessedRoles?: Maybe<Array<Maybe<RoleType>>>;
  organization?: Maybe<OrganizationType>;
  role: RoleType;
  user?: Maybe<OrganizationMembershipUserType>;
};

export type OrganizationMembershipUserType = {
  __typename?: "OrganizationMembershipUserType";
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
};

export type OrganizationMutation = {
  __typename?: "OrganizationMutation";
  createJobPosition?: Maybe<OrganizationJobPositionCreateMutation>;
  createJobPositionFromFile?: Maybe<OrganizationExtractJobPosition>;
  invite?: Maybe<OrganizationInviteMutation>;
  register?: Maybe<RegisterOrganization>;
  setContacts?: Maybe<SetOrganizationContactsMutation>;
  setJobPositionInterviewSlot?: Maybe<OrganizationJobPositionInterviewSlotSetMutation>;
  setVerificationMethod?: Maybe<OrganizationSetVerificationMethodMutation>;
  update?: Maybe<OrganizationUpdateMutation>;
  updateCalendarEventStatus?: Maybe<CalendarEventStatusUpdateMutation>;
  updateEmployeeCooperationStatus?: Maybe<OrganizationEmployeeCooperationStatusUpdateMutation>;
  updateJobPosition?: Maybe<OrganizationJobPositionUpdateMutation>;
  updateJobPositionAssignmentStatus?: Maybe<JobPositionAssignmentStatusUpdateMutation>;
  updateJobPositionStatus?: Maybe<OrganizationJobPositionStatusUpdateMutation>;
  updatePlatformMessageReadAt?: Maybe<OrganizationPlatformMessageReadAtUpdateMutation>;
  verify?: Maybe<OrganizationVerify>;
};

export type OrganizationMutationCreateJobPositionArgs = {
  input: CreateOrganizationJobPositionInput;
};

export type OrganizationMutationCreateJobPositionFromFileArgs = {
  file: Scalars["Upload"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type OrganizationMutationInviteArgs = {
  input: CreateOrganizationInvitationInput;
};

export type OrganizationMutationRegisterArgs = {
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
};

export type OrganizationMutationSetContactsArgs = {
  input: Array<InputMaybe<SetOrganizationContactableInput>>;
};

export type OrganizationMutationSetJobPositionInterviewSlotArgs = {
  jobPositionId: Scalars["ID"]["input"];
  slots: Array<InputMaybe<Scalars["DateTimeRangeScalar"]["input"]>>;
};

export type OrganizationMutationSetVerificationMethodArgs = {
  id: Scalars["NotEmptyID"]["input"];
  input: OrganizationVerificationMethodInput;
};

export type OrganizationMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationInput;
};

export type OrganizationMutationUpdateCalendarEventStatusArgs = {
  id: Scalars["ID"]["input"];
  status?: InputMaybe<FlexCalendarCalendarEventStatusChoices>;
};

export type OrganizationMutationUpdateEmployeeCooperationStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationEmployeeCooperationStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionArgs = {
  id: Scalars["ID"]["input"];
  input: PatchOrganizationJobPositionInput;
};

export type OrganizationMutationUpdateJobPositionAssignmentStatusArgs = {
  id: Scalars["ID"]["input"];
  input: JobPositionAssignmentStatusUpdateInput;
};

export type OrganizationMutationUpdateJobPositionStatusArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationJobPositionStatusUpdateInput;
};

export type OrganizationMutationUpdatePlatformMessageReadAtArgs = {
  id: Scalars["ID"]["input"];
  input: OrganizationPlatformMessageReadAtUpdateInput;
};

export type OrganizationMutationVerifyArgs = {
  organization: Scalars["NotEmptyID"]["input"];
  otp?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationPlatformMessageAttachmentType = {
  __typename?: "OrganizationPlatformMessageAttachmentType";
  attachmentType?: Maybe<AttachmentType>;
  course?: Maybe<CourseNode>;
  courseResult?: Maybe<CourseResultType>;
  file?: Maybe<BaseFileModelType>;
  id: Scalars["ID"]["output"];
  text: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNode = {
  __typename?: "OrganizationPlatformMessageNode";
  assigneeType: AuthAccountOrganizationPlatformMessageAssigneeTypeChoices;
  attachments: Array<OrganizationPlatformMessageAttachmentType>;
  created: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  source: AuthAccountOrganizationPlatformMessageSourceChoices;
  text: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type OrganizationPlatformMessageNodeConnection = {
  __typename?: "OrganizationPlatformMessageNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrganizationPlatformMessageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrganizationPlatformMessageNode` and its cursor. */
export type OrganizationPlatformMessageNodeEdge = {
  __typename?: "OrganizationPlatformMessageNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationPlatformMessageReadAtUpdateInput = {
  readAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type OrganizationPlatformMessageReadAtUpdateMutation = {
  __typename?: "OrganizationPlatformMessageReadAtUpdateMutation";
  organizationPlatformMessage?: Maybe<OrganizationPlatformMessageNode>;
};

export type OrganizationQuery = {
  __typename?: "OrganizationQuery";
  employee?: Maybe<OrganizationEmployeeQuery>;
  invitation?: Maybe<OrganizationInvitationType>;
  jobPosition?: Maybe<OrganizationJobPositionQuery>;
  jobPositionAssignment?: Maybe<JobPositionAssignmentNode>;
  jobPositionAssignmentStatistics?: Maybe<JobPositionAssignmentStatisticsType>;
  jobPositionInterview?: Maybe<JobPositionInterviewDetailType>;
};

export type OrganizationQueryInvitationArgs = {
  token: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionAssignmentStatisticsArgs = {
  organizationId: Scalars["NotEmptyID"]["input"];
};

export type OrganizationQueryJobPositionInterviewArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type OrganizationSetVerificationMethodMutation = {
  __typename?: "OrganizationSetVerificationMethodMutation";
  output?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationType = {
  __typename?: "OrganizationType";
  about?: Maybe<Scalars["String"]["output"]>;
  businessType?: Maybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: Maybe<CityNode>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  establishedAt?: Maybe<Scalars["Date"]["output"]>;
  hasFinancialData?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  industry?: Maybe<IndustryNode>;
  invitations: Array<OrganizationInvitationType>;
  logo?: Maybe<OrganizationLogoFileType>;
  memberships: Array<OrganizationMembershipType>;
  name: Scalars["String"]["output"];
  nationalNumber?: Maybe<Scalars["String"]["output"]>;
  shortName?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<AuthAccountOrganizationSizeChoices>;
  status: AuthAccountOrganizationStatusChoices;
  type?: Maybe<AuthAccountOrganizationTypeChoices>;
};

export type OrganizationUpdateMutation = {
  __typename?: "OrganizationUpdateMutation";
  organization?: Maybe<OrganizationType>;
};

export type OrganizationVerificationMethodInput = {
  communicateorganizationmethod?: InputMaybe<CommunicateOrganizationMethodInput>;
  dnstxtrecordmethod?: InputMaybe<Scalars["String"]["input"]>;
  uploadcompanycertificatemethod?: InputMaybe<UploadCompanyCertificateMethodInput>;
  uploadfiletowebsitemethod?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationVerify = {
  __typename?: "OrganizationVerify";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PasswordReset = {
  __typename?: "PasswordReset";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PatchCertificateAndLicenseInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  certifier?: InputMaybe<Scalars["String"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchEducationInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  degree?: InputMaybe<AuthAccountEducationDegreeChoices>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  field?: InputMaybe<Scalars["ID"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
  university?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PatchLanguageCertificateInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  expiredAt?: InputMaybe<Scalars["Date"]["input"]>;
  issuedAt?: InputMaybe<Scalars["Date"]["input"]>;
  language?: InputMaybe<AuthAccountLanguageCertificateLanguageChoices>;
  test?: InputMaybe<Scalars["ID"]["input"]>;
  values?: InputMaybe<Array<InputMaybe<PatchLanguageCertificateInputExactLanguageCertificateValues>>>;
};

export type PatchLanguageCertificateInputExactLanguageCertificateValues = {
  skill: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type PatchOrganizationInput = {
  about?: InputMaybe<Scalars["String"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  establishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  nationalNumber?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
};

export type PatchOrganizationJobPositionInput = {
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>>;
  degrees?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employerQuestions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  languages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>>;
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
};

export type PatchWorkExperienceInput = {
  allowSelfVerification?: InputMaybe<Scalars["Boolean"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  end?: InputMaybe<Scalars["Date"]["input"]>;
  grade?: InputMaybe<AuthAccountWorkExperienceGradeChoices>;
  jobTitle?: InputMaybe<Scalars["String"]["input"]>;
  organization?: InputMaybe<Scalars["String"]["input"]>;
  skills?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
};

export type PaystubsFileType = {
  __typename?: "PaystubsFileType";
  file: Scalars["String"]["output"];
};

export type PaystubsMethodAiType = {
  __typename?: "PaystubsMethodAIType";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type PaystubsMethodType = {
  __typename?: "PaystubsMethodType";
  id: Scalars["ID"]["output"];
  paystubs: PaystubsFileType;
};

export type PerformOnboardingInput = {
  country: Scalars["ID"]["input"];
  industry: Scalars["ID"]["input"];
  interestedJobs: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type PerformOnboardingJobSuggestionMutation = {
  __typename?: "PerformOnboardingJobSuggestionMutation";
  output?: Maybe<OnboardingJobSuggestionOutputType>;
};

export type PerformOnboardingMutation = {
  __typename?: "PerformOnboardingMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProfileMutation = {
  __typename?: "ProfileMutation";
  performOnboarding?: Maybe<PerformOnboardingMutation>;
  setContacts?: Maybe<SetUserContactsMutation>;
  setSkills?: Maybe<UserSetSkillsMutation>;
  update?: Maybe<UserUpdateMutation>;
  uploadResume?: Maybe<ResumeCreateMutation>;
};

export type ProfileMutationPerformOnboardingArgs = {
  input: PerformOnboardingInput;
};

export type ProfileMutationSetContactsArgs = {
  input: Array<InputMaybe<BatchCreateContactInput>>;
};

export type ProfileMutationSetSkillsArgs = {
  input: UserSkillInput;
  shouldAnalyze?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileMutationUpdateArgs = {
  input: UpdateProfileInput;
};

export type ProfileMutationUploadResumeArgs = {
  input: UpdateResumeInput;
};

export type ProfileType = {
  __typename?: "ProfileType";
  acceptTermsAndConditions: Scalars["Boolean"]["output"];
  allowNotifications: Scalars["Boolean"]["output"];
  avatar?: Maybe<AvatarFileType>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<CityNode>;
  completionPercentage?: Maybe<Scalars["Float"]["output"]>;
  contacts?: Maybe<Array<Maybe<ContactType>>>;
  country?: Maybe<CountryNode>;
  credits: Scalars["Int"]["output"];
  employmentStatus?: Maybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: Maybe<AuthAccountProfileEyeColorChoices>;
  fluentLanguages?: Maybe<Array<Maybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: Maybe<FullBodyImageFileType>;
  gender?: Maybe<AuthAccountProfileGenderChoices>;
  hairColor?: Maybe<Scalars["String"]["output"]>;
  height?: Maybe<Scalars["Int"]["output"]>;
  industry?: Maybe<IndustryNode>;
  interestedJobs: JobNodeConnection;
  isOnboardingCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  jobCities: CityNodeConnection;
  jobLocationType?: Maybe<Array<Maybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: Maybe<Array<Maybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  nativeLanguage?: Maybe<AuthAccountProfileNativeLanguageChoices>;
  rawSkills?: Maybe<Array<Scalars["String"]["output"]>>;
  score: Scalars["Int"]["output"];
  scores: Scalars["JSONString"]["output"];
  skills: Array<SkillType>;
  skinColor?: Maybe<AuthAccountProfileSkinColorChoices>;
  weight?: Maybe<Scalars["Int"]["output"]>;
};

export type ProfileTypeInterestedJobsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title_Icontains?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfileTypeJobCitiesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  country_Code2?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  name_Icontains?: InputMaybe<Scalars["String"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PushNotificationMutation = {
  __typename?: "PushNotificationMutation";
  registerToken?: Maybe<RegisterPushNotificationTokenMutation>;
};

export type PushNotificationMutationRegisterTokenArgs = {
  token: Scalars["String"]["input"];
};

export type Query = {
  __typename?: "Query";
  academy?: Maybe<AcademyQuery>;
  admin?: Maybe<AdminQuery>;
  calendar?: Maybe<CalendarQuery>;
  certificateAndLicense?: Maybe<CertificateAndLicenseQuery>;
  common?: Maybe<CommonQuery>;
  cv?: Maybe<CvQuery>;
  education?: Maybe<EducationQuery>;
  languageCertificate?: Maybe<LanguageCertificateQuery>;
  me?: Maybe<UserNode>;
  organization?: Maybe<OrganizationQuery>;
  supportTicketCategory?: Maybe<SupportTicketCategoryNodeConnection>;
  workExperience?: Maybe<WorkExperienceQuery>;
};

export type QuerySupportTicketCategoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  types_Contains?: InputMaybe<Array<InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

export type ReferenceCheckEmployerAiType = {
  __typename?: "ReferenceCheckEmployerAIType";
  email?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceCheckEmployerType = {
  __typename?: "ReferenceCheckEmployerType";
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  phoneNumber: Scalars["String"]["output"];
  position: Scalars["String"]["output"];
};

export type ReferralType = {
  __typename?: "ReferralType";
  code: Scalars["String"]["output"];
};

export type RefreshToken = {
  __typename?: "RefreshToken";
  payload?: Maybe<Scalars["GenericScalar"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
  token?: Maybe<Scalars["String"]["output"]>;
};

export type RegionNode = {
  __typename?: "RegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

export type RegionNodeConnection = {
  __typename?: "RegionNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RegionNode` and its cursor. */
export type RegionNodeEdge = {
  __typename?: "RegionNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<RegionNode>;
};

export type RegisterOrganization = {
  __typename?: "RegisterOrganization";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RegisterPushNotificationTokenMutation = {
  __typename?: "RegisterPushNotificationTokenMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ResendActivationEmail = {
  __typename?: "ResendActivationEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ResumeCreateMutation = {
  __typename?: "ResumeCreateMutation";
  resume?: Maybe<ResumeType>;
};

export type ResumeFileType = {
  __typename?: "ResumeFileType";
  file: Scalars["String"]["output"];
};

export type ResumeType = {
  __typename?: "ResumeType";
  file: ResumeFileType;
};

export type RevokeTokenMutation = {
  __typename?: "RevokeTokenMutation";
  revoked?: Maybe<Scalars["Int"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RoleType = {
  __typename?: "RoleType";
  accesses: Array<AccessType>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

/** An enumeration. */
export enum Score {
  AVERAGE = "AVERAGE",
  EXCEPTIONAL = "EXCEPTIONAL",
  GOOD = "GOOD",
  GREAT = "GREAT",
  ZERO = "ZERO",
}

export type SelectInterviewSlotMutation = {
  __typename?: "SelectInterviewSlotMutation";
  jobPositionAssignment?: Maybe<JobSeekerJobPositionAssignmentNode>;
};

export type SendPasswordResetEmail = {
  __typename?: "SendPasswordResetEmail";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetOrganizationContactableInput = {
  organizationId: Scalars["NotEmptyID"]["input"];
  type?: InputMaybe<AuthAccountContactTypeChoices>;
  value: Scalars["String"]["input"];
};

export type SetOrganizationContactsMutation = {
  __typename?: "SetOrganizationContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SetUserContactsMutation = {
  __typename?: "SetUserContactsMutation";
  contacts?: Maybe<Array<Maybe<ContactType>>>;
};

export type SkillNode = {
  __typename?: "SkillNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type SkillNodeConnection = {
  __typename?: "SkillNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SkillNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SkillNode` and its cursor. */
export type SkillNodeEdge = {
  __typename?: "SkillNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SkillNode>;
};

export type SkillType = {
  __typename?: "SkillType";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

/** An enumeration. */
export enum Status {
  COMPLETED = "COMPLETED",
  EVALUATED = "EVALUATED",
  EXPIRED = "EXPIRED",
  GENERATING = "GENERATING",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_READY = "NOT_READY",
  NOT_STARTED = "NOT_STARTED",
}

export type SubRegionNode = {
  __typename?: "SubRegionNode";
  alternateNames?: Maybe<Scalars["String"]["output"]>;
  country: CountryNode;
  displayName: Scalars["String"]["output"];
  geonameCode?: Maybe<Scalars["String"]["output"]>;
  geonameId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  nameAscii: Scalars["String"]["output"];
  region?: Maybe<RegionNode>;
  slug: Scalars["String"]["output"];
};

export type SupportTicketCategoryNode = {
  __typename?: "SupportTicketCategoryNode";
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  types?: Maybe<Array<Maybe<AuthAccountSupportTicketCategoryTypesChoices>>>;
};

export type SupportTicketCategoryNodeConnection = {
  __typename?: "SupportTicketCategoryNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SupportTicketCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SupportTicketCategoryNode` and its cursor. */
export type SupportTicketCategoryNodeEdge = {
  __typename?: "SupportTicketCategoryNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<SupportTicketCategoryNode>;
};

export type SupportTicketCreateMutation = {
  __typename?: "SupportTicketCreateMutation";
  supportTicket?: Maybe<SupportTicketType>;
};

export type SupportTicketMutation = {
  __typename?: "SupportTicketMutation";
  create?: Maybe<SupportTicketCreateMutation>;
};

export type SupportTicketMutationCreateArgs = {
  input: CreateSupportTicketInput;
};

export type SupportTicketType = {
  __typename?: "SupportTicketType";
  category: SupportTicketCategoryNode;
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["output"];
  created: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  modified: Scalars["DateTime"]["output"];
  priority: AuthAccountSupportTicketPriorityChoices;
  status: AuthAccountSupportTicketStatusChoices;
  ticketId: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type TriggerJobSuggestionMutation = {
  __typename?: "TriggerJobSuggestionMutation";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UnassignJobMutation = {
  __typename?: "UnassignJobMutation";
  deletedId?: Maybe<Scalars["ID"]["output"]>;
  deletedInputId?: Maybe<Scalars["ID"]["output"]>;
  deletedRawId?: Maybe<Scalars["ID"]["output"]>;
  found?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UniversityNode = {
  __typename?: "UniversityNode";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  websites?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type UniversityNodeConnection = {
  __typename?: "UniversityNodeConnection";
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UniversityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UniversityNode` and its cursor. */
export type UniversityNodeEdge = {
  __typename?: "UniversityNodeEdge";
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge */
  node?: Maybe<UniversityNode>;
};

export type UpdateCanadaVisaInput = {
  citizenshipDocument?: InputMaybe<Scalars["ID"]["input"]>;
  nationality?: InputMaybe<Scalars["ID"]["input"]>;
  status: AuthAccountCanadaVisaStatusChoices;
};

export type UpdateCourseResultInput = {
  course: Scalars["ID"]["input"];
};

export type UpdateProfileInput = {
  acceptTermsAndConditions?: InputMaybe<Scalars["Boolean"]["input"]>;
  allowNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  avatar?: InputMaybe<Scalars["ID"]["input"]>;
  /** Must be at least 18 years ago and at most 65 years ago */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  employmentStatus?: InputMaybe<AuthAccountProfileEmploymentStatusChoices>;
  eyeColor?: InputMaybe<AuthAccountProfileEyeColorChoices>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  fluentLanguages?: InputMaybe<Array<InputMaybe<AuthAccountProfileFluentLanguagesChoices>>>;
  fullBodyImage?: InputMaybe<Scalars["ID"]["input"]>;
  gender?: InputMaybe<AuthAccountProfileGenderChoices>;
  hairColor?: InputMaybe<Scalars["String"]["input"]>;
  height?: InputMaybe<Scalars["Int"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  interestedJobs?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobCities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  jobLocationType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobLocationTypeExcludeChoices>>>;
  jobType?: InputMaybe<Array<InputMaybe<AuthAccountProfileJobTypeExcludeChoices>>>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<AuthAccountProfileNativeLanguageChoices>;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  skinColor?: InputMaybe<AuthAccountProfileSkinColorChoices>;
  weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateResumeInput = {
  file: Scalars["ID"]["input"];
};

export type UploadCompanyCertificateMethodInput = {
  organizationCertificateFileId: Scalars["NotEmptyID"]["input"];
};

export type UploadCompanyCertificateMethodType = {
  __typename?: "UploadCompanyCertificateMethodType";
  id: Scalars["ID"]["output"];
  organizationCertificateFile: OrganizationCertificateFileType;
};

export type UploadFileMutation = {
  __typename?: "UploadFileMutation";
  pk?: Maybe<Scalars["Int"]["output"]>;
};

export type UploadFileToWebsiteMethodType = {
  __typename?: "UploadFileToWebsiteMethodType";
  fileName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

/** An enumeration. */
export enum UploadType {
  /** Avatar Image */
  AVATAR = "AVATAR",
  /** Certificate File */
  CERTIFICATE = "CERTIFICATE",
  /** Citizenship Document File */
  CITIZENSHIP_DOCUMENT = "CITIZENSHIP_DOCUMENT",
  /** Degree File */
  DEGREE = "DEGREE",
  /** Education Evaluation Document File */
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Full Body Image */
  FULL_BODY_IMAGE = "FULL_BODY_IMAGE",
  /** Language Certificate File */
  LANGUAGE_CERTIFICATE = "LANGUAGE_CERTIFICATE",
  /** Organization Certificate File */
  ORGANIZATION_CERTIFICATE = "ORGANIZATION_CERTIFICATE",
  /** Organization Logo File */
  ORGANIZATION_LOGO = "ORGANIZATION_LOGO",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
  /** Resume File */
  RESUME = "RESUME",
}

export type UserNode = {
  __typename?: "UserNode";
  archived?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Array<Maybe<AssessmentType>>>;
  calendar?: Maybe<CalendarType>;
  canadaVisa?: Maybe<CanadaVisaNode>;
  certificateandlicenses?: Maybe<Array<CertificateAndLicenseNode>>;
  currentEmployement?: Maybe<JobSeekerEmployeeType>;
  cv?: Maybe<GeneratedCvNode>;
  educations?: Maybe<Array<EducationNode>>;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  hasResume?: Maybe<Scalars["Boolean"]["output"]>;
  jobPositionAssignments?: Maybe<JobSeekerJobPositionAssignmentNodeConnection>;
  languagecertificates?: Maybe<Array<LanguageCertificateNode>>;
  lastName: Scalars["String"]["output"];
  notifications?: Maybe<Array<Maybe<InAppNotificationNode>>>;
  organizationMemberships: Array<OrganizationMembershipType>;
  pk?: Maybe<Scalars["Int"]["output"]>;
  profile?: Maybe<ProfileType>;
  referral?: Maybe<ReferralType>;
  relatedCalendarEvents?: Maybe<Array<Maybe<CalendarEventType>>>;
  resume?: Maybe<ResumeType>;
  secondaryEmail?: Maybe<Scalars["String"]["output"]>;
  supportTickets?: Maybe<Array<SupportTicketType>>;
  tasks: Array<UserTaskType>;
  verified?: Maybe<Scalars["Boolean"]["output"]>;
  workexperiences?: Maybe<Array<WorkExperienceNode>>;
};

export type UserNodeJobPositionAssignmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  createdAt_Gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAt_Lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  jobPosition_Status_In?: InputMaybe<Array<InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>>>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeeker_Profile_Score_Gte?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeeker_Profile_Score_Lte?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AuthAccountJobPositionAssignmentOrderByChoices>;
  status_In?: InputMaybe<Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>>;
};

export type UserRegister = {
  __typename?: "UserRegister";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserSetSkillsMutation = {
  __typename?: "UserSetSkillsMutation";
  user?: Maybe<UserNode>;
};

export type UserSkillInput = {
  skills: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type UserTaskType = {
  __typename?: "UserTaskType";
  status?: Maybe<AuthAccountUserTaskStatusChoices>;
  taskName: AuthAccountUserTaskTaskNameChoices;
};

export type UserUpdateMutation = {
  __typename?: "UserUpdateMutation";
  profile?: Maybe<ProfileType>;
};

export type VerifyAccount = {
  __typename?: "VerifyAccount";
  success?: Maybe<Scalars["Boolean"]["output"]>;
  /** The token required to set password after registration with password_reset */
  token?: Maybe<Scalars["String"]["output"]>;
};

export type WorkExperienceAiType = {
  __typename?: "WorkExperienceAIType";
  city?: Maybe<CityNode>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade?: Maybe<AuthAccountWorkExperienceGradeChoices>;
  industry?: Maybe<IndustryNode>;
  jobTitle?: Maybe<Scalars["String"]["output"]>;
  organization?: Maybe<Scalars["String"]["output"]>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start?: Maybe<Scalars["Date"]["output"]>;
};

export type WorkExperienceAnalyseAndExtractDataMutation = {
  __typename?: "WorkExperienceAnalyseAndExtractDataMutation";
  data?: Maybe<WorkExperienceAiType>;
  isValid?: Maybe<Scalars["Boolean"]["output"]>;
  verificationMethodData?: Maybe<WorkExperienceVerificationMethodType>;
};

export type WorkExperienceCreateMutation = {
  __typename?: "WorkExperienceCreateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceEmployerLetterMethodInput = {
  employerLetter: Scalars["ID"]["input"];
  employers?: InputMaybe<Array<InputMaybe<WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers>>>;
};

export type WorkExperienceEmployerLetterMethodInputExactEmployerLetterMethodEmployers = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  position: Scalars["String"]["input"];
};

export type WorkExperienceMutation = {
  __typename?: "WorkExperienceMutation";
  analyseAndExtractData?: Maybe<WorkExperienceAnalyseAndExtractDataMutation>;
  create?: Maybe<WorkExperienceCreateMutation>;
  update?: Maybe<WorkExperienceUpdateMutation>;
};

export type WorkExperienceMutationAnalyseAndExtractDataArgs = {
  fileId: Scalars["NotEmptyID"]["input"];
  verificationType: WorkExperienceVerificationMethodUploadType;
};

export type WorkExperienceMutationCreateArgs = {
  input: CreateWorkExperienceAndSetVerificationMethodInput;
};

export type WorkExperienceMutationUpdateArgs = {
  id: Scalars["ID"]["input"];
  input: PatchWorkExperienceInput;
};

export type WorkExperienceNode = {
  __typename?: "WorkExperienceNode";
  allowSelfVerification: Scalars["Boolean"]["output"];
  city: CityNode;
  createdAt: Scalars["DateTime"]["output"];
  employerlettermethod?: Maybe<EmployerLetterMethodType>;
  end?: Maybe<Scalars["Date"]["output"]>;
  grade: AuthAccountWorkExperienceGradeChoices;
  id: Scalars["ID"]["output"];
  jobTitle: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  paystubsmethod?: Maybe<PaystubsMethodType>;
  skills?: Maybe<Scalars["String"]["output"]>;
  start: Scalars["Date"]["output"];
  status: AuthAccountWorkExperienceStatusChoices;
  updatedAt: Scalars["DateTime"]["output"];
};

export type WorkExperienceQuery = {
  __typename?: "WorkExperienceQuery";
  get?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceQueryGetArgs = {
  id: Scalars["NotEmptyID"]["input"];
};

export type WorkExperienceUpdateMutation = {
  __typename?: "WorkExperienceUpdateMutation";
  workExperience?: Maybe<WorkExperienceNode>;
};

export type WorkExperienceVerificationMethodType = PaystubsMethodAiType | ReferenceCheckEmployerAiType;

/** An enumeration. */
export enum WorkExperienceVerificationMethodUploadType {
  /** Employer Letter File */
  EMPLOYER_LETTER = "EMPLOYER_LETTER",
  /** Paystubs File */
  PAYSTUBS = "PAYSTUBS",
}

export type CreateJobPositionMutationVariables = Exact<{
  organization: Scalars["ID"]["input"];
  employerQuestions?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>
  >;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>>;
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>
  >;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>
  >;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
  nativeLanguages?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>
  >;
  languages?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>
  >;
  degrees?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>
  >;
  daysOff?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>
  >;
  cities: Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateJobPositionMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      createJobPosition?: {
        __typename?: "OrganizationJobPositionCreateMutation";
        organizationJobPosition?: { __typename?: "OrganizationJobPositionNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type CreateJobPositionFromFileMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
  organizationId: Scalars["ID"]["input"];
}>;

export type CreateJobPositionFromFileMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      createJobPositionFromFile?: {
        __typename?: "OrganizationExtractJobPosition";
        jobPosition?: {
          __typename?: "OrganizationJobPositionNode";
          workingStartAt?: any | null;
          workingEndAt?: any | null;
          id: string;
          workExperienceYearsRange?: Array<number> | null;
          validityDate?: any | null;
          vaccancy?: number | null;
          title?: string | null;
          startAt?: any | null;
          salaryRange?: Array<number> | null;
          requiredDocuments?: Array<string> | null;
          ageRange?: Array<number> | null;
          contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
          daysOff?: Array<AuthAccountOrganizationJobPositionDaysOffChoices | null> | null;
          degrees?: Array<AuthAccountOrganizationJobPositionDegreesChoices | null> | null;
          description?: string | null;
          employerQuestions?: Array<string> | null;
          languages?: Array<AuthAccountOrganizationJobPositionLanguagesChoices | null> | null;
          locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
          nativeLanguages?: Array<AuthAccountOrganizationJobPositionNativeLanguagesChoices | null> | null;
          otherBenefits?: Array<string> | null;
          paymentTerm?: AuthAccountOrganizationJobPositionPaymentTermChoices | null;
          performanceExpectation?: string | null;
          skills?: Array<{ __typename?: "SkillType"; id: string; title: string }> | null;
          benefits?: Array<{ __typename?: "JobBenefitType"; id: string }> | null;
          cities: {
            __typename?: "CityNodeConnection";
            edges: Array<{ __typename?: "CityNodeEdge"; node?: { __typename?: "CityNode"; id: string } | null } | null>;
          };
          fields?: Array<{ __typename?: "FieldType"; name: string }> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type SetJobPositionCalendarSlotMutationVariables = Exact<{
  jobPositionId: Scalars["ID"]["input"];
  slots:
    | Array<InputMaybe<Scalars["DateTimeRangeScalar"]["input"]>>
    | InputMaybe<Scalars["DateTimeRangeScalar"]["input"]>;
}>;

export type SetJobPositionCalendarSlotMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      setJobPositionInterviewSlot?: {
        __typename?: "OrganizationJobPositionInterviewSlotSetMutation";
        overlappingInterviews?: Array<{
          __typename?: "JobPositionInterviewType";
          id: string;
          slot?: {
            __typename?: "JobPositionInterviewSlotType";
            datetime?: any | null;
            id: string;
            isAvailable?: boolean | null;
          } | null;
          event: {
            __typename?: "CalendarEventType";
            datetime?: any | null;
            meetUrl?: string | null;
            status: FlexCalendarCalendarEventStatusChoices;
            attendees?: Array<{
              __typename?: "CalendarEventAttendeeType";
              firstName?: string | null;
              id: string;
              lastName?: string | null;
            } | null> | null;
          };
        } | null> | null;
      } | null;
    } | null;
  };
};

export type SetVerificationMethodMutationVariables = Exact<{
  dnstxtrecordmethod?: InputMaybe<Scalars["String"]["input"]>;
  communicateorganizationmethod?: InputMaybe<CommunicateOrganizationMethodInput>;
  uploadcompanycertificatemethod?: InputMaybe<UploadCompanyCertificateMethodInput>;
  uploadfiletowebsitemethod?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["NotEmptyID"]["input"];
}>;

export type SetVerificationMethodMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      setVerificationMethod?: {
        __typename?: "OrganizationSetVerificationMethodMutation";
        success?: boolean | null;
        output?: any | null;
      } | null;
    } | null;
  };
};

export type UpdateEmployeeCooperationStatusMutationVariables = Exact<{
  status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
  id: Scalars["ID"]["input"];
}>;

export type UpdateEmployeeCooperationStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      updateEmployeeCooperationStatus?: {
        __typename?: "OrganizationEmployeeCooperationStatusUpdateMutation";
        organizationEmployeeCooperation?: { __typename?: "OrganizationEmployeeCooperationType"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UpdateJobPositionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  employerQuestions?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>
  >;
  benefits?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  salaryRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>>;
  ageRange?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  contractType?: InputMaybe<AuthAccountOrganizationJobPositionContractTypeChoices>;
  daysOff?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionDaysOffChoices>
  >;
  degrees?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionDegreesChoices>
  >;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fields?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  jobRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  locationType?: InputMaybe<AuthAccountOrganizationJobPositionLocationTypeChoices>;
  nativeLanguages?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionNativeLanguagesChoices>
  >;
  languages?: InputMaybe<
    | Array<InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>>
    | InputMaybe<AuthAccountOrganizationJobPositionLanguagesChoices>
  >;
  otherBenefits?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>>;
  paymentTerm?: InputMaybe<AuthAccountOrganizationJobPositionPaymentTermChoices>;
  performanceExpectation?: InputMaybe<Scalars["String"]["input"]>;
  requiredDocuments?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>> | InputMaybe<Scalars["String"]["input"]>
  >;
  skills?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>> | InputMaybe<Scalars["ID"]["input"]>>;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  vaccancy?: InputMaybe<Scalars["Int"]["input"]>;
  validityDays?: InputMaybe<Scalars["Int"]["input"]>;
  workExperienceYearsRange?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>> | InputMaybe<Scalars["Int"]["input"]>
  >;
  workingEndAt?: InputMaybe<Scalars["Time"]["input"]>;
  workingStartAt?: InputMaybe<Scalars["Time"]["input"]>;
  hiringInCanada?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateJobPositionMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      updateJobPosition?: {
        __typename?: "OrganizationJobPositionUpdateMutation";
        organizationJobPosition?: { __typename?: "OrganizationJobPositionNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UpdateJobPositionAssignmentStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  status: AuthAccountJobPositionAssignmentStatusChoices;
  startAt?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type UpdateJobPositionAssignmentStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      updateJobPositionAssignmentStatus?: {
        __typename?: "JobPositionAssignmentStatusUpdateMutation";
        jobPositionAssignment?: { __typename?: "JobPositionAssignmentNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UpdateJobPositionStatusMutationVariables = Exact<{
  status: AuthAccountOrganizationJobPositionStatusChoices;
  id: Scalars["ID"]["input"];
}>;

export type UpdateJobPositionStatusMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      updateJobPositionStatus?: {
        __typename?: "OrganizationJobPositionStatusUpdateMutation";
        organizationJobPosition?: { __typename?: "OrganizationJobPositionNode"; id: string } | null;
      } | null;
    } | null;
  };
};

export type UpdateAvatarMutationVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  logo?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type UpdateAvatarMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      update?: {
        __typename?: "OrganizationUpdateMutation";
        organization?: {
          __typename?: "OrganizationType";
          id: string;
          logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateProfileMutationVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  nationalNumber?: InputMaybe<Scalars["String"]["input"]>;
  shortName?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  about?: InputMaybe<Scalars["String"]["input"]>;
  industry?: InputMaybe<Scalars["ID"]["input"]>;
  businessType?: InputMaybe<AuthAccountOrganizationBusinessTypeChoices>;
  type?: InputMaybe<AuthAccountOrganizationTypeChoices>;
  size?: InputMaybe<AuthAccountOrganizationSizeChoices>;
  contacts: Array<InputMaybe<SetOrganizationContactableInput>> | InputMaybe<SetOrganizationContactableInput>;
  establishedAt?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type UpdateProfileMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      setContacts?: {
        __typename?: "SetOrganizationContactsMutation";
        contacts?: Array<{ __typename?: "ContactType"; id: string } | null> | null;
      } | null;
      update?: {
        __typename?: "OrganizationUpdateMutation";
        organization?: {
          __typename?: "OrganizationType";
          id: string;
          about?: string | null;
          businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
          establishedAt?: any | null;
          hasFinancialData?: boolean | null;
          name: string;
          nationalNumber?: string | null;
          shortName?: string | null;
          size?: AuthAccountOrganizationSizeChoices | null;
          status: AuthAccountOrganizationStatusChoices;
          type?: AuthAccountOrganizationTypeChoices | null;
          email?: string | null;
          industry?: { __typename?: "IndustryNode"; id: string; title: string } | null;
          logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
          contacts?: Array<{
            __typename?: "ContactType";
            id: string;
            type: AuthAccountContactTypeChoices;
            value: string;
          } | null> | null;
          city?: { __typename?: "CityNode"; id: string } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type VerifyOrganizationMutationVariables = Exact<{
  organization: Scalars["NotEmptyID"]["input"];
  otp: Scalars["String"]["input"];
}>;

export type VerifyOrganizationMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      verify?: { __typename?: "OrganizationVerify"; success?: boolean | null } | null;
    } | null;
  };
};

export type AccountPasswordResetMutationVariables = Exact<{
  newPassword1: Scalars["String"]["input"];
  newPassword2: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountPasswordResetMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    passwordReset?: { __typename?: "PasswordReset"; success?: boolean | null } | null;
  };
};

export type AccountRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRefreshTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    refreshToken?: {
      __typename?: "RefreshToken";
      token?: string | null;
      success?: boolean | null;
      payload?: any | null;
    } | null;
  };
};

export type AccountRegisterMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  website: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountRegisterMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    organization?: {
      __typename?: "OrganizationMutation";
      register?: { __typename?: "RegisterOrganization"; success?: boolean | null } | null;
    } | null;
  };
};

export type AccountResendActivationEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountResendActivationEmailMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    resendActivationEmail?: { __typename?: "ResendActivationEmail"; success?: boolean | null } | null;
  };
};

export type AccountRevokeTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type AccountRevokeTokenMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    revokeToken?: { __typename?: "RevokeTokenMutation"; success?: boolean | null } | null;
  };
};

export type AccountSendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  emailCallbackUrl: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountSendPasswordResetEmailMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    sendPasswordResetEmail?: { __typename?: "SendPasswordResetEmail"; success?: boolean | null } | null;
  };
};

export type CreateSupportTicketMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  priority: AuthAccountSupportTicketPriorityChoices;
  category: Scalars["ID"]["input"];
  contactMethod: AuthAccountSupportTicketContactMethodChoices;
  contactValue: Scalars["String"]["input"];
}>;

export type CreateSupportTicketMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    supportTicket?: {
      __typename?: "SupportTicketMutation";
      create?: {
        __typename?: "SupportTicketCreateMutation";
        supportTicket?: { __typename?: "SupportTicketType"; id: string; ticketId: string } | null;
      } | null;
    } | null;
  };
};

export type AccountTokenAuthMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  deviceId: Scalars["String"]["input"];
  gRecaptchaToken: Scalars["String"]["input"];
}>;

export type AccountTokenAuthMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    tokenAuth?: {
      __typename?: "ObtainJSONWebToken";
      token?: string | null;
      success?: boolean | null;
      refreshExpiresIn?: number | null;
      payload?: any | null;
      refreshToken?: string | null;
      user?: {
        __typename?: "UserNode";
        organizationMemberships: Array<{
          __typename?: "OrganizationMembershipType";
          organization?: { __typename?: "OrganizationType"; id: string } | null;
        }>;
      } | null;
    } | null;
  };
};

export type AccountVerifyMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type AccountVerifyMutation = {
  __typename?: "Mutation";
  account: {
    __typename?: "AccountMutation";
    verify?: { __typename?: "VerifyAccount"; success?: boolean | null; token?: string | null } | null;
  };
};

export type CommonUploadFileMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
  type: UploadType;
}>;

export type CommonUploadFileMutation = {
  __typename?: "Mutation";
  common: {
    __typename?: "CommonMutation";
    uploadFile?: { __typename?: "UploadFileMutation"; pk?: number | null } | null;
  };
};

export type GetEventsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEventsQuery = {
  __typename?: "Query";
  calendar?: {
    __typename?: "CalendarQuery";
    calendars?: Array<{
      __typename?: "CalendarType";
      events: Array<{
        __typename?: "CalendarEventType";
        status: FlexCalendarCalendarEventStatusChoices;
        datetime?: any | null;
        meetUrl?: string | null;
        attendees?: Array<{
          __typename?: "CalendarEventAttendeeType";
          lastName?: string | null;
          id: string;
          firstName?: string | null;
        } | null> | null;
        relatedObject?: {
          __typename?: "CalendarEventRelatedObjectType";
          pk?: string | null;
          key?: CalendarEventObjectType | null;
        } | null;
      }>;
    } | null> | null;
  } | null;
};

export type GetCitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  region?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCitiesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    cities?: {
      __typename?: "CityNodeConnection";
      edges: Array<{
        __typename?: "CityNodeEdge";
        node?: { __typename?: "CityNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetCountriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetCountriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    countries?: {
      __typename?: "CountryNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "CountryNodeEdge";
        node?: { __typename?: "CountryNode"; name: string; id: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetJobBenefitsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetJobBenefitsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    jobBenefits?: {
      __typename?: "JobBenefitNodeConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "JobBenefitNodeEdge";
        node?: { __typename?: "JobBenefitNode"; id: string; name: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetSkillsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetSkillsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    skills?: {
      __typename?: "SkillNodeConnection";
      edges: Array<{
        __typename?: "SkillNodeEdge";
        node?: { __typename?: "SkillNode"; id: string; title: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetIndustriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetIndustriesQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    industries?: {
      __typename?: "IndustryNodeConnection";
      edges: Array<{
        __typename?: "IndustryNodeEdge";
        node?: { __typename?: "IndustryNode"; id: string; title: string } | null;
      } | null>;
    } | null;
  } | null;
};

export type GetRegionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetRegionsQuery = {
  __typename?: "Query";
  common?: {
    __typename?: "CommonQuery";
    regions?: {
      __typename?: "RegionNodeConnection";
      edges: Array<{
        __typename?: "RegionNodeEdge";
        node?: { __typename?: "RegionNode"; id: string; name: string } | null;
      } | null>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    } | null;
  } | null;
};

export type GetOrganizationInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganizationInfoQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    organizationMemberships: Array<{
      __typename?: "OrganizationMembershipType";
      organization?: {
        __typename?: "OrganizationType";
        id: string;
        type?: AuthAccountOrganizationTypeChoices | null;
        status: AuthAccountOrganizationStatusChoices;
        size?: AuthAccountOrganizationSizeChoices | null;
        shortName?: string | null;
        nationalNumber?: string | null;
        name: string;
        hasFinancialData?: boolean | null;
        establishedAt?: any | null;
        businessType?: AuthAccountOrganizationBusinessTypeChoices | null;
        about?: string | null;
        email?: string | null;
        logo?: { __typename?: "OrganizationLogoFileType"; file: string } | null;
        industry?: { __typename?: "IndustryNode"; id: string; title: string } | null;
        contacts?: Array<{
          __typename?: "ContactType";
          id: string;
          type: AuthAccountContactTypeChoices;
          value: string;
        } | null> | null;
        city?: { __typename?: "CityNode"; id: string } | null;
      } | null;
    }>;
  } | null;
};

export type GetSupportTicketCategoryQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  types_Contains?: InputMaybe<
    | Array<InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>>
    | InputMaybe<AuthAccountSupportTicketCategoryTypesChoices>
  >;
}>;

export type GetSupportTicketCategoryQuery = {
  __typename?: "Query";
  supportTicketCategory?: {
    __typename?: "SupportTicketCategoryNodeConnection";
    edges: Array<{
      __typename?: "SupportTicketCategoryNodeEdge";
      node?: { __typename?: "SupportTicketCategoryNode"; id: string; title: string } | null;
    } | null>;
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  } | null;
};

export type GetSupportTicketsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportTicketsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "UserNode";
    supportTickets?: Array<{
      __typename?: "SupportTicketType";
      contactMethod: AuthAccountSupportTicketContactMethodChoices;
      contactValue: string;
      created: any;
      description: string;
      id: string;
      priority: AuthAccountSupportTicketPriorityChoices;
      status: AuthAccountSupportTicketStatusChoices;
      ticketId: string;
      title: string;
      modified: any;
      category: { __typename?: "SupportTicketCategoryNode"; title: string; id: string };
    }> | null;
  } | null;
};

export type GetCooperationsPlatformMessagesQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetCooperationsPlatformMessagesQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    employee?: {
      __typename?: "OrganizationEmployeeQuery";
      get?: {
        __typename?: "OrganizationEmployeeNode";
        cooperations?: Array<{
          __typename?: "OrganizationEmployeeCooperationType";
          platformMessages?: {
            __typename?: "OrganizationPlatformMessageNodeConnection";
            edges: Array<{
              __typename?: "OrganizationPlatformMessageNodeEdge";
              node?: {
                __typename?: "OrganizationPlatformMessageNode";
                title: string;
                text: string;
                source: AuthAccountOrganizationPlatformMessageSourceChoices;
                readAt?: any | null;
                created: any;
                id: string;
                attachments: Array<{
                  __typename?: "OrganizationPlatformMessageAttachmentType";
                  id: string;
                  text: string;
                  file?: { __typename?: "BaseFileModelType"; file: string } | null;
                  courseResult?: {
                    __typename?: "CourseResultType";
                    status: AcademyCourseResultStatusChoices;
                    course: { __typename?: "CourseNode"; name: string; logo?: string | null };
                  } | null;
                  course?: { __typename?: "CourseNode"; name: string; logo?: string | null } | null;
                }>;
              } | null;
            } | null>;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetEmployeeByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetEmployeeByIdQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    employee?: {
      __typename?: "OrganizationEmployeeQuery";
      get?: {
        __typename?: "OrganizationEmployeeNode";
        id: string;
        employee?: {
          __typename?: "EmployeeType";
          email: string;
          firstName: string;
          lastName: string;
          profile?: {
            __typename?: "JobSeekerProfileType";
            score: number;
            birthDate?: any | null;
            gender?: AuthAccountProfileGenderChoices | null;
            contacts?: Array<{
              __typename?: "ContactType";
              id: string;
              type: AuthAccountContactTypeChoices;
              value: string;
            } | null> | null;
            avatar?: { __typename?: "AvatarFileType"; file: string } | null;
            city?: {
              __typename?: "CityNode";
              name: string;
              region?: { __typename?: "RegionNode"; name: string } | null;
              country: { __typename?: "CountryNode"; name: string };
            } | null;
          } | null;
          certificateandlicenses?: Array<{
            __typename?: "JobSeekerCertificateAndLicenseType";
            certifier: string;
            expiredAt?: any | null;
            id: string;
            issuedAt: any;
            status: AuthAccountCertificateAndLicenseStatusChoices;
            title: string;
            certificateandlicenseofflineverificationmethod?: {
              __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
              certificateFile: { __typename?: "CertificateFileType"; file: string };
            } | null;
            certificateandlicenseonlineverificationmethod?: {
              __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
              certificateLink: string;
            } | null;
          }> | null;
          cv?: { __typename?: "JobSeekerGeneratedCVType"; file: string } | null;
          educations?: Array<{
            __typename?: "JobSeekerEducationType";
            degree: AuthAccountEducationDegreeChoices;
            end?: any | null;
            start: any;
            status: AuthAccountEducationStatusChoices;
            city: { __typename?: "CityNode"; id: string; country: { __typename?: "CountryNode"; name: string } };
            field: { __typename?: "FieldType"; name: string };
            university: { __typename?: "UniversityNode"; name: string };
            communicationmethod?: {
              __typename?: "CommunicationMethodType";
              degreeFile: { __typename?: "DegreeFileType"; file: string };
            } | null;
            ieemethod?: {
              __typename?: "IEEMethodType";
              educationEvaluationDocument: { __typename?: "EducationEvaluationDocumentFileType"; file: string };
            } | null;
          }> | null;
          workexperiences?: Array<{
            __typename?: "JobSeekerWorkExperienceType";
            end?: any | null;
            grade: AuthAccountWorkExperienceGradeChoices;
            id: string;
            jobTitle: string;
            organization: string;
            start: any;
            status: AuthAccountWorkExperienceStatusChoices;
            city: { __typename?: "CityNode"; name: string; id: string };
            employerlettermethod?: {
              __typename?: "EmployerLetterMethodType";
              employerLetter: { __typename?: "EmployerLetterFileType"; file: string };
            } | null;
            paystubsmethod?: {
              __typename?: "PaystubsMethodType";
              paystubs: { __typename?: "PaystubsFileType"; file: string };
            } | null;
          }> | null;
          languagecertificates?: Array<{
            __typename?: "JobSeekerLanguageCertificateType";
            expiredAt?: any | null;
            id: string;
            issuedAt: any;
            language: AuthAccountLanguageCertificateLanguageChoices;
            status: AuthAccountLanguageCertificateStatusChoices;
            test?: { __typename?: "LanguageProficiencyTestNode"; title: string } | null;
            onlinemethod?: {
              __typename?: "LanguageCertificateOnlineVerificationMethodType";
              certificateLink: string;
            } | null;
            offlinemethod?: {
              __typename?: "LanguageCertificateOfflineVerificationMethodType";
              certificateFile: { __typename?: "LanguageCertificateFileType"; file: string };
            } | null;
          }> | null;
          resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
        } | null;
        cooperations?: Array<{
          __typename?: "OrganizationEmployeeCooperationType";
          id: string;
          endAt?: any | null;
          createdAt: any;
          startAt?: any | null;
          status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
          jobPosition?: {
            __typename?: "OrganizationJobPositionNode";
            title?: string | null;
            locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
            contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetEmployeeCoursesQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEmployeeCoursesQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    employee?: {
      __typename?: "OrganizationEmployeeQuery";
      get?: {
        __typename?: "OrganizationEmployeeNode";
        employee?: {
          __typename?: "EmployeeType";
          courses?: {
            __typename?: "CourseNodeConnection";
            edges: Array<{
              __typename?: "CourseNodeEdge";
              node?: {
                __typename?: "CourseNode";
                description: string;
                externalId: string;
                id: string;
                logo?: string | null;
                name: string;
                results: {
                  __typename?: "CourseResultTypeConnection";
                  edges: Array<{
                    __typename?: "CourseResultTypeEdge";
                    node?: { __typename?: "CourseResultType"; status: AcademyCourseResultStatusChoices } | null;
                  } | null>;
                };
                industries: {
                  __typename?: "IndustryNodeConnection";
                  edges: Array<{
                    __typename?: "IndustryNodeEdge";
                    node?: { __typename?: "IndustryNode"; id: string; title: string } | null;
                  } | null>;
                };
              } | null;
            } | null>;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetEmployeeJobAssessmentsQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetEmployeeJobAssessmentsQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    employee?: {
      __typename?: "OrganizationEmployeeQuery";
      get?: {
        __typename?: "OrganizationEmployeeNode";
        employee?: {
          __typename?: "EmployeeType";
          assessments?: Array<{
            __typename?: "OrganizationAssessmentType";
            title: string;
            status: Status;
            description: string;
            id: string;
            remainingQuestions: number;
            totalEstimatedTime: number;
            totalQuestions: number;
            skill?: { __typename?: "AssessmentSkillType"; description: string; title: string } | null;
            results?: Array<{
              __typename?: "OrganizationAssessmentResultType";
              evaluation?: {
                __typename?: "OrganizationEvaluationType";
                score: Score;
                userFeedback: string;
                negativePoints: Array<string | null>;
                positivePoints: Array<string | null>;
                scoreReasoning: string;
                scoreValue?: any | null;
              } | null;
              question: { __typename?: "AssessmentResultQuestionType"; text: string };
            } | null> | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetEmployeesQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  jobPosition?: InputMaybe<Scalars["ID"]["input"]>;
  fullName?: InputMaybe<Scalars["String"]["input"]>;
  hiringStatus?: InputMaybe<AuthAccountOrganizationEmployeeCooperationStatusChoices>;
  organization?: InputMaybe<Scalars["ID"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEmployeesQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    employee?: {
      __typename?: "OrganizationEmployeeQuery";
      list?: {
        __typename?: "OrganizationEmployeeNodeConnection";
        totalCount?: number | null;
        edges: Array<{
          __typename?: "OrganizationEmployeeNodeEdge";
          node?: {
            __typename?: "OrganizationEmployeeNode";
            id: string;
            employee?: {
              __typename?: "EmployeeType";
              email: string;
              firstName: string;
              lastName: string;
              profile?: {
                __typename?: "JobSeekerProfileType";
                score: number;
                contacts?: Array<{
                  __typename?: "ContactType";
                  id: string;
                  type: AuthAccountContactTypeChoices;
                  value: string;
                } | null> | null;
                avatar?: { __typename?: "AvatarFileType"; file: string } | null;
              } | null;
            } | null;
            cooperations?: Array<{
              __typename?: "OrganizationEmployeeCooperationType";
              id: string;
              status: AuthAccountOrganizationEmployeeCooperationStatusChoices;
              endAt?: any | null;
              createdAt: any;
              startAt?: any | null;
              jobPosition?: {
                __typename?: "OrganizationJobPositionNode";
                title?: string | null;
                locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
              } | null;
            } | null> | null;
          } | null;
        } | null>;
        pageInfo: {
          __typename?: "PageInfo";
          endCursor?: string | null;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor?: string | null;
        };
      } | null;
    } | null;
  } | null;
};

export type GetJobPositionAssignmentQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetJobPositionAssignmentQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPositionAssignment?: {
      __typename?: "JobPositionAssignmentNode";
      createdAt: any;
      id: string;
      status: AuthAccountJobPositionAssignmentStatusChoices;
      hasActiveCooperationInOtherOrganizations?: boolean | null;
      statusHistories?: Array<{
        __typename?: "JobPositionAssignmentStatusHistoryType";
        createdAt: any;
        status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
        interview?: {
          __typename?: "JobPositionInterviewDetailType";
          id: string;
          slot?: {
            __typename?: "JobPositionInterviewSlotType";
            datetime?: any | null;
            isAvailable?: boolean | null;
            id: string;
          } | null;
        } | null;
      } | null> | null;
      interviews?: Array<{
        __typename?: "JobPositionInterviewType";
        id: string;
        slot?: {
          __typename?: "JobPositionInterviewSlotType";
          datetime?: any | null;
          isAvailable?: boolean | null;
          id: string;
        } | null;
        event: {
          __typename?: "CalendarEventType";
          datetime?: any | null;
          meetUrl?: string | null;
          status: FlexCalendarCalendarEventStatusChoices;
          attendees?: Array<{
            __typename?: "CalendarEventAttendeeType";
            firstName?: string | null;
            id: string;
            lastName?: string | null;
          } | null> | null;
          relatedObject?: {
            __typename?: "CalendarEventRelatedObjectType";
            key?: CalendarEventObjectType | null;
            pk?: string | null;
          } | null;
        };
      } | null> | null;
      jobSeeker?:
        | {
            __typename: "JobSeekerPrimitiveType";
            firstName: string;
            lastName: string;
            profile?: {
              __typename?: "JobSeekerProfilePrimitiveType";
              score: number;
              avatar?: { __typename?: "AvatarFileType"; file: string } | null;
            } | null;
          }
        | {
            __typename: "JobSeekerType";
            firstName: string;
            lastName: string;
            email: string;
            workexperiences?: Array<{
              __typename?: "JobSeekerWorkExperienceType";
              end?: any | null;
              grade: AuthAccountWorkExperienceGradeChoices;
              id: string;
              jobTitle: string;
              organization: string;
              start: any;
              status: AuthAccountWorkExperienceStatusChoices;
              city: { __typename?: "CityNode"; name: string; id: string };
              employerlettermethod?: {
                __typename?: "EmployerLetterMethodType";
                employerLetter: { __typename?: "EmployerLetterFileType"; file: string };
              } | null;
              paystubsmethod?: {
                __typename?: "PaystubsMethodType";
                paystubs: { __typename?: "PaystubsFileType"; file: string };
              } | null;
            }> | null;
            certificateandlicenses?: Array<{
              __typename?: "JobSeekerCertificateAndLicenseType";
              certifier: string;
              expiredAt?: any | null;
              id: string;
              issuedAt: any;
              status: AuthAccountCertificateAndLicenseStatusChoices;
              title: string;
              certificateandlicenseofflineverificationmethod?: {
                __typename?: "CertificateAndLicenseOfflineVerificationMethodType";
                certificateFile: { __typename?: "CertificateFileType"; file: string };
              } | null;
              certificateandlicenseonlineverificationmethod?: {
                __typename?: "CertificateAndLicenseOnlineVerificationMethodType";
                certificateLink: string;
              } | null;
            }> | null;
            languagecertificates?: Array<{
              __typename?: "JobSeekerLanguageCertificateType";
              expiredAt?: any | null;
              id: string;
              issuedAt: any;
              language: AuthAccountLanguageCertificateLanguageChoices;
              status: AuthAccountLanguageCertificateStatusChoices;
              test?: { __typename?: "LanguageProficiencyTestNode"; title: string } | null;
              onlinemethod?: {
                __typename?: "LanguageCertificateOnlineVerificationMethodType";
                certificateLink: string;
              } | null;
              offlinemethod?: {
                __typename?: "LanguageCertificateOfflineVerificationMethodType";
                certificateFile: { __typename?: "LanguageCertificateFileType"; file: string };
              } | null;
            }> | null;
            cv?: {
              __typename?: "JobSeekerGeneratedCVType";
              file: string;
              modified: any;
              aboutMe?: string | null;
            } | null;
            educations?: Array<{
              __typename?: "JobSeekerEducationType";
              degree: AuthAccountEducationDegreeChoices;
              end?: any | null;
              start: any;
              status: AuthAccountEducationStatusChoices;
              city: { __typename?: "CityNode"; id: string; country: { __typename?: "CountryNode"; name: string } };
              field: { __typename?: "FieldType"; name: string };
              university: { __typename?: "UniversityNode"; name: string };
              communicationmethod?: {
                __typename?: "CommunicationMethodType";
                degreeFile: { __typename?: "DegreeFileType"; file: string };
              } | null;
              ieemethod?: {
                __typename?: "IEEMethodType";
                educationEvaluationDocument: { __typename?: "EducationEvaluationDocumentFileType"; file: string };
              } | null;
            }> | null;
            resume?: { __typename?: "ResumeType"; file: { __typename?: "ResumeFileType"; file: string } } | null;
            profile?: {
              __typename?: "JobSeekerProfileType";
              score: number;
              avatar?: { __typename?: "AvatarFileType"; file: string } | null;
              contacts?: Array<{
                __typename?: "ContactType";
                value: string;
                type: AuthAccountContactTypeChoices;
                id: string;
              } | null> | null;
              fullBodyImage?: { __typename?: "FullBodyImageFileType"; file: string } | null;
              city?: { __typename?: "CityNode"; name: string } | null;
            } | null;
          }
        | null;
      jobPosition?: { __typename?: "OrganizationJobPositionNode"; id: string } | null;
    } | null;
  } | null;
};

export type GetJobPositionByIdQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetJobPositionByIdQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      get?: {
        __typename?: "OrganizationJobPositionNode";
        isEditable?: boolean | null;
        ageRange?: Array<number> | null;
        contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
        daysOff?: Array<AuthAccountOrganizationJobPositionDaysOffChoices | null> | null;
        degrees?: Array<AuthAccountOrganizationJobPositionDegreesChoices | null> | null;
        description?: string | null;
        employerQuestions?: Array<string> | null;
        id: string;
        jobRestrictions?: string | null;
        languages?: Array<AuthAccountOrganizationJobPositionLanguagesChoices | null> | null;
        locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
        nativeLanguages?: Array<AuthAccountOrganizationJobPositionNativeLanguagesChoices | null> | null;
        otherBenefits?: Array<string> | null;
        paymentTerm?: AuthAccountOrganizationJobPositionPaymentTermChoices | null;
        performanceExpectation?: string | null;
        requiredDocuments?: Array<string> | null;
        salaryRange?: Array<number> | null;
        startAt?: any | null;
        status: AuthAccountOrganizationJobPositionStatusChoices;
        title?: string | null;
        vaccancy?: number | null;
        validityDate?: any | null;
        validityDays?: number | null;
        workExperienceYearsRange?: Array<number> | null;
        workingEndAt?: any | null;
        workingStartAt?: any | null;
        hiringInCanada?: boolean | null;
        benefits?: Array<{ __typename?: "JobBenefitType"; id: string; name: string }> | null;
        fields?: Array<{ __typename?: "FieldType"; id: string; name: string }> | null;
        skills?: Array<{ __typename?: "SkillType"; id: string; title: string }> | null;
        cities: {
          __typename?: "CityNodeConnection";
          edges: Array<{
            __typename?: "CityNodeEdge";
            node?: {
              __typename?: "CityNode";
              name: string;
              id: string;
              country: { __typename?: "CountryNode"; id: string; name: string };
              region?: { __typename?: "RegionNode"; id: string; name: string } | null;
            } | null;
          } | null>;
        };
      } | null;
    } | null;
  } | null;
};

export type GetJobPositionInterviewQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetJobPositionInterviewQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPositionInterview?: {
      __typename?: "JobPositionInterviewDetailType";
      id: string;
      jobPosition?: {
        __typename?: "OrganizationJobPositionNode";
        id: string;
        title?: string | null;
        status: AuthAccountOrganizationJobPositionStatusChoices;
        paymentTerm?: AuthAccountOrganizationJobPositionPaymentTermChoices | null;
        locationType?: AuthAccountOrganizationJobPositionLocationTypeChoices | null;
        startAt?: any | null;
        vaccancy?: number | null;
        validityDays?: number | null;
        workExperienceYearsRange?: Array<number> | null;
        salaryRange?: Array<number> | null;
        contractType?: AuthAccountOrganizationJobPositionContractTypeChoices | null;
        assignments?: {
          __typename?: "JobPositionAssignmentNodeConnection";
          edges: Array<{
            __typename?: "JobPositionAssignmentNodeEdge";
            node?: { __typename?: "JobPositionAssignmentNode"; createdAt: any } | null;
          } | null>;
        } | null;
        skills?: Array<{ __typename?: "SkillType"; title: string }> | null;
        fields?: Array<{ __typename?: "FieldType"; name: string }> | null;
      } | null;
      jobPositionAssignment?: {
        __typename?: "JobPositionAssignmentNode";
        id: string;
        jobSeeker?:
          | { __typename?: "JobSeekerPrimitiveType" }
          | {
              __typename: "JobSeekerType";
              firstName: string;
              lastName: string;
              email: string;
              educations?: Array<{
                __typename?: "JobSeekerEducationType";
                degree: AuthAccountEducationDegreeChoices;
                end?: any | null;
                university: { __typename?: "UniversityNode"; name: string };
                field: { __typename?: "FieldType"; name: string };
              }> | null;
              profile?: {
                __typename?: "JobSeekerProfileType";
                gender?: AuthAccountProfileGenderChoices | null;
                score: number;
                birthDate?: any | null;
                avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                contacts?: Array<{
                  __typename?: "ContactType";
                  value: string;
                  type: AuthAccountContactTypeChoices;
                } | null> | null;
              } | null;
            }
          | null;
        interviews?: Array<{
          __typename?: "JobPositionInterviewType";
          event: {
            __typename?: "CalendarEventType";
            meetUrl?: string | null;
            status: FlexCalendarCalendarEventStatusChoices;
            datetime?: any | null;
          };
          slot?: {
            __typename?: "JobPositionInterviewSlotType";
            isAvailable?: boolean | null;
            datetime?: any | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type GetJobPositionInterviewTimeSlotsQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetJobPositionInterviewTimeSlotsQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      get?: {
        __typename?: "OrganizationJobPositionNode";
        interviewSlots: Array<{
          __typename?: "JobPositionInterviewSlotType";
          datetime?: any | null;
          id: string;
          isAvailable?: boolean | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type GetJobPositionReportQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
}>;

export type GetJobPositionReportQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      get?: {
        __typename?: "OrganizationJobPositionNode";
        report?: {
          __typename?: "OrganizationJobPositionReportType";
          assignmentStatusCounts?: Array<{
            __typename?: "JobPositionAssignmentStatusCountType";
            count?: number | null;
            status?: string | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetJobPositionsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetJobPositionsQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      list?: {
        __typename?: "OrganizationJobPositionNodeConnection";
        totalCount?: number | null;
        edges: Array<{
          __typename?: "OrganizationJobPositionNodeEdge";
          node?: {
            __typename?: "OrganizationJobPositionNode";
            id: string;
            status: AuthAccountOrganizationJobPositionStatusChoices;
            title?: string | null;
            validityDate?: any | null;
            assignments?: {
              __typename?: "JobPositionAssignmentNodeConnection";
              edges: Array<{
                __typename?: "JobPositionAssignmentNodeEdge";
                node?: {
                  __typename?: "JobPositionAssignmentNode";
                  id: string;
                  status: AuthAccountJobPositionAssignmentStatusChoices;
                } | null;
              } | null>;
            } | null;
            skills?: Array<{ __typename?: "SkillType"; id: string; title: string }> | null;
          } | null;
        } | null>;
        pageInfo: {
          __typename?: "PageInfo";
          endCursor?: string | null;
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor?: string | null;
        };
      } | null;
    } | null;
  } | null;
};

export type MyQueryQueryVariables = Exact<{
  status?: InputMaybe<AuthAccountOrganizationJobPositionStatusChoices>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type MyQueryQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      list?: { __typename?: "OrganizationJobPositionNodeConnection"; totalCount?: number | null } | null;
    } | null;
  } | null;
};

export type GetOrganizationStatisticsQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  organizationNotEmptyId: Scalars["NotEmptyID"]["input"];
}>;

export type GetOrganizationStatisticsQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPositionAssignmentStatistics?: {
      __typename?: "JobPositionAssignmentStatisticsType";
      rejectedCount?: number | null;
      rejectedByJobseekerCount?: number | null;
      notReviewedCount?: number | null;
      interviewScheduledCount?: number | null;
      acceptedCount?: number | null;
      awaitingInterviewDateCount?: number | null;
      awaitingJobseekerApprovalCount?: number | null;
      interviewCanceledCount?: number | null;
      interviewDoneCount?: number | null;
    } | null;
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      list?: { __typename?: "OrganizationJobPositionNodeConnection"; totalCount?: number | null } | null;
    } | null;
  } | null;
};

export type GetResumesQueryVariables = Exact<{
  id: Scalars["NotEmptyID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  jobSeekerFullName?: InputMaybe<Scalars["String"]["input"]>;
  jobSeekerProfileScoreGte?: InputMaybe<Scalars["Int"]["input"]>;
  createdAtGte?: InputMaybe<Scalars["DateTime"]["input"]>;
  statusIn?: InputMaybe<
    | Array<InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>>
    | InputMaybe<AuthAccountJobPositionAssignmentStatusChoices>
  >;
}>;

export type GetResumesQuery = {
  __typename?: "Query";
  organization?: {
    __typename?: "OrganizationQuery";
    jobPosition?: {
      __typename?: "OrganizationJobPositionQuery";
      get?: {
        __typename?: "OrganizationJobPositionNode";
        assignments?: {
          __typename?: "JobPositionAssignmentNodeConnection";
          totalCount?: number | null;
          edges: Array<{
            __typename?: "JobPositionAssignmentNodeEdge";
            node?: {
              __typename?: "JobPositionAssignmentNode";
              createdAt: any;
              id: string;
              status: AuthAccountJobPositionAssignmentStatusChoices;
              interviews?: Array<{
                __typename?: "JobPositionInterviewType";
                id: string;
                slot?: {
                  __typename?: "JobPositionInterviewSlotType";
                  datetime?: any | null;
                  id: string;
                  isAvailable?: boolean | null;
                } | null;
              } | null> | null;
              statusHistories?: Array<{
                __typename?: "JobPositionAssignmentStatusHistoryType";
                createdAt: any;
                status: AuthAccountJobPositionAssignmentStatusHistoryStatusChoices;
              } | null> | null;
              jobSeeker?:
                | {
                    __typename: "JobSeekerPrimitiveType";
                    firstName: string;
                    lastName: string;
                    profile?: {
                      __typename?: "JobSeekerProfilePrimitiveType";
                      score: number;
                      avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                    } | null;
                  }
                | {
                    __typename: "JobSeekerType";
                    email: string;
                    firstName: string;
                    lastName: string;
                    profile?: {
                      __typename?: "JobSeekerProfileType";
                      score: number;
                      avatar?: { __typename?: "AvatarFileType"; file: string } | null;
                    } | null;
                    resume?: {
                      __typename?: "ResumeType";
                      file: { __typename?: "ResumeFileType"; file: string };
                    } | null;
                    workexperiences?: Array<{
                      __typename?: "JobSeekerWorkExperienceType";
                      organization: string;
                      jobTitle: string;
                    }> | null;
                  }
                | null;
            } | null;
          } | null>;
          pageInfo: {
            __typename?: "PageInfo";
            endCursor?: string | null;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor?: string | null;
          };
        } | null;
      } | null;
    } | null;
  } | null;
};

export const CreateJobPositionDocument = gql`
  mutation CreateJobPosition(
    $organization: ID!
    $employerQuestions: [String]
    $benefits: [ID]
    $salaryRange: [Int]
    $ageRange: [Int]
    $contractType: AuthAccountOrganizationJobPositionContractTypeChoices
    $description: String
    $fields: [ID]
    $jobRestrictions: String
    $locationType: AuthAccountOrganizationJobPositionLocationTypeChoices
    $otherBenefits: [String]
    $paymentTerm: AuthAccountOrganizationJobPositionPaymentTermChoices
    $performanceExpectation: String
    $requiredDocuments: [String]
    $skills: [ID]
    $startAt: Date
    $title: String
    $vaccancy: Int
    $validityDays: Int
    $workExperienceYearsRange: [Int]
    $workingEndAt: Time
    $workingStartAt: Time
    $nativeLanguages: [AuthAccountOrganizationJobPositionNativeLanguagesChoices]
    $languages: [AuthAccountOrganizationJobPositionLanguagesChoices]
    $degrees: [AuthAccountOrganizationJobPositionDegreesChoices]
    $daysOff: [AuthAccountOrganizationJobPositionDaysOffChoices]
    $cities: [ID]!
    $hiringInCanada: Boolean
  ) {
    account {
      organization {
        createJobPosition(
          input: {
            organization: $organization
            salaryRange: $salaryRange
            contractType: $contractType
            ageRange: $ageRange
            benefits: $benefits
            description: $description
            employerQuestions: $employerQuestions
            fields: $fields
            locationType: $locationType
            otherBenefits: $otherBenefits
            paymentTerm: $paymentTerm
            performanceExpectation: $performanceExpectation
            requiredDocuments: $requiredDocuments
            skills: $skills
            startAt: $startAt
            title: $title
            vaccancy: $vaccancy
            validityDays: $validityDays
            workExperienceYearsRange: $workExperienceYearsRange
            workingEndAt: $workingEndAt
            workingStartAt: $workingStartAt
            nativeLanguages: $nativeLanguages
            languages: $languages
            jobRestrictions: $jobRestrictions
            degrees: $degrees
            daysOff: $daysOff
            cities: $cities
            hiringInCanada: $hiringInCanada
          }
        ) {
          organizationJobPosition {
            id
          }
        }
      }
    }
  }
`;
export type CreateJobPositionMutationFn = Apollo.MutationFunction<
  CreateJobPositionMutation,
  CreateJobPositionMutationVariables
>;

/**
 * __useCreateJobPositionMutation__
 *
 * To run a mutation, you first call `useCreateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobPositionMutation, { data, loading, error }] = useCreateJobPositionMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *      employerQuestions: // value for 'employerQuestions'
 *      benefits: // value for 'benefits'
 *      salaryRange: // value for 'salaryRange'
 *      ageRange: // value for 'ageRange'
 *      contractType: // value for 'contractType'
 *      description: // value for 'description'
 *      fields: // value for 'fields'
 *      jobRestrictions: // value for 'jobRestrictions'
 *      locationType: // value for 'locationType'
 *      otherBenefits: // value for 'otherBenefits'
 *      paymentTerm: // value for 'paymentTerm'
 *      performanceExpectation: // value for 'performanceExpectation'
 *      requiredDocuments: // value for 'requiredDocuments'
 *      skills: // value for 'skills'
 *      startAt: // value for 'startAt'
 *      title: // value for 'title'
 *      vaccancy: // value for 'vaccancy'
 *      validityDays: // value for 'validityDays'
 *      workExperienceYearsRange: // value for 'workExperienceYearsRange'
 *      workingEndAt: // value for 'workingEndAt'
 *      workingStartAt: // value for 'workingStartAt'
 *      nativeLanguages: // value for 'nativeLanguages'
 *      languages: // value for 'languages'
 *      degrees: // value for 'degrees'
 *      daysOff: // value for 'daysOff'
 *      cities: // value for 'cities'
 *      hiringInCanada: // value for 'hiringInCanada'
 *   },
 * });
 */
export function useCreateJobPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateJobPositionMutation, CreateJobPositionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateJobPositionMutation, CreateJobPositionMutationVariables>(
    CreateJobPositionDocument,
    options,
  );
}
export type CreateJobPositionMutationHookResult = ReturnType<typeof useCreateJobPositionMutation>;
export type CreateJobPositionMutationResult = Apollo.MutationResult<CreateJobPositionMutation>;
export type CreateJobPositionMutationOptions = Apollo.BaseMutationOptions<
  CreateJobPositionMutation,
  CreateJobPositionMutationVariables
>;
export const CreateJobPositionFromFileDocument = gql`
  mutation CreateJobPositionFromFile($file: Upload!, $organizationId: ID!) {
    account {
      organization {
        createJobPositionFromFile(file: $file, organizationId: $organizationId) {
          jobPosition {
            workingStartAt
            workingEndAt
            id
            workExperienceYearsRange
            validityDate
            vaccancy
            title
            startAt
            skills {
              id
              title
            }
            salaryRange
            requiredDocuments
            ageRange
            benefits {
              id
            }
            cities {
              edges {
                node {
                  id
                }
              }
            }
            contractType
            daysOff
            degrees
            description
            employerQuestions
            fields {
              name
            }
            languages
            locationType
            nativeLanguages
            otherBenefits
            paymentTerm
            performanceExpectation
          }
        }
      }
    }
  }
`;
export type CreateJobPositionFromFileMutationFn = Apollo.MutationFunction<
  CreateJobPositionFromFileMutation,
  CreateJobPositionFromFileMutationVariables
>;

/**
 * __useCreateJobPositionFromFileMutation__
 *
 * To run a mutation, you first call `useCreateJobPositionFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobPositionFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobPositionFromFileMutation, { data, loading, error }] = useCreateJobPositionFromFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateJobPositionFromFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobPositionFromFileMutation,
    CreateJobPositionFromFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateJobPositionFromFileMutation, CreateJobPositionFromFileMutationVariables>(
    CreateJobPositionFromFileDocument,
    options,
  );
}
export type CreateJobPositionFromFileMutationHookResult = ReturnType<typeof useCreateJobPositionFromFileMutation>;
export type CreateJobPositionFromFileMutationResult = Apollo.MutationResult<CreateJobPositionFromFileMutation>;
export type CreateJobPositionFromFileMutationOptions = Apollo.BaseMutationOptions<
  CreateJobPositionFromFileMutation,
  CreateJobPositionFromFileMutationVariables
>;
export const SetJobPositionCalendarSlotDocument = gql`
  mutation setJobPositionCalendarSlot($jobPositionId: ID!, $slots: [DateTimeRangeScalar]!) {
    account {
      organization {
        setJobPositionInterviewSlot(jobPositionId: $jobPositionId, slots: $slots) {
          overlappingInterviews {
            id
            slot {
              datetime
              id
              isAvailable
            }
            event {
              attendees {
                firstName
                id
                lastName
              }
              datetime
              meetUrl
              status
            }
          }
        }
      }
    }
  }
`;
export type SetJobPositionCalendarSlotMutationFn = Apollo.MutationFunction<
  SetJobPositionCalendarSlotMutation,
  SetJobPositionCalendarSlotMutationVariables
>;

/**
 * __useSetJobPositionCalendarSlotMutation__
 *
 * To run a mutation, you first call `useSetJobPositionCalendarSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJobPositionCalendarSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJobPositionCalendarSlotMutation, { data, loading, error }] = useSetJobPositionCalendarSlotMutation({
 *   variables: {
 *      jobPositionId: // value for 'jobPositionId'
 *      slots: // value for 'slots'
 *   },
 * });
 */
export function useSetJobPositionCalendarSlotMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetJobPositionCalendarSlotMutation,
    SetJobPositionCalendarSlotMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetJobPositionCalendarSlotMutation, SetJobPositionCalendarSlotMutationVariables>(
    SetJobPositionCalendarSlotDocument,
    options,
  );
}
export type SetJobPositionCalendarSlotMutationHookResult = ReturnType<typeof useSetJobPositionCalendarSlotMutation>;
export type SetJobPositionCalendarSlotMutationResult = Apollo.MutationResult<SetJobPositionCalendarSlotMutation>;
export type SetJobPositionCalendarSlotMutationOptions = Apollo.BaseMutationOptions<
  SetJobPositionCalendarSlotMutation,
  SetJobPositionCalendarSlotMutationVariables
>;
export const SetVerificationMethodDocument = gql`
  mutation SetVerificationMethod(
    $dnstxtrecordmethod: String
    $communicateorganizationmethod: CommunicateOrganizationMethodInput
    $uploadcompanycertificatemethod: UploadCompanyCertificateMethodInput
    $uploadfiletowebsitemethod: String
    $id: NotEmptyID!
  ) {
    account {
      organization {
        setVerificationMethod(
          id: $id
          input: {
            dnstxtrecordmethod: $dnstxtrecordmethod
            communicateorganizationmethod: $communicateorganizationmethod
            uploadcompanycertificatemethod: $uploadcompanycertificatemethod
            uploadfiletowebsitemethod: $uploadfiletowebsitemethod
          }
        ) {
          success
          output
        }
      }
    }
  }
`;
export type SetVerificationMethodMutationFn = Apollo.MutationFunction<
  SetVerificationMethodMutation,
  SetVerificationMethodMutationVariables
>;

/**
 * __useSetVerificationMethodMutation__
 *
 * To run a mutation, you first call `useSetVerificationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVerificationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVerificationMethodMutation, { data, loading, error }] = useSetVerificationMethodMutation({
 *   variables: {
 *      dnstxtrecordmethod: // value for 'dnstxtrecordmethod'
 *      communicateorganizationmethod: // value for 'communicateorganizationmethod'
 *      uploadcompanycertificatemethod: // value for 'uploadcompanycertificatemethod'
 *      uploadfiletowebsitemethod: // value for 'uploadfiletowebsitemethod'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetVerificationMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<SetVerificationMethodMutation, SetVerificationMethodMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetVerificationMethodMutation, SetVerificationMethodMutationVariables>(
    SetVerificationMethodDocument,
    options,
  );
}
export type SetVerificationMethodMutationHookResult = ReturnType<typeof useSetVerificationMethodMutation>;
export type SetVerificationMethodMutationResult = Apollo.MutationResult<SetVerificationMethodMutation>;
export type SetVerificationMethodMutationOptions = Apollo.BaseMutationOptions<
  SetVerificationMethodMutation,
  SetVerificationMethodMutationVariables
>;
export const UpdateEmployeeCooperationStatusDocument = gql`
  mutation UpdateEmployeeCooperationStatus(
    $status: AuthAccountOrganizationEmployeeCooperationStatusChoices!
    $id: ID!
  ) {
    account {
      organization {
        updateEmployeeCooperationStatus(id: $id, input: { status: $status }) {
          organizationEmployeeCooperation {
            id
          }
        }
      }
    }
  }
`;
export type UpdateEmployeeCooperationStatusMutationFn = Apollo.MutationFunction<
  UpdateEmployeeCooperationStatusMutation,
  UpdateEmployeeCooperationStatusMutationVariables
>;

/**
 * __useUpdateEmployeeCooperationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeCooperationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeCooperationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeCooperationStatusMutation, { data, loading, error }] = useUpdateEmployeeCooperationStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEmployeeCooperationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmployeeCooperationStatusMutation,
    UpdateEmployeeCooperationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmployeeCooperationStatusMutation, UpdateEmployeeCooperationStatusMutationVariables>(
    UpdateEmployeeCooperationStatusDocument,
    options,
  );
}
export type UpdateEmployeeCooperationStatusMutationHookResult = ReturnType<
  typeof useUpdateEmployeeCooperationStatusMutation
>;
export type UpdateEmployeeCooperationStatusMutationResult =
  Apollo.MutationResult<UpdateEmployeeCooperationStatusMutation>;
export type UpdateEmployeeCooperationStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmployeeCooperationStatusMutation,
  UpdateEmployeeCooperationStatusMutationVariables
>;
export const UpdateJobPositionDocument = gql`
  mutation UpdateJobPosition(
    $id: ID!
    $employerQuestions: [String]
    $benefits: [ID]
    $salaryRange: [Int]
    $ageRange: [Int]
    $cities: [ID]
    $contractType: AuthAccountOrganizationJobPositionContractTypeChoices
    $daysOff: [AuthAccountOrganizationJobPositionDaysOffChoices]
    $degrees: [AuthAccountOrganizationJobPositionDegreesChoices]
    $description: String
    $fields: [ID]
    $jobRestrictions: String
    $locationType: AuthAccountOrganizationJobPositionLocationTypeChoices
    $nativeLanguages: [AuthAccountOrganizationJobPositionNativeLanguagesChoices]
    $languages: [AuthAccountOrganizationJobPositionLanguagesChoices]
    $otherBenefits: [String]
    $paymentTerm: AuthAccountOrganizationJobPositionPaymentTermChoices
    $performanceExpectation: String
    $requiredDocuments: [String]
    $skills: [ID]
    $startAt: Date
    $title: String
    $vaccancy: Int
    $validityDays: Int
    $workExperienceYearsRange: [Int]
    $workingEndAt: Time
    $workingStartAt: Time
    $hiringInCanada: Boolean
  ) {
    account {
      organization {
        updateJobPosition(
          id: $id
          input: {
            salaryRange: $salaryRange
            contractType: $contractType
            ageRange: $ageRange
            benefits: $benefits
            cities: $cities
            daysOff: $daysOff
            degrees: $degrees
            description: $description
            employerQuestions: $employerQuestions
            fields: $fields
            jobRestrictions: $jobRestrictions
            languages: $languages
            locationType: $locationType
            nativeLanguages: $nativeLanguages
            otherBenefits: $otherBenefits
            paymentTerm: $paymentTerm
            performanceExpectation: $performanceExpectation
            requiredDocuments: $requiredDocuments
            skills: $skills
            startAt: $startAt
            title: $title
            vaccancy: $vaccancy
            validityDays: $validityDays
            workExperienceYearsRange: $workExperienceYearsRange
            workingEndAt: $workingEndAt
            hiringInCanada: $hiringInCanada
            workingStartAt: $workingStartAt
          }
        ) {
          organizationJobPosition {
            id
          }
        }
      }
    }
  }
`;
export type UpdateJobPositionMutationFn = Apollo.MutationFunction<
  UpdateJobPositionMutation,
  UpdateJobPositionMutationVariables
>;

/**
 * __useUpdateJobPositionMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionMutation, { data, loading, error }] = useUpdateJobPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employerQuestions: // value for 'employerQuestions'
 *      benefits: // value for 'benefits'
 *      salaryRange: // value for 'salaryRange'
 *      ageRange: // value for 'ageRange'
 *      cities: // value for 'cities'
 *      contractType: // value for 'contractType'
 *      daysOff: // value for 'daysOff'
 *      degrees: // value for 'degrees'
 *      description: // value for 'description'
 *      fields: // value for 'fields'
 *      jobRestrictions: // value for 'jobRestrictions'
 *      locationType: // value for 'locationType'
 *      nativeLanguages: // value for 'nativeLanguages'
 *      languages: // value for 'languages'
 *      otherBenefits: // value for 'otherBenefits'
 *      paymentTerm: // value for 'paymentTerm'
 *      performanceExpectation: // value for 'performanceExpectation'
 *      requiredDocuments: // value for 'requiredDocuments'
 *      skills: // value for 'skills'
 *      startAt: // value for 'startAt'
 *      title: // value for 'title'
 *      vaccancy: // value for 'vaccancy'
 *      validityDays: // value for 'validityDays'
 *      workExperienceYearsRange: // value for 'workExperienceYearsRange'
 *      workingEndAt: // value for 'workingEndAt'
 *      workingStartAt: // value for 'workingStartAt'
 *      hiringInCanada: // value for 'hiringInCanada'
 *   },
 * });
 */
export function useUpdateJobPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>(
    UpdateJobPositionDocument,
    options,
  );
}
export type UpdateJobPositionMutationHookResult = ReturnType<typeof useUpdateJobPositionMutation>;
export type UpdateJobPositionMutationResult = Apollo.MutationResult<UpdateJobPositionMutation>;
export type UpdateJobPositionMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobPositionMutation,
  UpdateJobPositionMutationVariables
>;
export const UpdateJobPositionAssignmentStatusDocument = gql`
  mutation UpdateJobPositionAssignmentStatus(
    $id: ID!
    $status: AuthAccountJobPositionAssignmentStatusChoices!
    $startAt: Date
  ) {
    account {
      organization {
        updateJobPositionAssignmentStatus(id: $id, input: { status: $status, startAt: $startAt }) {
          jobPositionAssignment {
            id
          }
        }
      }
    }
  }
`;
export type UpdateJobPositionAssignmentStatusMutationFn = Apollo.MutationFunction<
  UpdateJobPositionAssignmentStatusMutation,
  UpdateJobPositionAssignmentStatusMutationVariables
>;

/**
 * __useUpdateJobPositionAssignmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionAssignmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionAssignmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionAssignmentStatusMutation, { data, loading, error }] = useUpdateJobPositionAssignmentStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      startAt: // value for 'startAt'
 *   },
 * });
 */
export function useUpdateJobPositionAssignmentStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobPositionAssignmentStatusMutation,
    UpdateJobPositionAssignmentStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateJobPositionAssignmentStatusMutation,
    UpdateJobPositionAssignmentStatusMutationVariables
  >(UpdateJobPositionAssignmentStatusDocument, options);
}
export type UpdateJobPositionAssignmentStatusMutationHookResult = ReturnType<
  typeof useUpdateJobPositionAssignmentStatusMutation
>;
export type UpdateJobPositionAssignmentStatusMutationResult =
  Apollo.MutationResult<UpdateJobPositionAssignmentStatusMutation>;
export type UpdateJobPositionAssignmentStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobPositionAssignmentStatusMutation,
  UpdateJobPositionAssignmentStatusMutationVariables
>;
export const UpdateJobPositionStatusDocument = gql`
  mutation UpdateJobPositionStatus($status: AuthAccountOrganizationJobPositionStatusChoices!, $id: ID!) {
    account {
      organization {
        updateJobPositionStatus(id: $id, input: { status: $status }) {
          organizationJobPosition {
            id
          }
        }
      }
    }
  }
`;
export type UpdateJobPositionStatusMutationFn = Apollo.MutationFunction<
  UpdateJobPositionStatusMutation,
  UpdateJobPositionStatusMutationVariables
>;

/**
 * __useUpdateJobPositionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionStatusMutation, { data, loading, error }] = useUpdateJobPositionStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateJobPositionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionStatusMutation, UpdateJobPositionStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateJobPositionStatusMutation, UpdateJobPositionStatusMutationVariables>(
    UpdateJobPositionStatusDocument,
    options,
  );
}
export type UpdateJobPositionStatusMutationHookResult = ReturnType<typeof useUpdateJobPositionStatusMutation>;
export type UpdateJobPositionStatusMutationResult = Apollo.MutationResult<UpdateJobPositionStatusMutation>;
export type UpdateJobPositionStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobPositionStatusMutation,
  UpdateJobPositionStatusMutationVariables
>;
export const UpdateAvatarDocument = gql`
  mutation UpdateAvatar($organizationId: ID!, $logo: ID) {
    account {
      organization {
        update(id: $organizationId, input: { logo: $logo }) {
          organization {
            id
            logo {
              file
            }
          }
        }
      }
    }
  }
`;
export type UpdateAvatarMutationFn = Apollo.MutationFunction<UpdateAvatarMutation, UpdateAvatarMutationVariables>;

/**
 * __useUpdateAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarMutation, { data, loading, error }] = useUpdateAvatarMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useUpdateAvatarMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAvatarMutation, UpdateAvatarMutationVariables>(UpdateAvatarDocument, options);
}
export type UpdateAvatarMutationHookResult = ReturnType<typeof useUpdateAvatarMutation>;
export type UpdateAvatarMutationResult = Apollo.MutationResult<UpdateAvatarMutation>;
export type UpdateAvatarMutationOptions = Apollo.BaseMutationOptions<
  UpdateAvatarMutation,
  UpdateAvatarMutationVariables
>;
export const UpdateProfileDocument = gql`
  mutation UpdateProfile(
    $organizationId: ID!
    $logo: ID
    $nationalNumber: String
    $shortName: String
    $city: ID
    $name: String!
    $about: String
    $industry: ID
    $businessType: AuthAccountOrganizationBusinessTypeChoices
    $type: AuthAccountOrganizationTypeChoices
    $size: AuthAccountOrganizationSizeChoices
    $contacts: [SetOrganizationContactableInput]!
    $establishedAt: Date
  ) {
    account {
      organization {
        setContacts(input: $contacts) {
          contacts {
            id
          }
        }
        update(
          id: $organizationId
          input: {
            about: $about
            name: $name
            shortName: $shortName
            nationalNumber: $nationalNumber
            industry: $industry
            businessType: $businessType
            type: $type
            establishedAt: $establishedAt
            size: $size
            logo: $logo
            city: $city
          }
        ) {
          organization {
            id
            about
            businessType
            establishedAt
            hasFinancialData
            industry {
              id
              title
            }
            logo {
              file
            }
            name
            nationalNumber
            shortName
            size
            status
            type
            contacts {
              id
              type
              value
            }
            email
            city {
              id
            }
          }
        }
      }
    }
  }
`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      logo: // value for 'logo'
 *      nationalNumber: // value for 'nationalNumber'
 *      shortName: // value for 'shortName'
 *      city: // value for 'city'
 *      name: // value for 'name'
 *      about: // value for 'about'
 *      industry: // value for 'industry'
 *      businessType: // value for 'businessType'
 *      type: // value for 'type'
 *      size: // value for 'size'
 *      contacts: // value for 'contacts'
 *      establishedAt: // value for 'establishedAt'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
}
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;
export const VerifyOrganizationDocument = gql`
  mutation VerifyOrganization($organization: NotEmptyID!, $otp: String!) {
    account {
      organization {
        verify(organization: $organization, otp: $otp) {
          success
        }
      }
    }
  }
`;
export type VerifyOrganizationMutationFn = Apollo.MutationFunction<
  VerifyOrganizationMutation,
  VerifyOrganizationMutationVariables
>;

/**
 * __useVerifyOrganizationMutation__
 *
 * To run a mutation, you first call `useVerifyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOrganizationMutation, { data, loading, error }] = useVerifyOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>(
    VerifyOrganizationDocument,
    options,
  );
}
export type VerifyOrganizationMutationHookResult = ReturnType<typeof useVerifyOrganizationMutation>;
export type VerifyOrganizationMutationResult = Apollo.MutationResult<VerifyOrganizationMutation>;
export type VerifyOrganizationMutationOptions = Apollo.BaseMutationOptions<
  VerifyOrganizationMutation,
  VerifyOrganizationMutationVariables
>;
export const AccountPasswordResetDocument = gql`
  mutation AccountPasswordReset(
    $newPassword1: String!
    $newPassword2: String!
    $token: String!
    $gRecaptchaToken: String!
  ) {
    account {
      passwordReset(
        newPassword1: $newPassword1
        newPassword2: $newPassword2
        token: $token
        gRecaptchaToken: $gRecaptchaToken
      ) {
        success
      }
    }
  }
`;
export type AccountPasswordResetMutationFn = Apollo.MutationFunction<
  AccountPasswordResetMutation,
  AccountPasswordResetMutationVariables
>;

/**
 * __useAccountPasswordResetMutation__
 *
 * To run a mutation, you first call `useAccountPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountPasswordResetMutation, { data, loading, error }] = useAccountPasswordResetMutation({
 *   variables: {
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *      token: // value for 'token'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountPasswordResetMutation, AccountPasswordResetMutationVariables>(
    AccountPasswordResetDocument,
    options,
  );
}
export type AccountPasswordResetMutationHookResult = ReturnType<typeof useAccountPasswordResetMutation>;
export type AccountPasswordResetMutationResult = Apollo.MutationResult<AccountPasswordResetMutation>;
export type AccountPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  AccountPasswordResetMutation,
  AccountPasswordResetMutationVariables
>;
export const AccountRefreshTokenDocument = gql`
  mutation AccountRefreshToken($refreshToken: String!) {
    account {
      refreshToken(refreshToken: $refreshToken) {
        token
        success
        payload
      }
    }
  }
`;
export type AccountRefreshTokenMutationFn = Apollo.MutationFunction<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;

/**
 * __useAccountRefreshTokenMutation__
 *
 * To run a mutation, you first call `useAccountRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRefreshTokenMutation, { data, loading, error }] = useAccountRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRefreshTokenMutation, AccountRefreshTokenMutationVariables>(
    AccountRefreshTokenDocument,
    options,
  );
}
export type AccountRefreshTokenMutationHookResult = ReturnType<typeof useAccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationResult = Apollo.MutationResult<AccountRefreshTokenMutation>;
export type AccountRefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRefreshTokenMutation,
  AccountRefreshTokenMutationVariables
>;
export const AccountRegisterDocument = gql`
  mutation AccountRegister(
    $email: String!
    $name: String!
    $website: String!
    $emailCallbackUrl: String!
    $gRecaptchaToken: String!
  ) {
    account {
      organization {
        register(
          email: $email
          name: $name
          website: $website
          emailCallbackUrl: $emailCallbackUrl
          gRecaptchaToken: $gRecaptchaToken
        ) {
          success
        }
      }
    }
  }
`;
export type AccountRegisterMutationFn = Apollo.MutationFunction<
  AccountRegisterMutation,
  AccountRegisterMutationVariables
>;

/**
 * __useAccountRegisterMutation__
 *
 * To run a mutation, you first call `useAccountRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRegisterMutation, { data, loading, error }] = useAccountRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      website: // value for 'website'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRegisterMutation, AccountRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRegisterMutation, AccountRegisterMutationVariables>(
    AccountRegisterDocument,
    options,
  );
}
export type AccountRegisterMutationHookResult = ReturnType<typeof useAccountRegisterMutation>;
export type AccountRegisterMutationResult = Apollo.MutationResult<AccountRegisterMutation>;
export type AccountRegisterMutationOptions = Apollo.BaseMutationOptions<
  AccountRegisterMutation,
  AccountRegisterMutationVariables
>;
export const AccountResendActivationEmailDocument = gql`
  mutation AccountResendActivationEmail($email: String!, $emailCallbackUrl: String!, $gRecaptchaToken: String!) {
    account {
      resendActivationEmail(email: $email, emailCallbackUrl: $emailCallbackUrl, gRecaptchaToken: $gRecaptchaToken) {
        success
      }
    }
  }
`;
export type AccountResendActivationEmailMutationFn = Apollo.MutationFunction<
  AccountResendActivationEmailMutation,
  AccountResendActivationEmailMutationVariables
>;

/**
 * __useAccountResendActivationEmailMutation__
 *
 * To run a mutation, you first call `useAccountResendActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountResendActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountResendActivationEmailMutation, { data, loading, error }] = useAccountResendActivationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountResendActivationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccountResendActivationEmailMutation,
    AccountResendActivationEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountResendActivationEmailMutation, AccountResendActivationEmailMutationVariables>(
    AccountResendActivationEmailDocument,
    options,
  );
}
export type AccountResendActivationEmailMutationHookResult = ReturnType<typeof useAccountResendActivationEmailMutation>;
export type AccountResendActivationEmailMutationResult = Apollo.MutationResult<AccountResendActivationEmailMutation>;
export type AccountResendActivationEmailMutationOptions = Apollo.BaseMutationOptions<
  AccountResendActivationEmailMutation,
  AccountResendActivationEmailMutationVariables
>;
export const AccountRevokeTokenDocument = gql`
  mutation AccountRevokeToken($refreshToken: String!) {
    account {
      revokeToken(refreshToken: $refreshToken) {
        success
      }
    }
  }
`;
export type AccountRevokeTokenMutationFn = Apollo.MutationFunction<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;

/**
 * __useAccountRevokeTokenMutation__
 *
 * To run a mutation, you first call `useAccountRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRevokeTokenMutation, { data, loading, error }] = useAccountRevokeTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useAccountRevokeTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountRevokeTokenMutation, AccountRevokeTokenMutationVariables>(
    AccountRevokeTokenDocument,
    options,
  );
}
export type AccountRevokeTokenMutationHookResult = ReturnType<typeof useAccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationResult = Apollo.MutationResult<AccountRevokeTokenMutation>;
export type AccountRevokeTokenMutationOptions = Apollo.BaseMutationOptions<
  AccountRevokeTokenMutation,
  AccountRevokeTokenMutationVariables
>;
export const AccountSendPasswordResetEmailDocument = gql`
  mutation AccountSendPasswordResetEmail($email: String!, $emailCallbackUrl: String!, $gRecaptchaToken: String!) {
    account {
      sendPasswordResetEmail(email: $email, emailCallbackUrl: $emailCallbackUrl, gRecaptchaToken: $gRecaptchaToken) {
        success
      }
    }
  }
`;
export type AccountSendPasswordResetEmailMutationFn = Apollo.MutationFunction<
  AccountSendPasswordResetEmailMutation,
  AccountSendPasswordResetEmailMutationVariables
>;

/**
 * __useAccountSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useAccountSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSendPasswordResetEmailMutation, { data, loading, error }] = useAccountSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      emailCallbackUrl: // value for 'emailCallbackUrl'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountSendPasswordResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AccountSendPasswordResetEmailMutation,
    AccountSendPasswordResetEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountSendPasswordResetEmailMutation, AccountSendPasswordResetEmailMutationVariables>(
    AccountSendPasswordResetEmailDocument,
    options,
  );
}
export type AccountSendPasswordResetEmailMutationHookResult = ReturnType<
  typeof useAccountSendPasswordResetEmailMutation
>;
export type AccountSendPasswordResetEmailMutationResult = Apollo.MutationResult<AccountSendPasswordResetEmailMutation>;
export type AccountSendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<
  AccountSendPasswordResetEmailMutation,
  AccountSendPasswordResetEmailMutationVariables
>;
export const CreateSupportTicketDocument = gql`
  mutation CreateSupportTicket(
    $title: String!
    $description: String!
    $priority: AuthAccountSupportTicketPriorityChoices!
    $category: ID!
    $contactMethod: AuthAccountSupportTicketContactMethodChoices!
    $contactValue: String!
  ) {
    account {
      supportTicket {
        create(
          input: {
            title: $title
            description: $description
            priority: $priority
            category: $category
            contactMethod: $contactMethod
            contactValue: $contactValue
          }
        ) {
          supportTicket {
            id
            ticketId
          }
        }
      }
    }
  }
`;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<
  CreateSupportTicketMutation,
  CreateSupportTicketMutationVariables
>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      priority: // value for 'priority'
 *      category: // value for 'category'
 *      contactMethod: // value for 'contactMethod'
 *      contactValue: // value for 'contactValue'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(
    CreateSupportTicketDocument,
    options,
  );
}
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<
  CreateSupportTicketMutation,
  CreateSupportTicketMutationVariables
>;
export const AccountTokenAuthDocument = gql`
  mutation AccountTokenAuth($email: String!, $password: String!, $deviceId: String!, $gRecaptchaToken: String!) {
    account {
      tokenAuth(email: $email, password: $password, deviceId: $deviceId, gRecaptchaToken: $gRecaptchaToken) {
        token
        success
        refreshExpiresIn
        payload
        refreshToken
        user {
          organizationMemberships {
            organization {
              id
            }
          }
        }
      }
    }
  }
`;
export type AccountTokenAuthMutationFn = Apollo.MutationFunction<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;

/**
 * __useAccountTokenAuthMutation__
 *
 * To run a mutation, you first call `useAccountTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTokenAuthMutation, { data, loading, error }] = useAccountTokenAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      deviceId: // value for 'deviceId'
 *      gRecaptchaToken: // value for 'gRecaptchaToken'
 *   },
 * });
 */
export function useAccountTokenAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountTokenAuthMutation, AccountTokenAuthMutationVariables>(
    AccountTokenAuthDocument,
    options,
  );
}
export type AccountTokenAuthMutationHookResult = ReturnType<typeof useAccountTokenAuthMutation>;
export type AccountTokenAuthMutationResult = Apollo.MutationResult<AccountTokenAuthMutation>;
export type AccountTokenAuthMutationOptions = Apollo.BaseMutationOptions<
  AccountTokenAuthMutation,
  AccountTokenAuthMutationVariables
>;
export const AccountVerifyDocument = gql`
  mutation AccountVerify($token: String!) {
    account {
      verify(token: $token) {
        success
        token
      }
    }
  }
`;
export type AccountVerifyMutationFn = Apollo.MutationFunction<AccountVerifyMutation, AccountVerifyMutationVariables>;

/**
 * __useAccountVerifyMutation__
 *
 * To run a mutation, you first call `useAccountVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountVerifyMutation, { data, loading, error }] = useAccountVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountVerifyMutation(
  baseOptions?: Apollo.MutationHookOptions<AccountVerifyMutation, AccountVerifyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AccountVerifyMutation, AccountVerifyMutationVariables>(AccountVerifyDocument, options);
}
export type AccountVerifyMutationHookResult = ReturnType<typeof useAccountVerifyMutation>;
export type AccountVerifyMutationResult = Apollo.MutationResult<AccountVerifyMutation>;
export type AccountVerifyMutationOptions = Apollo.BaseMutationOptions<
  AccountVerifyMutation,
  AccountVerifyMutationVariables
>;
export const CommonUploadFileDocument = gql`
  mutation CommonUploadFile($file: Upload!, $type: UploadType!) {
    common {
      uploadFile(file: $file, type: $type) {
        pk
      }
    }
  }
`;
export type CommonUploadFileMutationFn = Apollo.MutationFunction<
  CommonUploadFileMutation,
  CommonUploadFileMutationVariables
>;

/**
 * __useCommonUploadFileMutation__
 *
 * To run a mutation, you first call `useCommonUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommonUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commonUploadFileMutation, { data, loading, error }] = useCommonUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCommonUploadFileMutation(
  baseOptions?: Apollo.MutationHookOptions<CommonUploadFileMutation, CommonUploadFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CommonUploadFileMutation, CommonUploadFileMutationVariables>(
    CommonUploadFileDocument,
    options,
  );
}
export type CommonUploadFileMutationHookResult = ReturnType<typeof useCommonUploadFileMutation>;
export type CommonUploadFileMutationResult = Apollo.MutationResult<CommonUploadFileMutation>;
export type CommonUploadFileMutationOptions = Apollo.BaseMutationOptions<
  CommonUploadFileMutation,
  CommonUploadFileMutationVariables
>;
export const GetEventsDocument = gql`
  query GetEvents {
    calendar {
      calendars {
        events {
          attendees {
            lastName
            id
            firstName
          }
          status
          datetime
          meetUrl
          relatedObject {
            pk
            key
          }
        }
      }
    }
  }
`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
}
export function useGetEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
}
export function useGetEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
}
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsSuspenseQueryHookResult = ReturnType<typeof useGetEventsSuspenseQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetCitiesDocument = gql`
  query GetCities(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $region: ID = ""
    $id: ID
    $country: String = ""
  ) {
    common {
      cities(
        region: $region
        first: $first
        name_Icontains: $name
        after: $after
        before: $before
        id: $id
        country_Code2: $country
      ) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      region: // value for 'region'
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export function useGetCitiesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
}
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetCountriesDocument = gql`
  query GetCountries($first: Int = 10, $after: String = "", $before: String = "", $name: String = "", $id: ID) {
    common {
      countries(first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            name
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetJobBenefitsDocument = gql`
  query GetJobBenefits($after: String = "", $before: String = "", $first: Int = 10, $last: Int = 10) {
    common {
      jobBenefits(after: $after, before: $before, first: $first, last: $last) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobBenefitsQuery__
 *
 * To run a query within a React component, call `useGetJobBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBenefitsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetJobBenefitsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>(GetJobBenefitsDocument, options);
}
export function useGetJobBenefitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>(GetJobBenefitsDocument, options);
}
export function useGetJobBenefitsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>(GetJobBenefitsDocument, options);
}
export type GetJobBenefitsQueryHookResult = ReturnType<typeof useGetJobBenefitsQuery>;
export type GetJobBenefitsLazyQueryHookResult = ReturnType<typeof useGetJobBenefitsLazyQuery>;
export type GetJobBenefitsSuspenseQueryHookResult = ReturnType<typeof useGetJobBenefitsSuspenseQuery>;
export type GetJobBenefitsQueryResult = Apollo.QueryResult<GetJobBenefitsQuery, GetJobBenefitsQueryVariables>;
export const GetSkillsDocument = gql`
  query GetSkills($after: String = "", $before: String = "", $first: Int = 100, $last: Int = 100) {
    common {
      skills(after: $after, before: $before, first: $first, last: $last) {
        edges {
          node {
            id
            title
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetSkillsQuery__
 *
 * To run a query within a React component, call `useGetSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetSkillsQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export function useGetSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export function useGetSkillsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
}
export type GetSkillsQueryHookResult = ReturnType<typeof useGetSkillsQuery>;
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>;
export type GetSkillsSuspenseQueryHookResult = ReturnType<typeof useGetSkillsSuspenseQuery>;
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkillsQuery, GetSkillsQueryVariables>;
export const GetIndustriesDocument = gql`
  query GetIndustries {
    common {
      industries {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useGetIndustriesQuery__
 *
 * To run a query within a React component, call `useGetIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export function useGetIndustriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
}
export type GetIndustriesQueryHookResult = ReturnType<typeof useGetIndustriesQuery>;
export type GetIndustriesLazyQueryHookResult = ReturnType<typeof useGetIndustriesLazyQuery>;
export type GetIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesSuspenseQuery>;
export type GetIndustriesQueryResult = Apollo.QueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export const GetRegionsDocument = gql`
  query GetRegions(
    $first: Int = 10
    $after: String = ""
    $before: String = ""
    $name: String = ""
    $country: ID = ""
    $id: ID
  ) {
    common {
      regions(country: $country, first: $first, name_Icontains: $name, after: $after, before: $before, id: $id) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      name: // value for 'name'
 *      country: // value for 'country'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export function useGetRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export function useGetRegionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
}
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetOrganizationInfoDocument = gql`
  query GetOrganizationInfo {
    me {
      organizationMemberships {
        organization {
          id
          type
          status
          size
          shortName
          nationalNumber
          name
          logo {
            file
          }
          industry {
            id
            title
          }
          hasFinancialData
          establishedAt
          businessType
          about
          contacts {
            id
            type
            value
          }
          email
          city {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(
    GetOrganizationInfoDocument,
    options,
  );
}
export function useGetOrganizationInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(
    GetOrganizationInfoDocument,
    options,
  );
}
export function useGetOrganizationInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(
    GetOrganizationInfoDocument,
    options,
  );
}
export type GetOrganizationInfoQueryHookResult = ReturnType<typeof useGetOrganizationInfoQuery>;
export type GetOrganizationInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationInfoLazyQuery>;
export type GetOrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInfoSuspenseQuery>;
export type GetOrganizationInfoQueryResult = Apollo.QueryResult<
  GetOrganizationInfoQuery,
  GetOrganizationInfoQueryVariables
>;
export const GetSupportTicketCategoryDocument = gql`
  query GetSupportTicketCategory(
    $after: String = ""
    $before: String = ""
    $first: Int = 100
    $last: Int = 100
    $types_Contains: [AuthAccountSupportTicketCategoryTypesChoices]
  ) {
    supportTicketCategory(first: $first, before: $before, after: $after, last: $last, types_Contains: $types_Contains) {
      edges {
        node {
          id
          title
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

/**
 * __useGetSupportTicketCategoryQuery__
 *
 * To run a query within a React component, call `useGetSupportTicketCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportTicketCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportTicketCategoryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      types_Contains: // value for 'types_Contains'
 *   },
 * });
 */
export function useGetSupportTicketCategoryQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export function useGetSupportTicketCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export function useGetSupportTicketCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSupportTicketCategoryQuery, GetSupportTicketCategoryQueryVariables>(
    GetSupportTicketCategoryDocument,
    options,
  );
}
export type GetSupportTicketCategoryQueryHookResult = ReturnType<typeof useGetSupportTicketCategoryQuery>;
export type GetSupportTicketCategoryLazyQueryHookResult = ReturnType<typeof useGetSupportTicketCategoryLazyQuery>;
export type GetSupportTicketCategorySuspenseQueryHookResult = ReturnType<
  typeof useGetSupportTicketCategorySuspenseQuery
>;
export type GetSupportTicketCategoryQueryResult = Apollo.QueryResult<
  GetSupportTicketCategoryQuery,
  GetSupportTicketCategoryQueryVariables
>;
export const GetSupportTicketsDocument = gql`
  query GetSupportTickets {
    me {
      supportTickets {
        category {
          title
          id
        }
        contactMethod
        contactValue
        created
        description
        id
        priority
        status
        ticketId
        title
        modified
      }
    }
  }
`;

/**
 * __useGetSupportTicketsQuery__
 *
 * To run a query within a React component, call `useGetSupportTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportTicketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(GetSupportTicketsDocument, options);
}
export function useGetSupportTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(
    GetSupportTicketsDocument,
    options,
  );
}
export function useGetSupportTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>(
    GetSupportTicketsDocument,
    options,
  );
}
export type GetSupportTicketsQueryHookResult = ReturnType<typeof useGetSupportTicketsQuery>;
export type GetSupportTicketsLazyQueryHookResult = ReturnType<typeof useGetSupportTicketsLazyQuery>;
export type GetSupportTicketsSuspenseQueryHookResult = ReturnType<typeof useGetSupportTicketsSuspenseQuery>;
export type GetSupportTicketsQueryResult = Apollo.QueryResult<GetSupportTicketsQuery, GetSupportTicketsQueryVariables>;
export const GetCooperationsPlatformMessagesDocument = gql`
  query GetCooperationsPlatformMessages($id: NotEmptyID!) {
    organization {
      employee {
        get(id: $id) {
          cooperations {
            platformMessages {
              edges {
                node {
                  title
                  text
                  source
                  readAt
                  created
                  id
                  attachments {
                    id
                    file {
                      file
                    }
                    text
                    courseResult {
                      status
                      course {
                        name
                        logo
                      }
                    }
                    course {
                      name
                      logo
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCooperationsPlatformMessagesQuery__
 *
 * To run a query within a React component, call `useGetCooperationsPlatformMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCooperationsPlatformMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCooperationsPlatformMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCooperationsPlatformMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCooperationsPlatformMessagesQuery,
    GetCooperationsPlatformMessagesQueryVariables
  > &
    ({ variables: GetCooperationsPlatformMessagesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCooperationsPlatformMessagesQuery, GetCooperationsPlatformMessagesQueryVariables>(
    GetCooperationsPlatformMessagesDocument,
    options,
  );
}
export function useGetCooperationsPlatformMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCooperationsPlatformMessagesQuery,
    GetCooperationsPlatformMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCooperationsPlatformMessagesQuery, GetCooperationsPlatformMessagesQueryVariables>(
    GetCooperationsPlatformMessagesDocument,
    options,
  );
}
export function useGetCooperationsPlatformMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCooperationsPlatformMessagesQuery,
        GetCooperationsPlatformMessagesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCooperationsPlatformMessagesQuery, GetCooperationsPlatformMessagesQueryVariables>(
    GetCooperationsPlatformMessagesDocument,
    options,
  );
}
export type GetCooperationsPlatformMessagesQueryHookResult = ReturnType<typeof useGetCooperationsPlatformMessagesQuery>;
export type GetCooperationsPlatformMessagesLazyQueryHookResult = ReturnType<
  typeof useGetCooperationsPlatformMessagesLazyQuery
>;
export type GetCooperationsPlatformMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetCooperationsPlatformMessagesSuspenseQuery
>;
export type GetCooperationsPlatformMessagesQueryResult = Apollo.QueryResult<
  GetCooperationsPlatformMessagesQuery,
  GetCooperationsPlatformMessagesQueryVariables
>;
export const GetEmployeeByIdDocument = gql`
  query GetEmployeeById($id: NotEmptyID!) {
    organization {
      employee {
        get(id: $id) {
          id
          employee {
            email
            firstName
            lastName
            profile {
              contacts {
                id
                type
                value
              }
              score
              avatar {
                file
              }
              birthDate
              city {
                name
                region {
                  name
                }
                country {
                  name
                }
              }
              gender
            }
            certificateandlicenses {
              certifier
              expiredAt
              id
              issuedAt
              status
              title
              certificateandlicenseofflineverificationmethod {
                certificateFile {
                  file
                }
              }
              certificateandlicenseonlineverificationmethod {
                certificateLink
              }
            }
            cv {
              file
            }
            educations {
              city {
                id
                country {
                  name
                }
              }
              degree
              end
              field {
                name
              }
              start
              status
              university {
                name
              }
              communicationmethod {
                degreeFile {
                  file
                }
              }
              ieemethod {
                educationEvaluationDocument {
                  file
                }
              }
            }
            workexperiences {
              city {
                name
                id
              }
              end
              grade
              id
              jobTitle
              organization
              start
              status
              employerlettermethod {
                employerLetter {
                  file
                }
              }
              paystubsmethod {
                paystubs {
                  file
                }
              }
            }
            languagecertificates {
              expiredAt
              id
              issuedAt
              language
              status
              test {
                title
              }
              onlinemethod {
                certificateLink
              }
              offlinemethod {
                certificateFile {
                  file
                }
              }
            }
            resume {
              file {
                file
              }
            }
          }
          cooperations {
            id
            endAt
            createdAt
            startAt
            status
            jobPosition {
              title
              locationType
              contractType
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeByIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables> &
    ({ variables: GetEmployeeByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
}
export function useGetEmployeeByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
}
export function useGetEmployeeByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
}
export type GetEmployeeByIdQueryHookResult = ReturnType<typeof useGetEmployeeByIdQuery>;
export type GetEmployeeByIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeByIdLazyQuery>;
export type GetEmployeeByIdSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeByIdSuspenseQuery>;
export type GetEmployeeByIdQueryResult = Apollo.QueryResult<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>;
export const GetEmployeeCoursesDocument = gql`
  query GetEmployeeCourses($id: NotEmptyID!, $after: String, $before: String, $first: Int, $last: Int) {
    organization {
      employee {
        get(id: $id) {
          employee {
            courses(after: $after, before: $before, first: $first, last: $last) {
              edges {
                node {
                  description
                  externalId
                  id
                  logo
                  name
                  results {
                    edges {
                      node {
                        status
                      }
                    }
                  }
                  industries {
                    edges {
                      node {
                        id
                        title
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeCoursesQuery__
 *
 * To run a query within a React component, call `useGetEmployeeCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeCoursesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetEmployeeCoursesQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables> &
    ({ variables: GetEmployeeCoursesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables>(
    GetEmployeeCoursesDocument,
    options,
  );
}
export function useGetEmployeeCoursesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables>(
    GetEmployeeCoursesDocument,
    options,
  );
}
export function useGetEmployeeCoursesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeCoursesQuery, GetEmployeeCoursesQueryVariables>(
    GetEmployeeCoursesDocument,
    options,
  );
}
export type GetEmployeeCoursesQueryHookResult = ReturnType<typeof useGetEmployeeCoursesQuery>;
export type GetEmployeeCoursesLazyQueryHookResult = ReturnType<typeof useGetEmployeeCoursesLazyQuery>;
export type GetEmployeeCoursesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeCoursesSuspenseQuery>;
export type GetEmployeeCoursesQueryResult = Apollo.QueryResult<
  GetEmployeeCoursesQuery,
  GetEmployeeCoursesQueryVariables
>;
export const GetEmployeeJobAssessmentsDocument = gql`
  query GetEmployeeJobAssessments($id: NotEmptyID!) {
    organization {
      employee {
        get(id: $id) {
          employee {
            assessments {
              title
              status
              skill {
                description
                title
              }
              description
              id
              results {
                evaluation {
                  score
                  userFeedback
                  negativePoints
                  positivePoints
                  scoreReasoning
                  scoreValue
                }
                question {
                  text
                }
              }
              remainingQuestions
              totalEstimatedTime
              totalQuestions
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeJobAssessmentsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeJobAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeJobAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeJobAssessmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeJobAssessmentsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables> &
    ({ variables: GetEmployeeJobAssessmentsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables>(
    GetEmployeeJobAssessmentsDocument,
    options,
  );
}
export function useGetEmployeeJobAssessmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables>(
    GetEmployeeJobAssessmentsDocument,
    options,
  );
}
export function useGetEmployeeJobAssessmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeeJobAssessmentsQuery, GetEmployeeJobAssessmentsQueryVariables>(
    GetEmployeeJobAssessmentsDocument,
    options,
  );
}
export type GetEmployeeJobAssessmentsQueryHookResult = ReturnType<typeof useGetEmployeeJobAssessmentsQuery>;
export type GetEmployeeJobAssessmentsLazyQueryHookResult = ReturnType<typeof useGetEmployeeJobAssessmentsLazyQuery>;
export type GetEmployeeJobAssessmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetEmployeeJobAssessmentsSuspenseQuery
>;
export type GetEmployeeJobAssessmentsQueryResult = Apollo.QueryResult<
  GetEmployeeJobAssessmentsQuery,
  GetEmployeeJobAssessmentsQueryVariables
>;
export const GetEmployeesDocument = gql`
  query GetEmployees(
    $endDate: Date
    $startDate: Date
    $jobPosition: ID
    $fullName: String
    $hiringStatus: AuthAccountOrganizationEmployeeCooperationStatusChoices
    $organization: ID
    $offset: Int = 0
    $first: Int = 10
  ) {
    organization {
      employee {
        list(
          cooperationStartAtGte: $startDate
          cooperationStartAtLte: $endDate
          fullName: $fullName
          cooperations_Status: $hiringStatus
          organization: $organization
          user_JobPositionAssignments_JobPosition: $jobPosition
          offset: $offset
          first: $first
        ) {
          edges {
            node {
              id
              employee {
                email
                firstName
                lastName
                profile {
                  contacts {
                    id
                    type
                    value
                  }
                  score
                  avatar {
                    file
                  }
                }
              }
              cooperations {
                id
                status
                endAt
                createdAt
                startAt
                jobPosition {
                  title
                  locationType
                }
              }
            }
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      jobPosition: // value for 'jobPosition'
 *      fullName: // value for 'fullName'
 *      hiringStatus: // value for 'hiringStatus'
 *      organization: // value for 'organization'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEmployeesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
}
export function useGetEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
}
export function useGetEmployeesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
}
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetJobPositionAssignmentDocument = gql`
  query GetJobPositionAssignment($id: NotEmptyID!) {
    organization {
      jobPositionAssignment(id: $id) {
        statusHistories {
          createdAt
          status
          interview {
            id
            slot {
              datetime
              isAvailable
              id
            }
          }
        }
        createdAt
        id
        interviews {
          id
          slot {
            datetime
            isAvailable
            id
          }
          event {
            attendees {
              firstName
              id
              lastName
            }
            datetime
            meetUrl
            relatedObject {
              key
              pk
            }
            status
          }
        }
        jobSeeker {
          ... on JobSeekerType {
            __typename
            workexperiences {
              city {
                name
                id
              }
              end
              grade
              id
              jobTitle
              organization
              start
              status
              employerlettermethod {
                employerLetter {
                  file
                }
              }
              paystubsmethod {
                paystubs {
                  file
                }
              }
            }
            certificateandlicenses {
              certifier
              expiredAt
              id
              issuedAt
              status
              title
              certificateandlicenseofflineverificationmethod {
                certificateFile {
                  file
                }
              }
              certificateandlicenseonlineverificationmethod {
                certificateLink
              }
            }
            languagecertificates {
              expiredAt
              id
              issuedAt
              language
              status
              test {
                title
              }
              onlinemethod {
                certificateLink
              }
              offlinemethod {
                certificateFile {
                  file
                }
              }
            }
            cv {
              file
              modified
              aboutMe
            }
            educations {
              city {
                id
                country {
                  name
                }
              }
              degree
              end
              field {
                name
              }
              start
              status
              university {
                name
              }
              communicationmethod {
                degreeFile {
                  file
                }
              }
              ieemethod {
                educationEvaluationDocument {
                  file
                }
              }
            }
            resume {
              file {
                file
              }
            }
            profile {
              avatar {
                file
              }
              contacts {
                value
                type
                id
              }
              fullBodyImage {
                file
              }
              score
              city {
                name
              }
            }
            firstName
            lastName
            email
          }
          ... on JobSeekerPrimitiveType {
            __typename
            firstName
            lastName
            profile {
              avatar {
                file
              }
              score
            }
          }
        }
        status
        hasActiveCooperationInOtherOrganizations
        jobPosition {
          id
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionAssignmentQuery__
 *
 * To run a query within a React component, call `useGetJobPositionAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPositionAssignmentQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables> &
    ({ variables: GetJobPositionAssignmentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables>(
    GetJobPositionAssignmentDocument,
    options,
  );
}
export function useGetJobPositionAssignmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables>(
    GetJobPositionAssignmentDocument,
    options,
  );
}
export function useGetJobPositionAssignmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionAssignmentQuery, GetJobPositionAssignmentQueryVariables>(
    GetJobPositionAssignmentDocument,
    options,
  );
}
export type GetJobPositionAssignmentQueryHookResult = ReturnType<typeof useGetJobPositionAssignmentQuery>;
export type GetJobPositionAssignmentLazyQueryHookResult = ReturnType<typeof useGetJobPositionAssignmentLazyQuery>;
export type GetJobPositionAssignmentSuspenseQueryHookResult = ReturnType<
  typeof useGetJobPositionAssignmentSuspenseQuery
>;
export type GetJobPositionAssignmentQueryResult = Apollo.QueryResult<
  GetJobPositionAssignmentQuery,
  GetJobPositionAssignmentQueryVariables
>;
export const GetJobPositionByIdDocument = gql`
  query GetJobPositionById($id: NotEmptyID!) {
    organization {
      jobPosition {
        get(id: $id) {
          isEditable
          ageRange
          benefits {
            id
            name
          }
          contractType
          daysOff
          degrees
          description
          employerQuestions
          fields {
            id
            name
          }
          id
          jobRestrictions
          languages
          locationType
          nativeLanguages
          otherBenefits
          paymentTerm
          performanceExpectation
          requiredDocuments
          salaryRange
          skills {
            id
            title
          }
          startAt
          status
          title
          vaccancy
          validityDate
          validityDays
          workExperienceYearsRange
          workingEndAt
          workingStartAt
          cities {
            edges {
              node {
                name
                id
                country {
                  id
                  name
                }
                region {
                  id
                  name
                }
              }
            }
          }
          hiringInCanada
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionByIdQuery__
 *
 * To run a query within a React component, call `useGetJobPositionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPositionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables> &
    ({ variables: GetJobPositionByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables>(
    GetJobPositionByIdDocument,
    options,
  );
}
export function useGetJobPositionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables>(
    GetJobPositionByIdDocument,
    options,
  );
}
export function useGetJobPositionByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionByIdQuery, GetJobPositionByIdQueryVariables>(
    GetJobPositionByIdDocument,
    options,
  );
}
export type GetJobPositionByIdQueryHookResult = ReturnType<typeof useGetJobPositionByIdQuery>;
export type GetJobPositionByIdLazyQueryHookResult = ReturnType<typeof useGetJobPositionByIdLazyQuery>;
export type GetJobPositionByIdSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionByIdSuspenseQuery>;
export type GetJobPositionByIdQueryResult = Apollo.QueryResult<
  GetJobPositionByIdQuery,
  GetJobPositionByIdQueryVariables
>;
export const GetJobPositionInterviewDocument = gql`
  query GetJobPositionInterview($id: NotEmptyID!) {
    organization {
      jobPositionInterview(id: $id) {
        id
        jobPosition {
          id
          title
          status
          paymentTerm
          locationType
          startAt
          vaccancy
          validityDays
          workExperienceYearsRange
          assignments {
            edges {
              node {
                createdAt
              }
            }
          }
          salaryRange
          skills {
            title
          }
          contractType
          fields {
            name
          }
        }
        jobPositionAssignment {
          id
          jobSeeker {
            ... on JobSeekerType {
              __typename
              firstName
              lastName
              email
              educations {
                degree
                end
                university {
                  name
                }
                field {
                  name
                }
              }
              profile {
                gender
                score
                birthDate
                avatar {
                  file
                }
                contacts {
                  value
                  type
                }
              }
            }
          }
          interviews {
            event {
              meetUrl
              status
              datetime
            }
            slot {
              isAvailable
              datetime
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionInterviewQuery__
 *
 * To run a query within a React component, call `useGetJobPositionInterviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionInterviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionInterviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPositionInterviewQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables> &
    ({ variables: GetJobPositionInterviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables>(
    GetJobPositionInterviewDocument,
    options,
  );
}
export function useGetJobPositionInterviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables>(
    GetJobPositionInterviewDocument,
    options,
  );
}
export function useGetJobPositionInterviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionInterviewQuery, GetJobPositionInterviewQueryVariables>(
    GetJobPositionInterviewDocument,
    options,
  );
}
export type GetJobPositionInterviewQueryHookResult = ReturnType<typeof useGetJobPositionInterviewQuery>;
export type GetJobPositionInterviewLazyQueryHookResult = ReturnType<typeof useGetJobPositionInterviewLazyQuery>;
export type GetJobPositionInterviewSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionInterviewSuspenseQuery>;
export type GetJobPositionInterviewQueryResult = Apollo.QueryResult<
  GetJobPositionInterviewQuery,
  GetJobPositionInterviewQueryVariables
>;
export const GetJobPositionInterviewTimeSlotsDocument = gql`
  query getJobPositionInterviewTimeSlots($id: NotEmptyID!) {
    organization {
      jobPosition {
        get(id: $id) {
          interviewSlots {
            datetime
            id
            isAvailable
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionInterviewTimeSlotsQuery__
 *
 * To run a query within a React component, call `useGetJobPositionInterviewTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionInterviewTimeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionInterviewTimeSlotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPositionInterviewTimeSlotsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobPositionInterviewTimeSlotsQuery,
    GetJobPositionInterviewTimeSlotsQueryVariables
  > &
    ({ variables: GetJobPositionInterviewTimeSlotsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionInterviewTimeSlotsQuery, GetJobPositionInterviewTimeSlotsQueryVariables>(
    GetJobPositionInterviewTimeSlotsDocument,
    options,
  );
}
export function useGetJobPositionInterviewTimeSlotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobPositionInterviewTimeSlotsQuery,
    GetJobPositionInterviewTimeSlotsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionInterviewTimeSlotsQuery, GetJobPositionInterviewTimeSlotsQueryVariables>(
    GetJobPositionInterviewTimeSlotsDocument,
    options,
  );
}
export function useGetJobPositionInterviewTimeSlotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetJobPositionInterviewTimeSlotsQuery,
        GetJobPositionInterviewTimeSlotsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionInterviewTimeSlotsQuery, GetJobPositionInterviewTimeSlotsQueryVariables>(
    GetJobPositionInterviewTimeSlotsDocument,
    options,
  );
}
export type GetJobPositionInterviewTimeSlotsQueryHookResult = ReturnType<
  typeof useGetJobPositionInterviewTimeSlotsQuery
>;
export type GetJobPositionInterviewTimeSlotsLazyQueryHookResult = ReturnType<
  typeof useGetJobPositionInterviewTimeSlotsLazyQuery
>;
export type GetJobPositionInterviewTimeSlotsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobPositionInterviewTimeSlotsSuspenseQuery
>;
export type GetJobPositionInterviewTimeSlotsQueryResult = Apollo.QueryResult<
  GetJobPositionInterviewTimeSlotsQuery,
  GetJobPositionInterviewTimeSlotsQueryVariables
>;
export const GetJobPositionReportDocument = gql`
  query getJobPositionReport($id: NotEmptyID!) {
    organization {
      jobPosition {
        get(id: $id) {
          report {
            assignmentStatusCounts {
              count
              status
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionReportQuery__
 *
 * To run a query within a React component, call `useGetJobPositionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPositionReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobPositionReportQuery, GetJobPositionReportQueryVariables> &
    ({ variables: GetJobPositionReportQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionReportQuery, GetJobPositionReportQueryVariables>(
    GetJobPositionReportDocument,
    options,
  );
}
export function useGetJobPositionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionReportQuery, GetJobPositionReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionReportQuery, GetJobPositionReportQueryVariables>(
    GetJobPositionReportDocument,
    options,
  );
}
export function useGetJobPositionReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobPositionReportQuery, GetJobPositionReportQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionReportQuery, GetJobPositionReportQueryVariables>(
    GetJobPositionReportDocument,
    options,
  );
}
export type GetJobPositionReportQueryHookResult = ReturnType<typeof useGetJobPositionReportQuery>;
export type GetJobPositionReportLazyQueryHookResult = ReturnType<typeof useGetJobPositionReportLazyQuery>;
export type GetJobPositionReportSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionReportSuspenseQuery>;
export type GetJobPositionReportQueryResult = Apollo.QueryResult<
  GetJobPositionReportQuery,
  GetJobPositionReportQueryVariables
>;
export const GetJobPositionsDocument = gql`
  query GetJobPositions(
    $startDate: Date
    $endDate: Date
    $status: AuthAccountOrganizationJobPositionStatusChoices
    $title: String
    $organizationId: ID
    $offset: Int = 0
    $first: Int = 10
  ) {
    organization {
      jobPosition {
        list(
          startAt_Gte: $startDate
          startAt_Lte: $endDate
          status: $status
          title_Icontains: $title
          organization: $organizationId
          offset: $offset
          first: $first
        ) {
          edges {
            node {
              assignments {
                edges {
                  node {
                    id
                    status
                  }
                }
              }
              id
              skills {
                id
                title
              }
              status
              title
              validityDate
            }
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobPositionsQuery__
 *
 * To run a query within a React component, call `useGetJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      title: // value for 'title'
 *      organizationId: // value for 'organizationId'
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetJobPositionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export function useGetJobPositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export function useGetJobPositionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobPositionsQuery, GetJobPositionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobPositionsQuery, GetJobPositionsQueryVariables>(GetJobPositionsDocument, options);
}
export type GetJobPositionsQueryHookResult = ReturnType<typeof useGetJobPositionsQuery>;
export type GetJobPositionsLazyQueryHookResult = ReturnType<typeof useGetJobPositionsLazyQuery>;
export type GetJobPositionsSuspenseQueryHookResult = ReturnType<typeof useGetJobPositionsSuspenseQuery>;
export type GetJobPositionsQueryResult = Apollo.QueryResult<GetJobPositionsQuery, GetJobPositionsQueryVariables>;
export const MyQueryDocument = gql`
  query MyQuery($status: AuthAccountOrganizationJobPositionStatusChoices, $organizationId: ID) {
    organization {
      jobPosition {
        list(organization: $organizationId, status: $status) {
          totalCount
        }
      }
    }
  }
`;

/**
 * __useMyQueryQuery__
 *
 * To run a query within a React component, call `useMyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyQueryQuery({
 *   variables: {
 *      status: // value for 'status'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMyQueryQuery(baseOptions?: Apollo.QueryHookOptions<MyQueryQuery, MyQueryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyQueryQuery, MyQueryQueryVariables>(MyQueryDocument, options);
}
export function useMyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyQueryQuery, MyQueryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyQueryQuery, MyQueryQueryVariables>(MyQueryDocument, options);
}
export function useMyQuerySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyQueryQuery, MyQueryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyQueryQuery, MyQueryQueryVariables>(MyQueryDocument, options);
}
export type MyQueryQueryHookResult = ReturnType<typeof useMyQueryQuery>;
export type MyQueryLazyQueryHookResult = ReturnType<typeof useMyQueryLazyQuery>;
export type MyQuerySuspenseQueryHookResult = ReturnType<typeof useMyQuerySuspenseQuery>;
export type MyQueryQueryResult = Apollo.QueryResult<MyQueryQuery, MyQueryQueryVariables>;
export const GetOrganizationStatisticsDocument = gql`
  query GetOrganizationStatistics($organizationId: ID!, $organizationNotEmptyId: NotEmptyID!) {
    organization {
      jobPositionAssignmentStatistics(organizationId: $organizationNotEmptyId) {
        rejectedCount
        rejectedByJobseekerCount
        notReviewedCount
        interviewScheduledCount
        acceptedCount
        awaitingInterviewDateCount
        awaitingJobseekerApprovalCount
        interviewCanceledCount
        interviewDoneCount
      }
      jobPosition {
        list(organization: $organizationId) {
          totalCount
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationStatisticsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationStatisticsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationNotEmptyId: // value for 'organizationNotEmptyId'
 *   },
 * });
 */
export function useGetOrganizationStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables> &
    ({ variables: GetOrganizationStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables>(
    GetOrganizationStatisticsDocument,
    options,
  );
}
export function useGetOrganizationStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables>(
    GetOrganizationStatisticsDocument,
    options,
  );
}
export function useGetOrganizationStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOrganizationStatisticsQuery, GetOrganizationStatisticsQueryVariables>(
    GetOrganizationStatisticsDocument,
    options,
  );
}
export type GetOrganizationStatisticsQueryHookResult = ReturnType<typeof useGetOrganizationStatisticsQuery>;
export type GetOrganizationStatisticsLazyQueryHookResult = ReturnType<typeof useGetOrganizationStatisticsLazyQuery>;
export type GetOrganizationStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationStatisticsSuspenseQuery
>;
export type GetOrganizationStatisticsQueryResult = Apollo.QueryResult<
  GetOrganizationStatisticsQuery,
  GetOrganizationStatisticsQueryVariables
>;
export const GetResumesDocument = gql`
  query GetResumes(
    $id: NotEmptyID!
    $first: Int = 10
    $offset: Int = 0
    $jobSeekerFullName: String
    $jobSeekerProfileScoreGte: Int
    $createdAtGte: DateTime
    $statusIn: [AuthAccountJobPositionAssignmentStatusChoices]
  ) {
    organization {
      jobPosition {
        get(id: $id) {
          assignments(
            first: $first
            offset: $offset
            jobSeekerFullName: $jobSeekerFullName
            jobSeeker_Profile_Score_Gte: $jobSeekerProfileScoreGte
            createdAt_Gte: $createdAtGte
            status_In: $statusIn
          ) {
            edges {
              node {
                interviews {
                  id
                  slot {
                    datetime
                    id
                    isAvailable
                  }
                }
                createdAt
                id
                statusHistories {
                  createdAt
                  status
                }
                status
                jobSeeker {
                  ... on JobSeekerType {
                    __typename
                    email
                    firstName
                    lastName
                    profile {
                      avatar {
                        file
                      }
                      score
                    }
                    resume {
                      file {
                        file
                      }
                    }
                    workexperiences {
                      organization
                      jobTitle
                    }
                  }
                  ... on JobSeekerPrimitiveType {
                    __typename
                    firstName
                    lastName
                    profile {
                      avatar {
                        file
                      }
                      score
                    }
                  }
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
            totalCount
          }
        }
      }
    }
  }
`;

/**
 * __useGetResumesQuery__
 *
 * To run a query within a React component, call `useGetResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      jobSeekerFullName: // value for 'jobSeekerFullName'
 *      jobSeekerProfileScoreGte: // value for 'jobSeekerProfileScoreGte'
 *      createdAtGte: // value for 'createdAtGte'
 *      statusIn: // value for 'statusIn'
 *   },
 * });
 */
export function useGetResumesQuery(
  baseOptions: Apollo.QueryHookOptions<GetResumesQuery, GetResumesQueryVariables> &
    ({ variables: GetResumesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetResumesQuery, GetResumesQueryVariables>(GetResumesDocument, options);
}
export function useGetResumesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetResumesQuery, GetResumesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetResumesQuery, GetResumesQueryVariables>(GetResumesDocument, options);
}
export function useGetResumesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResumesQuery, GetResumesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetResumesQuery, GetResumesQueryVariables>(GetResumesDocument, options);
}
export type GetResumesQueryHookResult = ReturnType<typeof useGetResumesQuery>;
export type GetResumesLazyQueryHookResult = ReturnType<typeof useGetResumesLazyQuery>;
export type GetResumesSuspenseQueryHookResult = ReturnType<typeof useGetResumesSuspenseQuery>;
export type GetResumesQueryResult = Apollo.QueryResult<GetResumesQuery, GetResumesQueryVariables>;
